"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * originator
 * description
 *
 * The version of the OpenAPI document: 2.58.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferRuleReason = exports.MortgageType = exports.MortgageRefinanceType = exports.MortgagePurchaseStatus = exports.MortgagePropertyType = exports.MortgagePropertyStatus = exports.MortgagePropertySearchStatus = exports.MortgageOccupancyType = exports.MortgageLoanType = exports.MlDemandApiFilterPrediction = exports.MedicalExam = exports.LoanPurpose = exports.LifeInsurancePackageType = exports.LeadAttributeTransunion = exports.LeadAttributeString = exports.LeadAttributeNumeric = exports.LeadAttributeBoolean = exports.LeadAttribute = exports.LeadActionType = exports.LeadActionRejectReason = exports.InclusionReason = exports.IncentiveUnit = exports.IncentiveType = exports.IdType = exports.GraduateDegreeType = exports.Gender = exports.FunnelStepResult = exports.FilterPrediction = exports.FederalInsuranceType = exports.EmploymentStatus = exports.EmploymentPayFrequency = exports.EducationLevel = exports.EarningItemType = exports.EarningContextType = exports.EarningBonusType = exports.EarningBonusName = exports.CreditCardIntroOfferType = exports.CompoundingMethod = exports.CompetitionType = exports.CitizenshipStatus = exports.CarrierDecisionType = exports.CardType = exports.CardPurpose = exports.CardBenefits = exports.BestTimeToCall = exports.BankAccountType = exports.AprType = exports.ApiResponseType = exports.AdjustmentType = exports.AccountTierType = void 0;
exports.LifeInsuranceApiFactory = exports.LifeInsuranceApiFp = exports.LifeInsuranceApiAxiosParamCreator = exports.LeadRateTableCountsApi = exports.LeadRateTableCountsApiFactory = exports.LeadRateTableCountsApiFp = exports.LeadRateTableCountsApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.EnrichedOfferClickApi = exports.EnrichedOfferClickApiFactory = exports.EnrichedOfferClickApiFp = exports.EnrichedOfferClickApiAxiosParamCreator = exports.EnrichedDirectOfferClickApi = exports.EnrichedDirectOfferClickApiFactory = exports.EnrichedDirectOfferClickApiFp = exports.EnrichedDirectOfferClickApiAxiosParamCreator = exports.EnrichedAffiliateOfferClickApi = exports.EnrichedAffiliateOfferClickApiFactory = exports.EnrichedAffiliateOfferClickApiFp = exports.EnrichedAffiliateOfferClickApiAxiosParamCreator = exports.DemandApiResponseApi = exports.DemandApiResponseApiFactory = exports.DemandApiResponseApiFp = exports.DemandApiResponseApiAxiosParamCreator = exports.DemandAPIFilterApi = exports.DemandAPIFilterApiFactory = exports.DemandAPIFilterApiFp = exports.DemandAPIFilterApiAxiosParamCreator = exports.DemandAPIApi = exports.DemandAPIApiFactory = exports.DemandAPIApiFp = exports.DemandAPIApiAxiosParamCreator = exports.AddLoanOffersAsyncApi = exports.AddLoanOffersAsyncApiFactory = exports.AddLoanOffersAsyncApiFp = exports.AddLoanOffersAsyncApiAxiosParamCreator = exports.TermUnit = exports.SupplyTemplateProductType = exports.SupplyTemplateApplicationStrategy = exports.State = exports.RefinanceLoanType = exports.ProvidedCreditRating = exports.ProductType = exports.ProductSubType = exports.PreSelectRuleFilterKey = exports.PersonalReferenceRelationType = exports.Order = void 0;
exports.RateTableSnapshotApiAxiosParamCreator = exports.RateTableAuditApi = exports.RateTableAuditApiFactory = exports.RateTableAuditApiFp = exports.RateTableAuditApiAxiosParamCreator = exports.RateTableApi = exports.RateTableApiFactory = exports.RateTableApiFp = exports.RateTableApiAxiosParamCreator = exports.RateFeeDetailURLApi = exports.RateFeeDetailURLApiFactory = exports.RateFeeDetailURLApiFp = exports.RateFeeDetailURLApiAxiosParamCreator = exports.PricingControlApi = exports.PricingControlApiFactory = exports.PricingControlApiFp = exports.PricingControlApiAxiosParamCreator = exports.PreviewOfferApi = exports.PreviewOfferApiFactory = exports.PreviewOfferApiFp = exports.PreviewOfferApiAxiosParamCreator = exports.PreSelectedOfferApi = exports.PreSelectedOfferApiFactory = exports.PreSelectedOfferApiFp = exports.PreSelectedOfferApiAxiosParamCreator = exports.PreSelectRuleApi = exports.PreSelectRuleApiFactory = exports.PreSelectRuleApiFp = exports.PreSelectRuleApiAxiosParamCreator = exports.PayoutCeilingApi = exports.PayoutCeilingApiFactory = exports.PayoutCeilingApiFp = exports.PayoutCeilingApiAxiosParamCreator = exports.OfferRuleDeactivationApi = exports.OfferRuleDeactivationApiFactory = exports.OfferRuleDeactivationApiFp = exports.OfferRuleDeactivationApiAxiosParamCreator = exports.OfferRuleApi = exports.OfferRuleApiFactory = exports.OfferRuleApiFp = exports.OfferRuleApiAxiosParamCreator = exports.OfferApi = exports.OfferApiFactory = exports.OfferApiFp = exports.OfferApiAxiosParamCreator = exports.MockRateTableApi = exports.MockRateTableApiFactory = exports.MockRateTableApiFp = exports.MockRateTableApiAxiosParamCreator = exports.LifeInsuranceApi = void 0;
exports.SupplyTemplateApi = exports.SupplyTemplateApiFactory = exports.SupplyTemplateApiFp = exports.SupplyTemplateApiAxiosParamCreator = exports.SupplyDemandSubAccountRequestsApi = exports.SupplyDemandSubAccountRequestsApiFactory = exports.SupplyDemandSubAccountRequestsApiFp = exports.SupplyDemandSubAccountRequestsApiAxiosParamCreator = exports.StaticOfferDeactivationApi = exports.StaticOfferDeactivationApiFactory = exports.StaticOfferDeactivationApiFp = exports.StaticOfferDeactivationApiAxiosParamCreator = exports.StaticOfferApi = exports.StaticOfferApiFactory = exports.StaticOfferApiFp = exports.StaticOfferApiAxiosParamCreator = exports.SecondLookOffersConfigurationsApi = exports.SecondLookOffersConfigurationsApiFactory = exports.SecondLookOffersConfigurationsApiFp = exports.SecondLookOffersConfigurationsApiAxiosParamCreator = exports.SecondLookConfigurationApi = exports.SecondLookConfigurationApiFactory = exports.SecondLookConfigurationApiFp = exports.SecondLookConfigurationApiAxiosParamCreator = exports.RuleDemandAPIFilterApi = exports.RuleDemandAPIFilterApiFactory = exports.RuleDemandAPIFilterApiFp = exports.RuleDemandAPIFilterApiAxiosParamCreator = exports.RateTableSnapshotApi = exports.RateTableSnapshotApiFactory = exports.RateTableSnapshotApiFp = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AccountTierType = {
    Growth: 'growth',
    Internal: 'internal',
    Legacy: 'legacy',
    Scale: 'scale',
    Starter: 'starter',
    StarterLegacy: 'starter_legacy',
    Trial: 'trial'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AdjustmentType = {
    Credits: 'credits',
    Par: 'par',
    Points: 'points'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ApiResponseType = {
    Approval: 'approval',
    Canceled: 'canceled',
    Error: 'error',
    Exception: 'exception',
    Rejection: 'rejection'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AprType = {
    Variable: 'variable',
    Regular: 'regular',
    Fixed: 'fixed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BankAccountType = {
    Checking: 'checking',
    Savings: 'savings',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BestTimeToCall = {
    Morning: 'morning',
    Afternoon: 'afternoon',
    Evening: 'evening',
    Night: 'night'
};
/**
 * Benefits or benefit categories related to a credit card
 * @export
 * @enum {string}
 */
exports.CardBenefits = {
    NoForeignTransactionFees: 'No Foreign Transaction Fees',
    PurchaseProtection: 'Purchase Protection',
    ReturnProtection: 'Return Protection',
    PriceProtection: 'Price Protection',
    FraudProtection: 'Fraud Protection',
    ExtendedWarranty: 'Extended Warranty',
    TravelAccidentInsurance: 'Travel Accident Insurance',
    TripInterruptionInsurance: 'Trip Interruption Insurance',
    CarRentalInsurance: 'Car Rental Insurance',
    BaggageInsurance: 'Baggage Insurance',
    BaggageDelayInsurance: 'Baggage Delay Insurance',
    HotelBurglaryInsurance: 'Hotel Burglary Insurance',
    TravelEmergencyAssistance: 'Travel & Emergency Assistance',
    RoadsideAssistance: 'Roadside Assistance',
    ConciergeService: 'Concierge Service',
    LoungeAccess: 'Lounge Access',
    IdentityTheftAssistance: 'Identity Theft Assistance',
    InFlightSavings: 'In-Flight Savings',
    FreeCheckedBag: 'Free Checked Bag',
    PriorityBoarding: 'Priority Boarding',
    NoBlackoutDates: 'No Blackout Dates',
    FreeCompanionTicket: 'Free Companion Ticket',
    DiscountCompanionTicket: 'Discount Companion Ticket',
    GlobalEntryOrTsaPreCheck: 'Global Entry or TSA PreCheck',
    PrivateJetPerks: 'Private Jet Perks',
    LoungeAccessDiscount: 'Lounge Access Discount',
    _247CardholderSupport: '24/7 Cardholder Support',
    AuthorizedUser: 'Authorized User',
    EntertainmentAccess: 'Entertainment Access',
    AirlineFeeCredit: 'Airline Fee Credit',
    LateFeePass: 'Late Fee Pass',
    CreditScoreReporting: 'Credit Score Reporting',
    NoFlightChangeFees: 'No Flight Change Fees',
    _247AccountMonitoring: '24/7 Account Monitoring',
    AmexOffers: 'Amex Offers',
    VisaSignatureOffers: 'Visa Signature Offers',
    MasterCardOffers: 'MasterCard Offers',
    FreeHotelStay: 'Free Hotel Stay',
    ExtendedHotelStay: 'Extended Hotel Stay',
    DiningConcierge: 'Dining Concierge',
    _2LoungePasses: '2 Lounge Passes',
    HiltonHonorsSilverMembership: 'Hilton Honors Silver Membership',
    HiltonHonorsGoldMembership: 'Hilton Honors Gold Membership',
    WorldOfHyattDiscoveristStatus: 'World of Hyatt Discoverist Status',
    SpgGoldMembership: 'SPG Gold Membership',
    MarriottRewardsSilverStatus: 'Marriott Rewards Silver Status',
    HertzPresidentsCircleEliteStatus: 'Hertz Presidents Circle Elite Status',
    _2FreeCheckedBags: '2 Free Checked Bags',
    AutoDiscounts: 'Auto Discounts',
    InCirclePartnership: 'InCircle Partnership',
    ShopRunner: 'ShopRunner',
    WiFiAccess: 'WiFi Access',
    ShopSafe: 'ShopSafe',
    BoAPreferredRewards: 'BoA Preferred Rewards',
    MasterCardFuelRewardsNetwork: 'MasterCard Fuel Rewards Network',
    MissedEventTicketProtection: 'Missed Event Ticket Protection',
    AccountFreezing: 'Account Freezing',
    CellPhoneProtection: 'Cell Phone Protection',
    GpaRewards: 'GPA Rewards',
    InFlightWiFiCredit: 'In-Flight WiFi Credit',
    CitiPrivatePass: 'Citi Private Pass',
    PricelessCities: 'Priceless Cities',
    TheHotelCollection: 'The Hotel Collection',
    ByInvitationOnly: 'By Invitation Only',
    LuxuryHotelCollection: 'Luxury Hotel Collection',
    ExpediaSilverStatus: 'Expedia+ Silver Status',
    ExpediaGoldStatus: 'Expedia+ Gold Status',
    _100AmericanAirlinesDiscount: '$100 American Airlines Discount',
    DisneyParksPerksAndSavings: 'Disney Parks Perks and Savings',
    RitzCarltonGoldEliteStatus: 'Ritz-Carlton Gold Elite Status',
    RitzCarltonClubLevelUpgrade: 'Ritz-Carlton Club Level Upgrade',
    AnnualTravelCredit: 'Annual Travel Credit',
    IhgPlatinumEliteStatus: 'IHG Platinum Elite Status',
    QuickBooksConnect: 'QuickBooks Connect',
    ReceiptMatch: 'ReceiptMatch',
    EmployeeSpendingLimits: 'Employee Spending Limits',
    FxInternationalPayments: 'FX International Payments',
    NoPreSetSpendingLimit: 'No Pre-Set Spending Limit',
    PurchaseFinancing: 'Purchase Financing',
    AmexOpenSavings: 'Amex Open Savings',
    AmazonSpecialFinancing: 'Amazon Special Financing',
    _100RitzCarltonHotelCredit: '$100 Ritz-Carlton Hotel Credit',
    BritishAirwaysCompanionTicket: 'British Airways Companion Ticket',
    MercedesBenzGiftCertificates: 'Mercedes-Benz Gift Certificates',
    MercedesBenzExcessMileageWaiver: 'Mercedes-Benz Excess Mileage Waiver',
    JetBlueAnnualStatementCredit: 'JetBlue Annual Statement Credit',
    _20DiscountOnDeltaFlightsForDeltaPrivateJetMembers: '20% Discount on Delta Flights for Delta Private Jet Members',
    ExpenseReportFeatures: 'Expense Report Features',
    BusinessCellPhoneProtection: 'Business Cell Phone Protection',
    FreeShippingOnMostTargetComOrders: 'Free Shipping on most Target.com orders',
    _30ExtraDaysForReturns: '30 Extra Days for Returns',
    FreeClothingAltertaions: 'Free clothing altertaions',
    PersonalShopping: 'Personal shopping',
    ShopmywaySavings: 'Shopmyway Savings',
    OnlineSubscriptionCredit: 'Online Subscription Credit',
    UberExclusiveAccess: 'Uber Exclusive Access',
    AirlineBenefits: 'Airline Benefits',
    HotelBenefits: 'Hotel Benefits',
    OtherTravelBenefits: 'Other Travel Benefits',
    EmergencyAssistance: 'Emergency Assistance',
    Experiences: 'Experiences',
    ShoppingBenefits: 'Shopping Benefits',
    CardholderBenefits: 'Cardholder Benefits',
    EnhancedSecurity: 'Enhanced Security',
    BusinessBenefits: 'Business Benefits',
    OtherBenefits: 'Other Benefits',
    InFlightDiscounts: 'In-Flight Discounts',
    FeeCoverage: 'Fee Coverage',
    FlightCreditsDiscounts: 'Flight Credits & Discounts',
    HotelMembershipStatus: 'Hotel Membership Status',
    HotelCreditFreeStays: 'Hotel Credit & Free Stays',
    TravelCredit: 'Travel Credit',
    TravelExperiencesPrograms: 'Travel Experiences Programs',
    CarRentalMembershipStatus: 'Car Rental Membership Status',
    ExtraGasRewards: 'Extra Gas Rewards',
    ShoppingProtection: 'Shopping Protection',
    ShoppingDiscounts: 'Shopping Discounts',
    FreeShipping: 'Free Shipping',
    TheBoingoAmericanExpressPreferredPlan: 'The Boingo American Express Preferred Plan',
    AirSpaceLounge: 'AirSpace Lounge',
    UberMonthlyCredit: 'Uber Monthly Credit',
    RideShareBenefits: 'Ride Share Benefits',
    DeltaSkyClub: 'Delta Sky Club',
    AdmiralsClubMembership: 'Admirals Club Membership',
    PriorityPassSelectMembershipPrestige: 'Priority Pass Select Membership (Prestige)',
    PriorityPassSelectMembershipStandardPlus: 'Priority Pass Select Membership (Standard Plus)',
    DailyBreakfast: 'Daily Breakfast',
    EarlyCheckInLateCheckOut: 'Early Check-in & Late Check-out',
    RoomUpgrades: 'Room Upgrades',
    ComplementaryWiFi: 'Complementary WiFi',
    AmexHotelCollectionCredit: 'Amex Hotel Collection Credit',
    TemporaryAccountNumbers: 'Temporary Account Numbers',
    OneTime50DiscountOnCompanionTicket: 'One-Time 50% Discount on Companion Ticket',
    AirlineTravelCredit: 'Airline Travel Credit',
    UnitedClubMembership: 'United Club Membership',
    ChipTechnology: 'Chip Technology',
    EarnMoreMilesForSharingTravelStories: 'Earn More Miles for Sharing Travel Stories',
    MastercardWorldEliteConciergeAndLuxuryTravelBenefits: 'Mastercard World Elite Concierge and Luxury Travel Benefits',
    _20SavingsOnDeltaInFlightPurchases: '20% Savings on Delta In-Flight Purchases',
    _25SavingsOnUnitedInFlightFoodAndDrinkPurchases: '25% Savings on United In-Flight Food and Drink Purchases',
    _100HiltonPropertiesCredit: '$100 Hilton Properties Credit',
    _250HiltonResortCredit: '$250 Hilton Resort Credit',
    HiltonHonorsDiamondMembership: 'Hilton Honors Diamond Membership',
    FreeBirthdayGift: 'Free Birthday Gift',
    _2xPointsDuringYourBirthdayMonth: '2x Points During Your Birthday Month',
    CarRentalVipPerks: 'Car Rental VIP Perks',
    FreeShippingWithThePurchaseOfABra: 'Free shipping with the purchase of a bra',
    MonthlyDiningCredit: 'Monthly Dining Credit',
    AmazonPrimeStudent: 'Amazon Prime Student'
};
/**
 * Purposes or categories related to a credit card
 * @export
 * @enum {string}
 */
exports.CardPurpose = {
    BalanceTransfer: 'balance_transfer',
    CashBack: 'cash_back',
    EarningRewards: 'earning_rewards',
    ImproveCredit: 'improve_credit',
    LowInterest: 'low_interest',
    NewToCredit: 'new_to_credit',
    Student: 'student',
    TravelIncentives: 'travel_incentives'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CardType = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    AmericanExpress: 'american_express',
    Discover: 'discover'
};
/**
 * Carrier decision speed
 * @export
 * @enum {string}
 */
exports.CarrierDecisionType = {
    Instant: 'instant',
    NonInstant: 'non_instant'
};
/**
 * Citizenship status
 * @export
 * @enum {string}
 */
exports.CitizenshipStatus = {
    Citizen: 'citizen',
    PermanentResident: 'permanent_resident',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CompetitionType = {
    Legacy: 'legacy',
    MarketplaceDynamicOfferPreference: 'marketplace_dynamic_offer_preference',
    MarketplaceCompetitionBySubtype: 'marketplace_competition_by_subtype',
    NoCompetition: 'no_competition'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CompoundingMethod = {
    Annually: 'annually',
    Continuous: 'continuous',
    Daily: 'daily',
    Monthly: 'monthly',
    Quarterly: 'quarterly',
    SemiAnnually: 'semiAnnually',
    Simple: 'simple',
    Weekly: 'weekly'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CreditCardIntroOfferType = {
    Miles: 'miles',
    Points: 'points',
    StatementCredit: 'statement_credit'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EarningBonusName = {
    SignUpBonus: 'Sign-Up Bonus',
    AnniversaryBonus: 'Anniversary Bonus',
    AnnualBonus: 'Annual Bonus',
    UsageBonus: 'Usage Bonus'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EarningBonusType = {
    OneTime: 'One Time',
    Recurring: 'Recurring'
};
/**
 * The type of context this is. Basic contexts have no details.
 * @export
 * @enum {string}
 */
exports.EarningContextType = {
    Basic: 'basic',
    Calculation: 'calculation',
    Introductory: 'introductory',
    Rotating: 'rotating',
    Capped: 'capped'
};
/**
 * Refers to the type (and schema) of the item
 * @export
 * @enum {string}
 */
exports.EarningItemType = {
    Category: 'category',
    Merchant: 'merchant',
    Ebp: 'ebp',
    PaymentMethod: 'paymentMethod'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EducationLevel = {
    HighSchool: 'high_school',
    Associate: 'associate',
    Bachelors: 'bachelors',
    Masters: 'masters',
    Doctorate: 'doctorate',
    OtherGradDegree: 'other_grad_degree',
    Certificate: 'certificate',
    DidNotGraduate: 'did_not_graduate',
    StillEnrolled: 'still_enrolled',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmploymentPayFrequency = {
    Weekly: 'weekly',
    Biweekly: 'biweekly',
    TwiceMonthly: 'twice_monthly',
    Monthly: 'monthly'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmploymentStatus = {
    Employed: 'employed',
    EmployedFullTime: 'employed_full_time',
    EmployedPartTime: 'employed_part_time',
    Military: 'military',
    NotEmployed: 'not_employed',
    SelfEmployed: 'self_employed',
    Retired: 'retired',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FederalInsuranceType = {
    Fdic: 'fdic',
    Ncua: 'ncua'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FilterPrediction = {
    Approve: 'approve',
    Reject: 'reject'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FunnelStepResult = {
    Success: 'success',
    Failure: 'failure',
    Inconclusive: 'inconclusive'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Gender = {
    Male: 'male',
    Female: 'female'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GraduateDegreeType = {
    DoctorOfMedicine: 'doctor_of_medicine',
    DoctorOfOsteopathicMedicine: 'doctor_of_osteopathic_medicine',
    DoctorOfOptometry: 'doctor_of_optometry',
    DoctorOfDentalMedicine: 'doctor_of_dental_medicine',
    DentariaeMedicinaeDoctoris: 'dentariae_medicinae_doctoris',
    DoctorOfDentalSurgery: 'doctor_of_dental_surgery',
    DoctorOfVeterinaryMedicine: 'doctor_of_veterinary_medicine',
    DoctorOfPharmacy: 'doctor_of_pharmacy',
    VeterinariaeMedicinaeDoctoris: 'veterinariae_medicinae_doctoris',
    MasterOfArts: 'master_of_arts',
    MasterOfScience: 'master_of_science',
    MasterOfResearch: 'master_of_research',
    MasterOfResearchProject: 'master_of_research_project',
    MasterOfStudies: 'master_of_studies',
    MasterOfBusinessAdministration: 'master_of_business_administration',
    MasterOfLibraryScience: 'master_of_library_science',
    MasterOfPublicAdministration: 'master_of_public_administration',
    MasterOfPublicHealth: 'master_of_public_health',
    MasterOfLaws: 'master_of_laws',
    MasterOfArtsLiberalStudies: 'master_of_arts_liberal_studies',
    MasterOfFineArts: 'master_of_fine_arts',
    MasterOfMusic: 'master_of_music',
    MasterOfEducation: 'master_of_education',
    MasterOfEngineering: 'master_of_engineering',
    MasterOfArchitecture: 'master_of_architecture',
    JurisDoctor: 'juris_doctor',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IdType = {
    DriverLicense: 'driver_license',
    StateId: 'state_id',
    Passport: 'passport'
};
/**
 * Unit of measure for incentives.
 * @export
 * @enum {string}
 */
exports.IncentiveType = {
    CashBack: 'cash_back',
    Other: 'other'
};
/**
 * Unit of measure for incentives.
 * @export
 * @enum {string}
 */
exports.IncentiveUnit = {
    Usd: 'usd',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.InclusionReason = {
    DemandOnboarding: 'demand_onboarding',
    SupplyOnboarding: 'supply_onboarding',
    PoorPerformance: 'poor_performance',
    DemandRequest: 'demand_request',
    SupplyRequest: 'supply_request',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LeadActionRejectReason = {
    LowFico: 'low_fico',
    NoFico: 'no_fico',
    MajorDerogatory: 'major_derogatory',
    UnderwritingDecline: 'underwriting_decline',
    DebtToIncomeRatio: 'debt_to_income_ratio',
    NotInActiveState: 'not_in_active_state',
    IncorrectDataProvided: 'incorrect_data_provided',
    Duplicate: 'duplicate'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LeadActionType = {
    Initialized: 'initialized',
    ApiRejected: 'api_rejected',
    ApiApproved: 'api_approved',
    ApiListing: 'api_listing',
    ClickedReferralLink: 'clicked_referral_link',
    ClickedSpecialOfferLink: 'clicked_special_offer_link',
    SpecialOfferConversion: 'special_offer_conversion',
    Applied: 'applied',
    Rejected: 'rejected',
    Approved: 'approved',
    Listed: 'listed',
    Funded: 'funded',
    NotFunded: 'not_funded',
    ClickedCreditCardOfferLink: 'clicked_credit_card_offer_link',
    ClickedMortgageOfferLink: 'clicked_mortgage_offer_link',
    ClickedSavingsOfferLink: 'clicked_savings_offer_link',
    LenderQualifiedLead: 'lender_qualified_lead'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LeadAttribute = {
    Age: 'age',
    AnnualIncome: 'annual_income',
    BankName: 'bank_name',
    BankRoutingNumber: 'bank_routing_number',
    CitizenshipStatus: 'citizenship_status',
    ClosedWithBalanceBalance: 'closed_with_balance_balance',
    ClosedWithBalancePastDue: 'closed_with_balance_past_due',
    CollectionCount: 'collection_count',
    DaysOnFile: 'days_on_file',
    DebtToIncomeRatio: 'debt_to_income_ratio',
    DirectDeposit: 'direct_deposit',
    EmploymentPayFrequency: 'employment_pay_frequency',
    EducationLevel: 'education_level',
    EmploymentStatus: 'employment_status',
    FicoScore8: 'fico_score_8',
    HasDirectDeposit: 'has_direct_deposit',
    HistoricalNegativeOccurrencesCount: 'historical_negative_occurrences_count',
    InquiryCount: 'inquiry_count',
    InstallmentBalance: 'installment_balance',
    InstallmentPastDue: 'installment_past_due',
    IsFrozen: 'is_frozen',
    LoanPurpose: 'loan_purpose',
    MonthlyGrossIncome: 'monthly_gross_income',
    MonthlyNetIncome: 'monthly_net_income',
    MortgageBalance: 'mortgage_balance',
    MortgagePastDue: 'mortgage_past_due',
    NegativeTradeCount: 'negative_trade_count',
    NonMortgageDebtToIncomeRatio: 'non_mortgage_debt_to_income_ratio',
    OpenBalance: 'open_balance',
    OpenPastDue: 'open_past_due',
    PropertyStatus: 'property_status',
    PublicRecordCode: 'public_record_code',
    RequestedLoanAmount: 'requested_loan_amount',
    RequestToIncomeRatio: 'request_to_income_ratio',
    RevolvingBalance: 'revolving_balance',
    RevolvingPastDue: 'revolving_past_due',
    SelfReportedCreditRating: 'self_reported_credit_rating',
    SelfReportedCreditScore: 'self_reported_credit_score',
    State: 'state',
    TotalBalance: 'total_balance',
    TotalBalanceMinusMortgage: 'total_balance_minus_mortgage',
    TotalNonPastDueBalancesForCreditCards: 'total_non_past_due_balances_for_credit_cards',
    TotalNonPastDueBalancesForPremiumCreditCards: 'total_non_past_due_balances_for_premium_credit_cards',
    TotalNonPastDueBalanceForRevolvingTrades: 'total_non_past_due_balance_for_revolving_trades',
    TotalPastDue: 'total_past_due',
    TotalUnsecuredDebt: 'total_unsecured_debt',
    TradeCount: 'trade_count',
    VantageScore3: 'vantage_score_3',
    Zipcode: 'zipcode',
    At01S: 'AT01S',
    At09S: 'AT09S',
    At21S: 'AT21S',
    At24S: 'AT24S',
    At34B: 'AT34B',
    At36S: 'AT36S',
    Au01S: 'AU01S',
    Au02S: 'AU02S',
    Au03S: 'AU03S',
    Au12S: 'AU12S',
    Au20S: 'AU20S',
    Au51A: 'AU51A',
    Aut106: 'AUT106',
    Aut107: 'AUT107',
    Aut206: 'AUT206',
    Aut207: 'AUT207',
    Aut306: 'AUT306',
    Aut307: 'AUT307',
    Aut406: 'AUT406',
    Aut407: 'AUT407',
    Aut506: 'AUT506',
    Aut507: 'AUT507',
    Bc101S: 'BC101S',
    Bc110S: 'BC110S',
    Bc28S: 'BC28S',
    Bc33S: 'BC33S',
    Bc34S: 'BC34S',
    Bi33S: 'BI33S',
    Bi34S: 'BI34S',
    Bkc54: 'BKC54',
    Br34S: 'BR34S',
    Br57S: 'BR57S',
    Co01S: 'CO01S',
    Co07S: 'CO07S',
    G043S: 'G043S',
    G093S: 'G093S',
    G106S: 'G106S',
    G237S: 'G237S',
    G243B: 'G243B',
    G980S: 'G980S',
    In06S: 'IN06S',
    Pb101S: 'PB101S',
    Pb57S: 'PB57S',
    Re01S: 'RE01S',
    Re101S: 'RE101S',
    Re31S: 'RE31S',
    Re57S: 'RE57S',
    S061S: 'S061S',
    S064A: 'S064A',
    S064B: 'S064B',
    S204A: 'S204A',
    S207A: 'S207A',
    S208S: 'S208S',
    S209A: 'S209A',
    S209S: 'S209S'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LeadAttributeBoolean = {
    DirectDeposit: 'direct_deposit',
    HasDirectDeposit: 'has_direct_deposit',
    IsFrozen: 'is_frozen'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LeadAttributeNumeric = {
    Age: 'age',
    AnnualIncome: 'annual_income',
    ClosedWithBalanceBalance: 'closed_with_balance_balance',
    ClosedWithBalancePastDue: 'closed_with_balance_past_due',
    CollectionCount: 'collection_count',
    DaysOnFile: 'days_on_file',
    DebtToIncomeRatio: 'debt_to_income_ratio',
    FicoScore8: 'fico_score_8',
    HistoricalNegativeOccurrencesCount: 'historical_negative_occurrences_count',
    InquiryCount: 'inquiry_count',
    InstallmentBalance: 'installment_balance',
    InstallmentPastDue: 'installment_past_due',
    MonthlyGrossIncome: 'monthly_gross_income',
    MonthlyNetIncome: 'monthly_net_income',
    MortgageBalance: 'mortgage_balance',
    MortgagePastDue: 'mortgage_past_due',
    NegativeTradeCount: 'negative_trade_count',
    NonMortgageDebtToIncomeRatio: 'non_mortgage_debt_to_income_ratio',
    OpenBalance: 'open_balance',
    OpenPastDue: 'open_past_due',
    RequestedLoanAmount: 'requested_loan_amount',
    RequestToIncomeRatio: 'request_to_income_ratio',
    RevolvingBalance: 'revolving_balance',
    RevolvingPastDue: 'revolving_past_due',
    SelfReportedCreditScore: 'self_reported_credit_score',
    TotalBalance: 'total_balance',
    TotalBalanceMinusMortgage: 'total_balance_minus_mortgage',
    TotalNonPastDueBalancesForCreditCards: 'total_non_past_due_balances_for_credit_cards',
    TotalNonPastDueBalancesForPremiumCreditCards: 'total_non_past_due_balances_for_premium_credit_cards',
    TotalNonPastDueBalanceForRevolvingTrades: 'total_non_past_due_balance_for_revolving_trades',
    TotalPastDue: 'total_past_due',
    TotalUnsecuredDebt: 'total_unsecured_debt',
    TradeCount: 'trade_count',
    VantageScore3: 'vantage_score_3',
    At01S: 'AT01S',
    At09S: 'AT09S',
    At21S: 'AT21S',
    At24S: 'AT24S',
    At34B: 'AT34B',
    At36S: 'AT36S',
    Au01S: 'AU01S',
    Au02S: 'AU02S',
    Au03S: 'AU03S',
    Au12S: 'AU12S',
    Au20S: 'AU20S',
    Au51A: 'AU51A',
    Aut106: 'AUT106',
    Aut107: 'AUT107',
    Aut206: 'AUT206',
    Aut207: 'AUT207',
    Aut306: 'AUT306',
    Aut307: 'AUT307',
    Aut406: 'AUT406',
    Aut407: 'AUT407',
    Aut506: 'AUT506',
    Aut507: 'AUT507',
    Bc101S: 'BC101S',
    Bc110S: 'BC110S',
    Bc28S: 'BC28S',
    Bc33S: 'BC33S',
    Bc34S: 'BC34S',
    Bi33S: 'BI33S',
    Bi34S: 'BI34S',
    Bkc54: 'BKC54',
    Br34S: 'BR34S',
    Br57S: 'BR57S',
    Co01S: 'CO01S',
    Co07S: 'CO07S',
    G043S: 'G043S',
    G093S: 'G093S',
    G106S: 'G106S',
    G237S: 'G237S',
    G243B: 'G243B',
    G980S: 'G980S',
    In06S: 'IN06S',
    Pb101S: 'PB101S',
    Pb57S: 'PB57S',
    Re01S: 'RE01S',
    Re101S: 'RE101S',
    Re31S: 'RE31S',
    Re57S: 'RE57S',
    S061S: 'S061S',
    S064A: 'S064A',
    S064B: 'S064B',
    S204A: 'S204A',
    S207A: 'S207A',
    S208S: 'S208S',
    S209A: 'S209A',
    S209S: 'S209S'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LeadAttributeString = {
    BankName: 'bank_name',
    BankRoutingNumber: 'bank_routing_number',
    CitizenshipStatus: 'citizenship_status',
    EducationLevel: 'education_level',
    EmploymentPayFrequency: 'employment_pay_frequency',
    EmploymentStatus: 'employment_status',
    LoanPurpose: 'loan_purpose',
    PropertyStatus: 'property_status',
    PublicRecordCode: 'public_record_code',
    SelfReportedCreditRating: 'self_reported_credit_rating',
    State: 'state',
    Zipcode: 'zipcode'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LeadAttributeTransunion = {
    ClosedWithBalanceBalance: 'closed_with_balance_balance',
    ClosedWithBalancePastDue: 'closed_with_balance_past_due',
    CollectionCount: 'collection_count',
    DaysOnFile: 'days_on_file',
    DebtToIncomeRatio: 'debt_to_income_ratio',
    FicoScore8: 'fico_score_8',
    HistoricalNegativeOccurrencesCount: 'historical_negative_occurrences_count',
    InquiryCount: 'inquiry_count',
    InstallmentBalance: 'installment_balance',
    InstallmentPastDue: 'installment_past_due',
    IsFrozen: 'is_frozen',
    MortgageBalance: 'mortgage_balance',
    MortgagePastDue: 'mortgage_past_due',
    NegativeTradeCount: 'negative_trade_count',
    NonMortgageDebtToIncomeRatio: 'non_mortgage_debt_to_income_ratio',
    OpenBalance: 'open_balance',
    OpenPastDue: 'open_past_due',
    PublicRecordCode: 'public_record_code',
    RevolvingBalance: 'revolving_balance',
    RevolvingPastDue: 'revolving_past_due',
    TotalBalance: 'total_balance',
    TotalBalanceMinusMortgage: 'total_balance_minus_mortgage',
    TotalNonPastDueBalancesForCreditCards: 'total_non_past_due_balances_for_credit_cards',
    TotalNonPastDueBalancesForPremiumCreditCards: 'total_non_past_due_balances_for_premium_credit_cards',
    TotalNonPastDueBalanceForRevolvingTrades: 'total_non_past_due_balance_for_revolving_trades',
    TotalPastDue: 'total_past_due',
    TradeCount: 'trade_count',
    VantageScore3: 'vantage_score_3',
    At01S: 'AT01S',
    At09S: 'AT09S',
    At21S: 'AT21S',
    At24S: 'AT24S',
    At34B: 'AT34B',
    At36S: 'AT36S',
    Au01S: 'AU01S',
    Au02S: 'AU02S',
    Au03S: 'AU03S',
    Au12S: 'AU12S',
    Au20S: 'AU20S',
    Au51A: 'AU51A',
    Aut106: 'AUT106',
    Aut107: 'AUT107',
    Aut206: 'AUT206',
    Aut207: 'AUT207',
    Aut306: 'AUT306',
    Aut307: 'AUT307',
    Aut406: 'AUT406',
    Aut407: 'AUT407',
    Aut506: 'AUT506',
    Aut507: 'AUT507',
    Bc101S: 'BC101S',
    Bc110S: 'BC110S',
    Bc28S: 'BC28S',
    Bc33S: 'BC33S',
    Bc34S: 'BC34S',
    Bi33S: 'BI33S',
    Bi34S: 'BI34S',
    Bkc54: 'BKC54',
    Br34S: 'BR34S',
    Br57S: 'BR57S',
    Co01S: 'CO01S',
    Co07S: 'CO07S',
    G043S: 'G043S',
    G093S: 'G093S',
    G106S: 'G106S',
    G237S: 'G237S',
    G243B: 'G243B',
    G980S: 'G980S',
    In06S: 'IN06S',
    Pb101S: 'PB101S',
    Pb57S: 'PB57S',
    Re01S: 'RE01S',
    Re101S: 'RE101S',
    Re31S: 'RE31S',
    Re57S: 'RE57S',
    S061S: 'S061S',
    S064A: 'S064A',
    S064B: 'S064B',
    S204A: 'S204A',
    S207A: 'S207A',
    S208S: 'S208S',
    S209A: 'S209A',
    S209S: 'S209S'
};
/**
 * Life insurance package types
 * @export
 * @enum {string}
 */
exports.LifeInsurancePackageType = {
    Basic: 'basic',
    Essential: 'essential',
    Elite: 'elite'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LoanPurpose = {
    Auto: 'auto',
    AutoPurchase: 'auto_purchase',
    AutoRefinance: 'auto_refinance',
    Baby: 'baby',
    Boat: 'boat',
    Business: 'business',
    CarRepair: 'car_repair',
    Cosmetic: 'cosmetic',
    CreditCardRefi: 'credit_card_refi',
    DebtConsolidation: 'debt_consolidation',
    Emergency: 'emergency',
    Engagement: 'engagement',
    Green: 'green',
    HomeImprovement: 'home_improvement',
    HomePurchase: 'home_purchase',
    HomeRefi: 'home_refi',
    HouseholdExpenses: 'household_expenses',
    LargePurchases: 'large_purchases',
    LifeEvent: 'life_event',
    MedicalDental: 'medical_dental',
    Motorcycle: 'motorcycle',
    MovingRelocation: 'moving_relocation',
    Other: 'other',
    Rv: 'rv',
    SpecialOccasion: 'special_occasion',
    StudentLoan: 'student_loan',
    StudentLoanRefi: 'student_loan_refi',
    Taxes: 'taxes',
    Unknown: 'unknown',
    Vacation: 'vacation',
    Wedding: 'wedding'
};
/**
 * Medical exam requirement
 * @export
 * @enum {string}
 */
exports.MedicalExam = {
    NoExamIfQualified: 'no_exam_if_qualified',
    NoExamGuaranteed: 'no_exam_guaranteed',
    ExamRequired: 'exam_required'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MlDemandApiFilterPrediction = {
    Approve: 'approve',
    Reject: 'reject'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgageLoanType = {
    FifteenYearFixed: 'fifteen_year_fixed',
    ThirtyYearFixed: 'thirty_year_fixed',
    FiveOneAdjustable: 'five_one_adjustable',
    SevenOneAdjustable: 'seven_one_adjustable',
    TenOneAdjustable: 'ten_one_adjustable'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgageOccupancyType = {
    Primary: 'primary',
    Secondary: 'secondary',
    Investment: 'investment'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgagePropertySearchStatus = {
    Found: 'found',
    NotFound: 'not_found'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgagePropertyStatus = {
    OwnOutright: 'own_outright',
    OwnWithMortgage: 'own_with_mortgage',
    Rent: 'rent'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgagePropertyType = {
    Rent: 'rent',
    Condo: 'condo',
    MultiUnit: 'multi_unit',
    SingleFamily: 'single_family',
    Townhouse: 'townhouse'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgagePurchaseStatus = {
    NoOffer: 'no_offer',
    OfferAccepted: 'offer_accepted',
    OfferPending: 'offer_pending',
    UnderContract: 'under_contract'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgageRefinanceType = {
    CashOut: 'cash_out',
    RateTerm: 'rate_term'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MortgageType = {
    Purchase: 'purchase',
    Refinance: 'refinance'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OfferRuleReason = {
    DemandOnboarding: 'demand_onboarding',
    SupplyOnboarding: 'supply_onboarding',
    PoorPerformance: 'poor_performance',
    DemandRequest: 'demand_request',
    SupplyRequest: 'supply_request',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Order = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PersonalReferenceRelationType = {
    Parent: 'parent',
    Employer: 'employer',
    Spouse: 'spouse',
    Guardian: 'guardian',
    Sibling: 'sibling',
    Relative: 'relative',
    Friend: 'friend',
    Other: 'other'
};
/**
 * Represents the type of filter to be utlized on the PreSelectRule as knockout criteria, which is associated to the provided characteristic
 * @export
 * @enum {string}
 */
exports.PreSelectRuleFilterKey = {
    Range: 'range',
    Exact: 'exact',
    High: 'high',
    Low: 'low'
};
/**
 * A type of financial product
 * @export
 * @enum {string}
 */
exports.ProductSubType = {
    CreditCard: 'credit_card',
    SecuredCard: 'secured_card',
    StudentCard: 'student_card',
    PersonalLoan: 'personal_loan',
    SecuredLoan: 'secured_loan',
    StudentLoanRefinance: 'student_loan_refinance',
    CoApplicantLoan: 'co_applicant_loan',
    LineOfCredit: 'line_of_credit',
    AutomobileRefinance: 'automobile_refinance',
    HomeEquityLineOfCredit: 'home_equity_line_of_credit',
    Purchase: 'purchase',
    Refinance: 'refinance',
    SavingsAccount: 'savings_account',
    MoneyMarketAccount: 'money_market_account',
    CertificateOfDeposit: 'certificate_of_deposit',
    IndividualRetirementAccount: 'individual_retirement_account',
    CashManagementAccount: 'cash_management_account',
    HighInterestChecking: 'high_interest_checking',
    Checking: 'checking',
    AccidentalDeathBenefits: 'accidental_death_benefits',
    TermLife: 'term_life',
    TermLifeInstant: 'term_life_instant',
    WholeLife: 'whole_life',
    DebtRelief: 'debt_relief',
    InstallmentLoans: 'installment_loans',
    CreditBuilder: 'credit_builder',
    CashAdvance: 'cash_advance',
    CreditRepair: 'credit_repair',
    EducationOffers: 'education_offers',
    EmploymentOpportunity: 'employment_opportunity',
    FinancialWellness: 'financial_wellness',
    DirectAffiliate: 'direct_affiliate',
    OverdraftProtection: 'overdraft_protection',
    RevenueBasedFinancing: 'revenue_based_financing',
    InstallmentLoanMoreOffers: 'installment_loan_more_offers',
    CreditCardMoreOffers: 'credit_card_more_offers',
    CreditRepairMoreOffers: 'credit_repair_more_offers',
    StudentLoan: 'student_loan',
    Health: 'health',
    AutoAndVehicle: 'auto_and_vehicle',
    Games: 'games',
    Home: 'home',
    Rewards: 'rewards',
    LifeInsurance: 'life_insurance',
    AutoInsurance: 'auto_insurance',
    SpecialtyVehicleInsurance: 'specialty_vehicle_insurance',
    HomeOwnersInsurance: 'home_owners_insurance',
    RentersInsurance: 'renters_insurance',
    Uncategorized: 'uncategorized',
    CashAdvanceMoneylion: 'cash_advance_moneylion',
    Unknown: 'unknown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductType = {
    CreditCard: 'credit_card',
    Generic: 'generic',
    AutoInsurance: 'auto_insurance',
    Insurance: 'insurance',
    LifeInsurance: 'life_insurance',
    Loan: 'loan',
    Mortgage: 'mortgage',
    Savings: 'savings',
    Other: 'other',
    Unknown: 'unknown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProvidedCreditRating = {
    Excellent: 'excellent',
    Good: 'good',
    Fair: 'fair',
    Poor: 'poor',
    Limited: 'limited',
    Unknown: 'unknown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RefinanceLoanType = {
    FederalStudentLoan: 'federal_student_loan',
    PrivateStudentLoan: 'private_student_loan'
};
/**
 * A two character upper case state, Puerto Rico, or District of Columbia code
 * @export
 * @enum {string}
 */
exports.State = {
    Ak: 'AK',
    Al: 'AL',
    Ar: 'AR',
    Az: 'AZ',
    Ca: 'CA',
    Co: 'CO',
    Ct: 'CT',
    Dc: 'DC',
    De: 'DE',
    Fl: 'FL',
    Ga: 'GA',
    Hi: 'HI',
    Ia: 'IA',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ks: 'KS',
    Ky: 'KY',
    La: 'LA',
    Ma: 'MA',
    Md: 'MD',
    Me: 'ME',
    Mi: 'MI',
    Mn: 'MN',
    Mo: 'MO',
    Ms: 'MS',
    Mt: 'MT',
    Nc: 'NC',
    Nd: 'ND',
    Ne: 'NE',
    Nh: 'NH',
    Nj: 'NJ',
    Nm: 'NM',
    Nv: 'NV',
    Ny: 'NY',
    Oh: 'OH',
    Ok: 'OK',
    Or: 'OR',
    Pa: 'PA',
    Pr: 'PR',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Va: 'VA',
    Vi: 'VI',
    Vt: 'VT',
    Wa: 'WA',
    Wi: 'WI',
    Wv: 'WV',
    Wy: 'WY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SupplyTemplateApplicationStrategy = {
    AddOnly: 'addOnly',
    AddAndRemove: 'addAndRemove'
};
/**
 * A type of financial product for Supply Templates
 * @export
 * @enum {string}
 */
exports.SupplyTemplateProductType = {
    PersonalLoan: 'personalLoan',
    StudentLoanRefinance: 'studentLoanRefinance',
    Savings: 'savings',
    CreditCard: 'creditCard',
    LifeInsurance: 'lifeInsurance',
    AutomobileRefinance: 'automobileRefinance'
};
/**
 * Unit of measure for offer term lengths, or open for a single term.
 * @export
 * @enum {string}
 */
exports.TermUnit = {
    Day: 'day',
    Month: 'month',
    Year: 'year',
    Open: 'open'
};
/**
 * AddLoanOffersAsyncApi - axios parameter creator
 * @export
 */
var AddLoanOffersAsyncApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add a demand partner api specific response, stored as a normalized api offer
         * @summary Add a demand partner api specific response
         * @param {string} uuid
         * @param {UpgradeResponse} [upgradeResponse] The demand partner api specific response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLoanOffersAsync: function (uuid_1, upgradeResponse_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1, upgradeResponse_1], args_1, true), void 0, function (uuid, upgradeResponse, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'uuid' is not null or undefined
                    (0, common_1.assertParamExists)('addLoanOffersAsync', 'uuid', uuid);
                    localVarPath = "/asyncOriginatorResponses/{uuid}/loanOffers"
                        .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upgradeResponse, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AddLoanOffersAsyncApiAxiosParamCreator = AddLoanOffersAsyncApiAxiosParamCreator;
/**
 * AddLoanOffersAsyncApi - functional programming interface
 * @export
 */
var AddLoanOffersAsyncApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AddLoanOffersAsyncApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add a demand partner api specific response, stored as a normalized api offer
         * @summary Add a demand partner api specific response
         * @param {string} uuid
         * @param {UpgradeResponse} [upgradeResponse] The demand partner api specific response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLoanOffersAsync: function (uuid, upgradeResponse, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addLoanOffersAsync(uuid, upgradeResponse, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AddLoanOffersAsyncApi.addLoanOffersAsync']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AddLoanOffersAsyncApiFp = AddLoanOffersAsyncApiFp;
/**
 * AddLoanOffersAsyncApi - factory interface
 * @export
 */
var AddLoanOffersAsyncApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AddLoanOffersAsyncApiFp)(configuration);
    return {
        /**
         * Add a demand partner api specific response, stored as a normalized api offer
         * @summary Add a demand partner api specific response
         * @param {AddLoanOffersAsyncApiAddLoanOffersAsyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLoanOffersAsync: function (requestParameters, options) {
            return localVarFp.addLoanOffersAsync(requestParameters.uuid, requestParameters.upgradeResponse, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AddLoanOffersAsyncApiFactory = AddLoanOffersAsyncApiFactory;
/**
 * AddLoanOffersAsyncApi - object-oriented interface
 * @export
 * @class AddLoanOffersAsyncApi
 * @extends {BaseAPI}
 */
var AddLoanOffersAsyncApi = /** @class */ (function (_super) {
    __extends(AddLoanOffersAsyncApi, _super);
    function AddLoanOffersAsyncApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add a demand partner api specific response, stored as a normalized api offer
     * @summary Add a demand partner api specific response
     * @param {AddLoanOffersAsyncApiAddLoanOffersAsyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddLoanOffersAsyncApi
     */
    AddLoanOffersAsyncApi.prototype.addLoanOffersAsync = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AddLoanOffersAsyncApiFp)(this.configuration).addLoanOffersAsync(requestParameters.uuid, requestParameters.upgradeResponse, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddLoanOffersAsyncApi;
}(base_1.BaseAPI));
exports.AddLoanOffersAsyncApi = AddLoanOffersAsyncApi;
/**
 * DemandAPIApi - axios parameter creator
 * @export
 */
var DemandAPIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get demand APIs
         * @summary Get demand APIs
         * @param {boolean} [isSecondLook]
         * @param {Array<number>} [subAccountId] A comma separated list of ids
         * @param {ProductType} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApis: function (isSecondLook_1, subAccountId_1, productType_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([isSecondLook_1, subAccountId_1, productType_1], args_1, true), void 0, function (isSecondLook, subAccountId, productType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/apis";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (isSecondLook !== undefined) {
                                localVarQueryParameter['isSecondLook'] = isSecondLook;
                            }
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (productType !== undefined) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandAPIApiAxiosParamCreator = DemandAPIApiAxiosParamCreator;
/**
 * DemandAPIApi - functional programming interface
 * @export
 */
var DemandAPIApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandAPIApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get demand APIs
         * @summary Get demand APIs
         * @param {boolean} [isSecondLook]
         * @param {Array<number>} [subAccountId] A comma separated list of ids
         * @param {ProductType} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApis: function (isSecondLook, subAccountId, productType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandApis(isSecondLook, subAccountId, productType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandAPIApi.getDemandApis']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandAPIApiFp = DemandAPIApiFp;
/**
 * DemandAPIApi - factory interface
 * @export
 */
var DemandAPIApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandAPIApiFp)(configuration);
    return {
        /**
         * Get demand APIs
         * @summary Get demand APIs
         * @param {DemandAPIApiGetDemandApisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApis: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getDemandApis(requestParameters.isSecondLook, requestParameters.subAccountId, requestParameters.productType, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandAPIApiFactory = DemandAPIApiFactory;
/**
 * DemandAPIApi - object-oriented interface
 * @export
 * @class DemandAPIApi
 * @extends {BaseAPI}
 */
var DemandAPIApi = /** @class */ (function (_super) {
    __extends(DemandAPIApi, _super);
    function DemandAPIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get demand APIs
     * @summary Get demand APIs
     * @param {DemandAPIApiGetDemandApisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandAPIApi
     */
    DemandAPIApi.prototype.getDemandApis = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandAPIApiFp)(this.configuration).getDemandApis(requestParameters.isSecondLook, requestParameters.subAccountId, requestParameters.productType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandAPIApi;
}(base_1.BaseAPI));
exports.DemandAPIApi = DemandAPIApi;
/**
 * DemandAPIFilterApi - axios parameter creator
 * @export
 */
var DemandAPIFilterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create demand API filters
         * @summary Create demand API filters
         * @param {DemandApiFilterCreateData} demandApiFilterCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandApiFilters: function (demandApiFilterCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandApiFilterCreateData_1], args_1, true), void 0, function (demandApiFilterCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'demandApiFilterCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createDemandApiFilters', 'demandApiFilterCreateData', demandApiFilterCreateData);
                            localVarPath = "/admin/demandApiFilters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandApiFilterCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a supply threshold override for a demand api filter
         * @summary Create a supply threshold override
         * @param {number} filterId
         * @param {SupplyThresholdOverrideCreateData} supplyThresholdOverrideCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyThresholdOverride: function (filterId_1, supplyThresholdOverrideCreateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filterId_1, supplyThresholdOverrideCreateData_1], args_1, true), void 0, function (filterId, supplyThresholdOverrideCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'filterId' is not null or undefined
                            (0, common_1.assertParamExists)('createSupplyThresholdOverride', 'filterId', filterId);
                            // verify required parameter 'supplyThresholdOverrideCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createSupplyThresholdOverride', 'supplyThresholdOverrideCreateData', supplyThresholdOverrideCreateData);
                            localVarPath = "/admin/demandApiFilters/{filterId}/supplyThresholdOverrides"
                                .replace("{".concat("filterId", "}"), encodeURIComponent(String(filterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyThresholdOverrideCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand api filter
         * @summary Delete a demand api filter
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandApiFilter: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandApiFilter', 'id', id);
                            localVarPath = "/admin/demandApiFilters/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a supply threshold override for a demand api filter
         * @summary Delete a supply threshold override
         * @param {number} filterId
         * @param {number} overrideId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyThresholdOverride: function (filterId_1, overrideId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filterId_1, overrideId_1], args_1, true), void 0, function (filterId, overrideId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'filterId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyThresholdOverride', 'filterId', filterId);
                            // verify required parameter 'overrideId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyThresholdOverride', 'overrideId', overrideId);
                            localVarPath = "/admin/demandApiFilters/{filterId}/supplyThresholdOverrides/{overrideId}"
                                .replace("{".concat("filterId", "}"), encodeURIComponent(String(filterId)))
                                .replace("{".concat("overrideId", "}"), encodeURIComponent(String(overrideId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get demand API filter results
         * @summary Get demand API filter results
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [rateTableId] A comma separated list of ids
         * @param {Array<number>} [demandApiFilterId] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma separated list of ids
         * @param {number} [minProbability] Minimum a DAF probability can be
         * @param {number} [maxProbability] Maximum a DAF probability can be
         * @param {string} [prediction] A filter prediction
         * @param {number} [minId] Minimum ID allowed for a DAF
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {Order} [order]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiFilterResults: function (limit_1, id_1, rateTableId_1, demandApiFilterId_1, demandSubAccountId_1, minProbability_1, maxProbability_1, prediction_1, minId_1, offset_1, order_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 12; _i < arguments.length; _i++) {
                args_1[_i - 12] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, rateTableId_1, demandApiFilterId_1, demandSubAccountId_1, minProbability_1, maxProbability_1, prediction_1, minId_1, offset_1, order_1, sortBy_1], args_1, true), void 0, function (limit, id, rateTableId, demandApiFilterId, demandSubAccountId, minProbability, maxProbability, prediction, minId, offset, order, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandApiFilterResults', 'limit', limit);
                            localVarPath = "/admin/demandApiFilterResults";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (rateTableId) {
                                localVarQueryParameter['rateTableId'] = rateTableId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (demandApiFilterId) {
                                localVarQueryParameter['demandApiFilterId'] = demandApiFilterId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (minProbability !== undefined) {
                                localVarQueryParameter['minProbability'] = minProbability;
                            }
                            if (maxProbability !== undefined) {
                                localVarQueryParameter['maxProbability'] = maxProbability;
                            }
                            if (prediction !== undefined) {
                                localVarQueryParameter['prediction'] = prediction;
                            }
                            if (minId !== undefined) {
                                localVarQueryParameter['minId'] = minId;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get demand API filters
         * @summary Get demand API filters
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma separated list of ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiFilters: function (id_1, demandSubAccountId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, demandSubAccountId_1], args_1, true), void 0, function (id, demandSubAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/demandApiFilters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandAPIFilterApiAxiosParamCreator = DemandAPIFilterApiAxiosParamCreator;
/**
 * DemandAPIFilterApi - functional programming interface
 * @export
 */
var DemandAPIFilterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandAPIFilterApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create demand API filters
         * @summary Create demand API filters
         * @param {DemandApiFilterCreateData} demandApiFilterCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandApiFilters: function (demandApiFilterCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandApiFilters(demandApiFilterCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandAPIFilterApi.createDemandApiFilters']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a supply threshold override for a demand api filter
         * @summary Create a supply threshold override
         * @param {number} filterId
         * @param {SupplyThresholdOverrideCreateData} supplyThresholdOverrideCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyThresholdOverride: function (filterId, supplyThresholdOverrideCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyThresholdOverride(filterId, supplyThresholdOverrideCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandAPIFilterApi.createSupplyThresholdOverride']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a demand api filter
         * @summary Delete a demand api filter
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandApiFilter: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandApiFilter(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandAPIFilterApi.deleteDemandApiFilter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a supply threshold override for a demand api filter
         * @summary Delete a supply threshold override
         * @param {number} filterId
         * @param {number} overrideId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyThresholdOverride: function (filterId, overrideId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyThresholdOverride(filterId, overrideId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandAPIFilterApi.deleteSupplyThresholdOverride']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get demand API filter results
         * @summary Get demand API filter results
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [rateTableId] A comma separated list of ids
         * @param {Array<number>} [demandApiFilterId] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma separated list of ids
         * @param {number} [minProbability] Minimum a DAF probability can be
         * @param {number} [maxProbability] Maximum a DAF probability can be
         * @param {string} [prediction] A filter prediction
         * @param {number} [minId] Minimum ID allowed for a DAF
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {Order} [order]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiFilterResults: function (limit, id, rateTableId, demandApiFilterId, demandSubAccountId, minProbability, maxProbability, prediction, minId, offset, order, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandApiFilterResults(limit, id, rateTableId, demandApiFilterId, demandSubAccountId, minProbability, maxProbability, prediction, minId, offset, order, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandAPIFilterApi.getDemandApiFilterResults']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get demand API filters
         * @summary Get demand API filters
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma separated list of ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiFilters: function (id, demandSubAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandApiFilters(id, demandSubAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandAPIFilterApi.getDemandApiFilters']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandAPIFilterApiFp = DemandAPIFilterApiFp;
/**
 * DemandAPIFilterApi - factory interface
 * @export
 */
var DemandAPIFilterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandAPIFilterApiFp)(configuration);
    return {
        /**
         * Create demand API filters
         * @summary Create demand API filters
         * @param {DemandAPIFilterApiCreateDemandApiFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandApiFilters: function (requestParameters, options) {
            return localVarFp.createDemandApiFilters(requestParameters.demandApiFilterCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a supply threshold override for a demand api filter
         * @summary Create a supply threshold override
         * @param {DemandAPIFilterApiCreateSupplyThresholdOverrideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyThresholdOverride: function (requestParameters, options) {
            return localVarFp.createSupplyThresholdOverride(requestParameters.filterId, requestParameters.supplyThresholdOverrideCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand api filter
         * @summary Delete a demand api filter
         * @param {DemandAPIFilterApiDeleteDemandApiFilterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandApiFilter: function (requestParameters, options) {
            return localVarFp.deleteDemandApiFilter(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a supply threshold override for a demand api filter
         * @summary Delete a supply threshold override
         * @param {DemandAPIFilterApiDeleteSupplyThresholdOverrideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyThresholdOverride: function (requestParameters, options) {
            return localVarFp.deleteSupplyThresholdOverride(requestParameters.filterId, requestParameters.overrideId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get demand API filter results
         * @summary Get demand API filter results
         * @param {DemandAPIFilterApiGetDemandApiFilterResultsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiFilterResults: function (requestParameters, options) {
            return localVarFp.getDemandApiFilterResults(requestParameters.limit, requestParameters.id, requestParameters.rateTableId, requestParameters.demandApiFilterId, requestParameters.demandSubAccountId, requestParameters.minProbability, requestParameters.maxProbability, requestParameters.prediction, requestParameters.minId, requestParameters.offset, requestParameters.order, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get demand API filters
         * @summary Get demand API filters
         * @param {DemandAPIFilterApiGetDemandApiFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiFilters: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getDemandApiFilters(requestParameters.id, requestParameters.demandSubAccountId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandAPIFilterApiFactory = DemandAPIFilterApiFactory;
/**
 * DemandAPIFilterApi - object-oriented interface
 * @export
 * @class DemandAPIFilterApi
 * @extends {BaseAPI}
 */
var DemandAPIFilterApi = /** @class */ (function (_super) {
    __extends(DemandAPIFilterApi, _super);
    function DemandAPIFilterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create demand API filters
     * @summary Create demand API filters
     * @param {DemandAPIFilterApiCreateDemandApiFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandAPIFilterApi
     */
    DemandAPIFilterApi.prototype.createDemandApiFilters = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandAPIFilterApiFp)(this.configuration).createDemandApiFilters(requestParameters.demandApiFilterCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a supply threshold override for a demand api filter
     * @summary Create a supply threshold override
     * @param {DemandAPIFilterApiCreateSupplyThresholdOverrideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandAPIFilterApi
     */
    DemandAPIFilterApi.prototype.createSupplyThresholdOverride = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandAPIFilterApiFp)(this.configuration).createSupplyThresholdOverride(requestParameters.filterId, requestParameters.supplyThresholdOverrideCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand api filter
     * @summary Delete a demand api filter
     * @param {DemandAPIFilterApiDeleteDemandApiFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandAPIFilterApi
     */
    DemandAPIFilterApi.prototype.deleteDemandApiFilter = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandAPIFilterApiFp)(this.configuration).deleteDemandApiFilter(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a supply threshold override for a demand api filter
     * @summary Delete a supply threshold override
     * @param {DemandAPIFilterApiDeleteSupplyThresholdOverrideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandAPIFilterApi
     */
    DemandAPIFilterApi.prototype.deleteSupplyThresholdOverride = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandAPIFilterApiFp)(this.configuration).deleteSupplyThresholdOverride(requestParameters.filterId, requestParameters.overrideId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get demand API filter results
     * @summary Get demand API filter results
     * @param {DemandAPIFilterApiGetDemandApiFilterResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandAPIFilterApi
     */
    DemandAPIFilterApi.prototype.getDemandApiFilterResults = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandAPIFilterApiFp)(this.configuration).getDemandApiFilterResults(requestParameters.limit, requestParameters.id, requestParameters.rateTableId, requestParameters.demandApiFilterId, requestParameters.demandSubAccountId, requestParameters.minProbability, requestParameters.maxProbability, requestParameters.prediction, requestParameters.minId, requestParameters.offset, requestParameters.order, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get demand API filters
     * @summary Get demand API filters
     * @param {DemandAPIFilterApiGetDemandApiFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandAPIFilterApi
     */
    DemandAPIFilterApi.prototype.getDemandApiFilters = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandAPIFilterApiFp)(this.configuration).getDemandApiFilters(requestParameters.id, requestParameters.demandSubAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandAPIFilterApi;
}(base_1.BaseAPI));
exports.DemandAPIFilterApi = DemandAPIFilterApi;
/**
 * DemandApiResponseApi - axios parameter creator
 * @export
 */
var DemandApiResponseApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get a demand api response by UUID
         * @summary Get a demand api response by UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiResponseByUuid: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandApiResponseByUuid', 'uuid', uuid);
                            localVarPath = "/admin/demandApiResponses/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get demand api responses
         * @summary Get demand api responses
         * @param {number} limit
         * @param {Array<string>} [uuid]
         * @param {Date} [since]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiResponses: function (limit_1, uuid_1, since_1, offset_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, uuid_1, since_1, offset_1], args_1, true), void 0, function (limit, uuid, since, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandApiResponses', 'limit', limit);
                            localVarPath = "/admin/demandApiResponses";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (since !== undefined) {
                                localVarQueryParameter['since'] = (since instanceof Date) ?
                                    since.toISOString() :
                                    since;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandApiResponseApiAxiosParamCreator = DemandApiResponseApiAxiosParamCreator;
/**
 * DemandApiResponseApi - functional programming interface
 * @export
 */
var DemandApiResponseApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandApiResponseApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get a demand api response by UUID
         * @summary Get a demand api response by UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiResponseByUuid: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandApiResponseByUuid(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandApiResponseApi.getDemandApiResponseByUuid']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get demand api responses
         * @summary Get demand api responses
         * @param {number} limit
         * @param {Array<string>} [uuid]
         * @param {Date} [since]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiResponses: function (limit, uuid, since, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandApiResponses(limit, uuid, since, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandApiResponseApi.getDemandApiResponses']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandApiResponseApiFp = DemandApiResponseApiFp;
/**
 * DemandApiResponseApi - factory interface
 * @export
 */
var DemandApiResponseApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandApiResponseApiFp)(configuration);
    return {
        /**
         * Get a demand api response by UUID
         * @summary Get a demand api response by UUID
         * @param {DemandApiResponseApiGetDemandApiResponseByUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiResponseByUuid: function (requestParameters, options) {
            return localVarFp.getDemandApiResponseByUuid(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get demand api responses
         * @summary Get demand api responses
         * @param {DemandApiResponseApiGetDemandApiResponsesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandApiResponses: function (requestParameters, options) {
            return localVarFp.getDemandApiResponses(requestParameters.limit, requestParameters.uuid, requestParameters.since, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandApiResponseApiFactory = DemandApiResponseApiFactory;
/**
 * DemandApiResponseApi - object-oriented interface
 * @export
 * @class DemandApiResponseApi
 * @extends {BaseAPI}
 */
var DemandApiResponseApi = /** @class */ (function (_super) {
    __extends(DemandApiResponseApi, _super);
    function DemandApiResponseApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get a demand api response by UUID
     * @summary Get a demand api response by UUID
     * @param {DemandApiResponseApiGetDemandApiResponseByUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandApiResponseApi
     */
    DemandApiResponseApi.prototype.getDemandApiResponseByUuid = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandApiResponseApiFp)(this.configuration).getDemandApiResponseByUuid(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get demand api responses
     * @summary Get demand api responses
     * @param {DemandApiResponseApiGetDemandApiResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandApiResponseApi
     */
    DemandApiResponseApi.prototype.getDemandApiResponses = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandApiResponseApiFp)(this.configuration).getDemandApiResponses(requestParameters.limit, requestParameters.uuid, requestParameters.since, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandApiResponseApi;
}(base_1.BaseAPI));
exports.DemandApiResponseApi = DemandApiResponseApi;
/**
 * EnrichedAffiliateOfferClickApi - axios parameter creator
 * @export
 */
var EnrichedAffiliateOfferClickApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get enriched affiliate offer clicks
         * @summary Get enriched affiliate offer clicks
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<string>} [sourceSubAccountUuid]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedAffiliateOfferClicks: function (limit_1, leadUuid_1, sourceSubAccountUuid_1, createdAtMin_1, createdAtMax_1, offset_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, leadUuid_1, sourceSubAccountUuid_1, createdAtMin_1, createdAtMax_1, offset_1, sortBy_1], args_1, true), void 0, function (limit, leadUuid, sourceSubAccountUuid, createdAtMin, createdAtMax, offset, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getEnrichedAffiliateOfferClicks', 'limit', limit);
                            localVarPath = "/admin/enrichedAffiliateOfferClicks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            if (sourceSubAccountUuid) {
                                localVarQueryParameter['sourceSubAccountUuid'] = sourceSubAccountUuid;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EnrichedAffiliateOfferClickApiAxiosParamCreator = EnrichedAffiliateOfferClickApiAxiosParamCreator;
/**
 * EnrichedAffiliateOfferClickApi - functional programming interface
 * @export
 */
var EnrichedAffiliateOfferClickApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EnrichedAffiliateOfferClickApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get enriched affiliate offer clicks
         * @summary Get enriched affiliate offer clicks
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<string>} [sourceSubAccountUuid]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedAffiliateOfferClicks: function (limit, leadUuid, sourceSubAccountUuid, createdAtMin, createdAtMax, offset, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnrichedAffiliateOfferClicks(limit, leadUuid, sourceSubAccountUuid, createdAtMin, createdAtMax, offset, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EnrichedAffiliateOfferClickApi.getEnrichedAffiliateOfferClicks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EnrichedAffiliateOfferClickApiFp = EnrichedAffiliateOfferClickApiFp;
/**
 * EnrichedAffiliateOfferClickApi - factory interface
 * @export
 */
var EnrichedAffiliateOfferClickApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EnrichedAffiliateOfferClickApiFp)(configuration);
    return {
        /**
         * Get enriched affiliate offer clicks
         * @summary Get enriched affiliate offer clicks
         * @param {EnrichedAffiliateOfferClickApiGetEnrichedAffiliateOfferClicksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedAffiliateOfferClicks: function (requestParameters, options) {
            return localVarFp.getEnrichedAffiliateOfferClicks(requestParameters.limit, requestParameters.leadUuid, requestParameters.sourceSubAccountUuid, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EnrichedAffiliateOfferClickApiFactory = EnrichedAffiliateOfferClickApiFactory;
/**
 * EnrichedAffiliateOfferClickApi - object-oriented interface
 * @export
 * @class EnrichedAffiliateOfferClickApi
 * @extends {BaseAPI}
 */
var EnrichedAffiliateOfferClickApi = /** @class */ (function (_super) {
    __extends(EnrichedAffiliateOfferClickApi, _super);
    function EnrichedAffiliateOfferClickApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get enriched affiliate offer clicks
     * @summary Get enriched affiliate offer clicks
     * @param {EnrichedAffiliateOfferClickApiGetEnrichedAffiliateOfferClicksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrichedAffiliateOfferClickApi
     */
    EnrichedAffiliateOfferClickApi.prototype.getEnrichedAffiliateOfferClicks = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnrichedAffiliateOfferClickApiFp)(this.configuration).getEnrichedAffiliateOfferClicks(requestParameters.limit, requestParameters.leadUuid, requestParameters.sourceSubAccountUuid, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnrichedAffiliateOfferClickApi;
}(base_1.BaseAPI));
exports.EnrichedAffiliateOfferClickApi = EnrichedAffiliateOfferClickApi;
/**
 * EnrichedDirectOfferClickApi - axios parameter creator
 * @export
 */
var EnrichedDirectOfferClickApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get enriched direct offer clicks
         * @summary Get enriched direct offer clicks
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [sourceSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedDirectOfferClicks: function (limit_1, id_1, supplySubAccountId_1, sourceSubAccountId_1, createdAtMin_1, createdAtMax_1, offset_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, supplySubAccountId_1, sourceSubAccountId_1, createdAtMin_1, createdAtMax_1, offset_1, sortBy_1], args_1, true), void 0, function (limit, id, supplySubAccountId, sourceSubAccountId, createdAtMin, createdAtMax, offset, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getEnrichedDirectOfferClicks', 'limit', limit);
                            localVarPath = "/admin/enrichedDirectOfferClicks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["internal"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            if (sourceSubAccountId) {
                                localVarQueryParameter['sourceSubAccountId'] = sourceSubAccountId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EnrichedDirectOfferClickApiAxiosParamCreator = EnrichedDirectOfferClickApiAxiosParamCreator;
/**
 * EnrichedDirectOfferClickApi - functional programming interface
 * @export
 */
var EnrichedDirectOfferClickApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EnrichedDirectOfferClickApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get enriched direct offer clicks
         * @summary Get enriched direct offer clicks
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [sourceSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedDirectOfferClicks: function (limit, id, supplySubAccountId, sourceSubAccountId, createdAtMin, createdAtMax, offset, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnrichedDirectOfferClicks(limit, id, supplySubAccountId, sourceSubAccountId, createdAtMin, createdAtMax, offset, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EnrichedDirectOfferClickApi.getEnrichedDirectOfferClicks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EnrichedDirectOfferClickApiFp = EnrichedDirectOfferClickApiFp;
/**
 * EnrichedDirectOfferClickApi - factory interface
 * @export
 */
var EnrichedDirectOfferClickApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EnrichedDirectOfferClickApiFp)(configuration);
    return {
        /**
         * Get enriched direct offer clicks
         * @summary Get enriched direct offer clicks
         * @param {EnrichedDirectOfferClickApiGetEnrichedDirectOfferClicksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedDirectOfferClicks: function (requestParameters, options) {
            return localVarFp.getEnrichedDirectOfferClicks(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.sourceSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EnrichedDirectOfferClickApiFactory = EnrichedDirectOfferClickApiFactory;
/**
 * EnrichedDirectOfferClickApi - object-oriented interface
 * @export
 * @class EnrichedDirectOfferClickApi
 * @extends {BaseAPI}
 */
var EnrichedDirectOfferClickApi = /** @class */ (function (_super) {
    __extends(EnrichedDirectOfferClickApi, _super);
    function EnrichedDirectOfferClickApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get enriched direct offer clicks
     * @summary Get enriched direct offer clicks
     * @param {EnrichedDirectOfferClickApiGetEnrichedDirectOfferClicksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrichedDirectOfferClickApi
     */
    EnrichedDirectOfferClickApi.prototype.getEnrichedDirectOfferClicks = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnrichedDirectOfferClickApiFp)(this.configuration).getEnrichedDirectOfferClicks(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.sourceSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnrichedDirectOfferClickApi;
}(base_1.BaseAPI));
exports.EnrichedDirectOfferClickApi = EnrichedDirectOfferClickApi;
/**
 * EnrichedOfferClickApi - axios parameter creator
 * @export
 */
var EnrichedOfferClickApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get enriched offer clicks
         * @summary Get enriched offer clicks
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<number>} [sourceSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedOfferClicks: function (limit_1, leadUuid_1, sourceSubAccountId_1, createdAtMin_1, createdAtMax_1, offset_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, leadUuid_1, sourceSubAccountId_1, createdAtMin_1, createdAtMax_1, offset_1, sortBy_1], args_1, true), void 0, function (limit, leadUuid, sourceSubAccountId, createdAtMin, createdAtMax, offset, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getEnrichedOfferClicks', 'limit', limit);
                            localVarPath = "/admin/enrichedOfferClicks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            if (sourceSubAccountId) {
                                localVarQueryParameter['sourceSubAccountId'] = sourceSubAccountId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EnrichedOfferClickApiAxiosParamCreator = EnrichedOfferClickApiAxiosParamCreator;
/**
 * EnrichedOfferClickApi - functional programming interface
 * @export
 */
var EnrichedOfferClickApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EnrichedOfferClickApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get enriched offer clicks
         * @summary Get enriched offer clicks
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<number>} [sourceSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedOfferClicks: function (limit, leadUuid, sourceSubAccountId, createdAtMin, createdAtMax, offset, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnrichedOfferClicks(limit, leadUuid, sourceSubAccountId, createdAtMin, createdAtMax, offset, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EnrichedOfferClickApi.getEnrichedOfferClicks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EnrichedOfferClickApiFp = EnrichedOfferClickApiFp;
/**
 * EnrichedOfferClickApi - factory interface
 * @export
 */
var EnrichedOfferClickApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EnrichedOfferClickApiFp)(configuration);
    return {
        /**
         * Get enriched offer clicks
         * @summary Get enriched offer clicks
         * @param {EnrichedOfferClickApiGetEnrichedOfferClicksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedOfferClicks: function (requestParameters, options) {
            return localVarFp.getEnrichedOfferClicks(requestParameters.limit, requestParameters.leadUuid, requestParameters.sourceSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EnrichedOfferClickApiFactory = EnrichedOfferClickApiFactory;
/**
 * EnrichedOfferClickApi - object-oriented interface
 * @export
 * @class EnrichedOfferClickApi
 * @extends {BaseAPI}
 */
var EnrichedOfferClickApi = /** @class */ (function (_super) {
    __extends(EnrichedOfferClickApi, _super);
    function EnrichedOfferClickApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get enriched offer clicks
     * @summary Get enriched offer clicks
     * @param {EnrichedOfferClickApiGetEnrichedOfferClicksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrichedOfferClickApi
     */
    EnrichedOfferClickApi.prototype.getEnrichedOfferClicks = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnrichedOfferClickApiFp)(this.configuration).getEnrichedOfferClicks(requestParameters.limit, requestParameters.leadUuid, requestParameters.sourceSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnrichedOfferClickApi;
}(base_1.BaseAPI));
exports.EnrichedOfferClickApi = EnrichedOfferClickApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runHealthChecks: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/status/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runHealthChecks: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.runHealthChecks(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HealthCheckApi.runHealthChecks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runHealthChecks: function (options) {
            return localVarFp.runHealthChecks(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Health check
     * @summary Health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.runHealthChecks = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).runHealthChecks(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
/**
 * LeadRateTableCountsApi - axios parameter creator
 * @export
 */
var LeadRateTableCountsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Return lead rate table counts based upon request parameters
         * @summary Get lead table counts
         * @param {Array<string>} leadUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadRateTableCounts: function (leadUuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([leadUuid_1], args_1, true), void 0, function (leadUuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'leadUuid' is not null or undefined
                            (0, common_1.assertParamExists)('getLeadRateTableCounts', 'leadUuid', leadUuid);
                            localVarPath = "/leadRateTableCounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:read", "originator:rate_table:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LeadRateTableCountsApiAxiosParamCreator = LeadRateTableCountsApiAxiosParamCreator;
/**
 * LeadRateTableCountsApi - functional programming interface
 * @export
 */
var LeadRateTableCountsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LeadRateTableCountsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Return lead rate table counts based upon request parameters
         * @summary Get lead table counts
         * @param {Array<string>} leadUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadRateTableCounts: function (leadUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLeadRateTableCounts(leadUuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LeadRateTableCountsApi.getLeadRateTableCounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LeadRateTableCountsApiFp = LeadRateTableCountsApiFp;
/**
 * LeadRateTableCountsApi - factory interface
 * @export
 */
var LeadRateTableCountsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LeadRateTableCountsApiFp)(configuration);
    return {
        /**
         * Return lead rate table counts based upon request parameters
         * @summary Get lead table counts
         * @param {LeadRateTableCountsApiGetLeadRateTableCountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadRateTableCounts: function (requestParameters, options) {
            return localVarFp.getLeadRateTableCounts(requestParameters.leadUuid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LeadRateTableCountsApiFactory = LeadRateTableCountsApiFactory;
/**
 * LeadRateTableCountsApi - object-oriented interface
 * @export
 * @class LeadRateTableCountsApi
 * @extends {BaseAPI}
 */
var LeadRateTableCountsApi = /** @class */ (function (_super) {
    __extends(LeadRateTableCountsApi, _super);
    function LeadRateTableCountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return lead rate table counts based upon request parameters
     * @summary Get lead table counts
     * @param {LeadRateTableCountsApiGetLeadRateTableCountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRateTableCountsApi
     */
    LeadRateTableCountsApi.prototype.getLeadRateTableCounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadRateTableCountsApiFp)(this.configuration).getLeadRateTableCounts(requestParameters.leadUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LeadRateTableCountsApi;
}(base_1.BaseAPI));
exports.LeadRateTableCountsApi = LeadRateTableCountsApi;
/**
 * LifeInsuranceApi - axios parameter creator
 * @export
 */
var LifeInsuranceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * - Call leap life API proxy - Create rate table with single life insurance offer
         * @summary Creates rate table with single life insurance offer
         * @param {LeadResponseJson} leadResponseJson A leadResponseJson object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLifeInsuranceSearch: function (leadResponseJson_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([leadResponseJson_1], args_1, true), void 0, function (leadResponseJson, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'leadResponseJson' is not null or undefined
                            (0, common_1.assertParamExists)('createLifeInsuranceSearch', 'leadResponseJson', leadResponseJson);
                            localVarPath = "/lifeInsurance/searches";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:create"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(leadResponseJson, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LifeInsuranceApiAxiosParamCreator = LifeInsuranceApiAxiosParamCreator;
/**
 * LifeInsuranceApi - functional programming interface
 * @export
 */
var LifeInsuranceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LifeInsuranceApiAxiosParamCreator)(configuration);
    return {
        /**
         * - Call leap life API proxy - Create rate table with single life insurance offer
         * @summary Creates rate table with single life insurance offer
         * @param {LeadResponseJson} leadResponseJson A leadResponseJson object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLifeInsuranceSearch: function (leadResponseJson, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLifeInsuranceSearch(leadResponseJson, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LifeInsuranceApi.createLifeInsuranceSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LifeInsuranceApiFp = LifeInsuranceApiFp;
/**
 * LifeInsuranceApi - factory interface
 * @export
 */
var LifeInsuranceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LifeInsuranceApiFp)(configuration);
    return {
        /**
         * - Call leap life API proxy - Create rate table with single life insurance offer
         * @summary Creates rate table with single life insurance offer
         * @param {LifeInsuranceApiCreateLifeInsuranceSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLifeInsuranceSearch: function (requestParameters, options) {
            return localVarFp.createLifeInsuranceSearch(requestParameters.leadResponseJson, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LifeInsuranceApiFactory = LifeInsuranceApiFactory;
/**
 * LifeInsuranceApi - object-oriented interface
 * @export
 * @class LifeInsuranceApi
 * @extends {BaseAPI}
 */
var LifeInsuranceApi = /** @class */ (function (_super) {
    __extends(LifeInsuranceApi, _super);
    function LifeInsuranceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * - Call leap life API proxy - Create rate table with single life insurance offer
     * @summary Creates rate table with single life insurance offer
     * @param {LifeInsuranceApiCreateLifeInsuranceSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeInsuranceApi
     */
    LifeInsuranceApi.prototype.createLifeInsuranceSearch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LifeInsuranceApiFp)(this.configuration).createLifeInsuranceSearch(requestParameters.leadResponseJson, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LifeInsuranceApi;
}(base_1.BaseAPI));
exports.LifeInsuranceApi = LifeInsuranceApi;
/**
 * MockRateTableApi - axios parameter creator
 * @export
 */
var MockRateTableApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a mock rate table
         * @summary Create a mock rate table
         * @param {MockRateTableCreateData} mockRateTableCreateData A mock rate table object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMockRateTable: function (mockRateTableCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([mockRateTableCreateData_1], args_1, true), void 0, function (mockRateTableCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'mockRateTableCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createMockRateTable', 'mockRateTableCreateData', mockRateTableCreateData);
                            localVarPath = "/admin/mockRateTables";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mockRateTableCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a mock rate table static offer
         * @summary Create a mock rate table static offer
         * @param {MockRateTableStaticOfferCreateData} mockRateTableStaticOfferCreateData A mock rate table and static offer pair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMockRateTableStaticOffer: function (mockRateTableStaticOfferCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([mockRateTableStaticOfferCreateData_1], args_1, true), void 0, function (mockRateTableStaticOfferCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'mockRateTableStaticOfferCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createMockRateTableStaticOffer', 'mockRateTableStaticOfferCreateData', mockRateTableStaticOfferCreateData);
                            localVarPath = "/admin/mockRateTableStaticOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mockRateTableStaticOfferCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a mock rate table
         * @summary Delete a mock rate table
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMockRateTable: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteMockRateTable', 'id', id);
                            localVarPath = "/admin/mockRateTables/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a mock rate table static offer
         * @summary Delete a mock rate table static offer
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMockRateTableStaticOffer: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteMockRateTableStaticOffer', 'id', id);
                            localVarPath = "/admin/mockRateTableStaticOffers/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get mock rate table static offers
         * @summary Get mock rate table static offers
         * @param {number} [id] Mock rate table static offer record ID
         * @param {number} [mockRateTableId] Mock rate table ID
         * @param {number} [staticOfferId] Static offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMockRateTableStaticOffers: function (id_1, mockRateTableId_1, staticOfferId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, mockRateTableId_1, staticOfferId_1], args_1, true), void 0, function (id, mockRateTableId, staticOfferId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/mockRateTableStaticOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (mockRateTableId !== undefined) {
                                localVarQueryParameter['mockRateTableId'] = mockRateTableId;
                            }
                            if (staticOfferId !== undefined) {
                                localVarQueryParameter['staticOfferId'] = staticOfferId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get mock rate tables
         * @summary Get mock rate tables
         * @param {number} limit The maximum number of records to return
         * @param {number} [offset] Offset for paginating through results when larger than the limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMockRateTables: function (limit_1, offset_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, offset_1], args_1, true), void 0, function (limit, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMockRateTables', 'limit', limit);
                    localVarPath = "/admin/mockRateTables";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MockRateTableApiAxiosParamCreator = MockRateTableApiAxiosParamCreator;
/**
 * MockRateTableApi - functional programming interface
 * @export
 */
var MockRateTableApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MockRateTableApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a mock rate table
         * @summary Create a mock rate table
         * @param {MockRateTableCreateData} mockRateTableCreateData A mock rate table object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMockRateTable: function (mockRateTableCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMockRateTable(mockRateTableCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MockRateTableApi.createMockRateTable']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a mock rate table static offer
         * @summary Create a mock rate table static offer
         * @param {MockRateTableStaticOfferCreateData} mockRateTableStaticOfferCreateData A mock rate table and static offer pair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMockRateTableStaticOffer: function (mockRateTableStaticOfferCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMockRateTableStaticOffer(mockRateTableStaticOfferCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MockRateTableApi.createMockRateTableStaticOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a mock rate table
         * @summary Delete a mock rate table
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMockRateTable: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMockRateTable(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MockRateTableApi.deleteMockRateTable']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a mock rate table static offer
         * @summary Delete a mock rate table static offer
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMockRateTableStaticOffer: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMockRateTableStaticOffer(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MockRateTableApi.deleteMockRateTableStaticOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get mock rate table static offers
         * @summary Get mock rate table static offers
         * @param {number} [id] Mock rate table static offer record ID
         * @param {number} [mockRateTableId] Mock rate table ID
         * @param {number} [staticOfferId] Static offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMockRateTableStaticOffers: function (id, mockRateTableId, staticOfferId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMockRateTableStaticOffers(id, mockRateTableId, staticOfferId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MockRateTableApi.getMockRateTableStaticOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get mock rate tables
         * @summary Get mock rate tables
         * @param {number} limit The maximum number of records to return
         * @param {number} [offset] Offset for paginating through results when larger than the limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMockRateTables: function (limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMockRateTables(limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MockRateTableApi.getMockRateTables']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.MockRateTableApiFp = MockRateTableApiFp;
/**
 * MockRateTableApi - factory interface
 * @export
 */
var MockRateTableApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MockRateTableApiFp)(configuration);
    return {
        /**
         * Create a mock rate table
         * @summary Create a mock rate table
         * @param {MockRateTableApiCreateMockRateTableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMockRateTable: function (requestParameters, options) {
            return localVarFp.createMockRateTable(requestParameters.mockRateTableCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a mock rate table static offer
         * @summary Create a mock rate table static offer
         * @param {MockRateTableApiCreateMockRateTableStaticOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMockRateTableStaticOffer: function (requestParameters, options) {
            return localVarFp.createMockRateTableStaticOffer(requestParameters.mockRateTableStaticOfferCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a mock rate table
         * @summary Delete a mock rate table
         * @param {MockRateTableApiDeleteMockRateTableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMockRateTable: function (requestParameters, options) {
            return localVarFp.deleteMockRateTable(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a mock rate table static offer
         * @summary Delete a mock rate table static offer
         * @param {MockRateTableApiDeleteMockRateTableStaticOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMockRateTableStaticOffer: function (requestParameters, options) {
            return localVarFp.deleteMockRateTableStaticOffer(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get mock rate table static offers
         * @summary Get mock rate table static offers
         * @param {MockRateTableApiGetMockRateTableStaticOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMockRateTableStaticOffers: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getMockRateTableStaticOffers(requestParameters.id, requestParameters.mockRateTableId, requestParameters.staticOfferId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get mock rate tables
         * @summary Get mock rate tables
         * @param {MockRateTableApiGetMockRateTablesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMockRateTables: function (requestParameters, options) {
            return localVarFp.getMockRateTables(requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MockRateTableApiFactory = MockRateTableApiFactory;
/**
 * MockRateTableApi - object-oriented interface
 * @export
 * @class MockRateTableApi
 * @extends {BaseAPI}
 */
var MockRateTableApi = /** @class */ (function (_super) {
    __extends(MockRateTableApi, _super);
    function MockRateTableApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a mock rate table
     * @summary Create a mock rate table
     * @param {MockRateTableApiCreateMockRateTableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockRateTableApi
     */
    MockRateTableApi.prototype.createMockRateTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MockRateTableApiFp)(this.configuration).createMockRateTable(requestParameters.mockRateTableCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a mock rate table static offer
     * @summary Create a mock rate table static offer
     * @param {MockRateTableApiCreateMockRateTableStaticOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockRateTableApi
     */
    MockRateTableApi.prototype.createMockRateTableStaticOffer = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MockRateTableApiFp)(this.configuration).createMockRateTableStaticOffer(requestParameters.mockRateTableStaticOfferCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a mock rate table
     * @summary Delete a mock rate table
     * @param {MockRateTableApiDeleteMockRateTableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockRateTableApi
     */
    MockRateTableApi.prototype.deleteMockRateTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MockRateTableApiFp)(this.configuration).deleteMockRateTable(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a mock rate table static offer
     * @summary Delete a mock rate table static offer
     * @param {MockRateTableApiDeleteMockRateTableStaticOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockRateTableApi
     */
    MockRateTableApi.prototype.deleteMockRateTableStaticOffer = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MockRateTableApiFp)(this.configuration).deleteMockRateTableStaticOffer(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get mock rate table static offers
     * @summary Get mock rate table static offers
     * @param {MockRateTableApiGetMockRateTableStaticOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockRateTableApi
     */
    MockRateTableApi.prototype.getMockRateTableStaticOffers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.MockRateTableApiFp)(this.configuration).getMockRateTableStaticOffers(requestParameters.id, requestParameters.mockRateTableId, requestParameters.staticOfferId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get mock rate tables
     * @summary Get mock rate tables
     * @param {MockRateTableApiGetMockRateTablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockRateTableApi
     */
    MockRateTableApi.prototype.getMockRateTables = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MockRateTableApiFp)(this.configuration).getMockRateTables(requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MockRateTableApi;
}(base_1.BaseAPI));
exports.MockRateTableApi = MockRateTableApi;
/**
 * OfferApi - axios parameter creator
 * @export
 */
var OfferApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get offers
         * @summary Get offers
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [loanOfferId]
         * @param {Array<number>} [mortgageOfferId]
         * @param {Array<number>} [savingsOfferId]
         * @param {Array<number>} [specialOfferId]
         * @param {Array<number>} [staticOfferId]
         * @param {Array<ProductType>} [productType]
         * @param {Array<string>} [leadUuid]
         * @param {Array<number>} [rateTableId]
         * @param {Array<number>} [rateTableOfferId]
         * @param {Array<number>} [sourceSubAccountId]
         * @param {Array<number>} [includedForSupplySubAccountId] Limits offers to those that belong to demand sub-accounts for which there exists an active &#x60;SupplyDemandInclusion&#x60; for any of the specified supply sub-account IDs.
         * @param {boolean} [_static]
         * @param {boolean} [hasRule]
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [minId]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {Order} [order]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers: function (limit_1, id_1, uuid_1, loanOfferId_1, mortgageOfferId_1, savingsOfferId_1, specialOfferId_1, staticOfferId_1, productType_1, leadUuid_1, rateTableId_1, rateTableOfferId_1, sourceSubAccountId_1, includedForSupplySubAccountId_1, _static_1, hasRule_1, includeDeactivated_1, minId_1, offset_1, order_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 21; _i < arguments.length; _i++) {
                args_1[_i - 21] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, loanOfferId_1, mortgageOfferId_1, savingsOfferId_1, specialOfferId_1, staticOfferId_1, productType_1, leadUuid_1, rateTableId_1, rateTableOfferId_1, sourceSubAccountId_1, includedForSupplySubAccountId_1, _static_1, hasRule_1, includeDeactivated_1, minId_1, offset_1, order_1, sortBy_1], args_1, true), void 0, function (limit, id, uuid, loanOfferId, mortgageOfferId, savingsOfferId, specialOfferId, staticOfferId, productType, leadUuid, rateTableId, rateTableOfferId, sourceSubAccountId, includedForSupplySubAccountId, _static, hasRule, includeDeactivated, minId, offset, order, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getOffers', 'limit', limit);
                            localVarPath = "/admin/offers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (loanOfferId) {
                                localVarQueryParameter['loanOfferId'] = loanOfferId;
                            }
                            if (mortgageOfferId) {
                                localVarQueryParameter['mortgageOfferId'] = mortgageOfferId;
                            }
                            if (savingsOfferId) {
                                localVarQueryParameter['savingsOfferId'] = savingsOfferId;
                            }
                            if (specialOfferId) {
                                localVarQueryParameter['specialOfferId'] = specialOfferId;
                            }
                            if (staticOfferId) {
                                localVarQueryParameter['staticOfferId'] = staticOfferId;
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            if (rateTableId) {
                                localVarQueryParameter['rateTableId'] = rateTableId;
                            }
                            if (rateTableOfferId) {
                                localVarQueryParameter['rateTableOfferId'] = rateTableOfferId;
                            }
                            if (sourceSubAccountId) {
                                localVarQueryParameter['sourceSubAccountId'] = sourceSubAccountId;
                            }
                            if (includedForSupplySubAccountId) {
                                localVarQueryParameter['includedForSupplySubAccountId'] = includedForSupplySubAccountId;
                            }
                            if (_static !== undefined) {
                                localVarQueryParameter['static'] = _static;
                            }
                            if (hasRule !== undefined) {
                                localVarQueryParameter['hasRule'] = hasRule;
                            }
                            if (includeDeactivated !== undefined) {
                                localVarQueryParameter['includeDeactivated'] = includeDeactivated;
                            }
                            if (minId !== undefined) {
                                localVarQueryParameter['minId'] = minId;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OfferApiAxiosParamCreator = OfferApiAxiosParamCreator;
/**
 * OfferApi - functional programming interface
 * @export
 */
var OfferApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OfferApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get offers
         * @summary Get offers
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [loanOfferId]
         * @param {Array<number>} [mortgageOfferId]
         * @param {Array<number>} [savingsOfferId]
         * @param {Array<number>} [specialOfferId]
         * @param {Array<number>} [staticOfferId]
         * @param {Array<ProductType>} [productType]
         * @param {Array<string>} [leadUuid]
         * @param {Array<number>} [rateTableId]
         * @param {Array<number>} [rateTableOfferId]
         * @param {Array<number>} [sourceSubAccountId]
         * @param {Array<number>} [includedForSupplySubAccountId] Limits offers to those that belong to demand sub-accounts for which there exists an active &#x60;SupplyDemandInclusion&#x60; for any of the specified supply sub-account IDs.
         * @param {boolean} [_static]
         * @param {boolean} [hasRule]
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [minId]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {Order} [order]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers: function (limit, id, uuid, loanOfferId, mortgageOfferId, savingsOfferId, specialOfferId, staticOfferId, productType, leadUuid, rateTableId, rateTableOfferId, sourceSubAccountId, includedForSupplySubAccountId, _static, hasRule, includeDeactivated, minId, offset, order, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOffers(limit, id, uuid, loanOfferId, mortgageOfferId, savingsOfferId, specialOfferId, staticOfferId, productType, leadUuid, rateTableId, rateTableOfferId, sourceSubAccountId, includedForSupplySubAccountId, _static, hasRule, includeDeactivated, minId, offset, order, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfferApi.getOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OfferApiFp = OfferApiFp;
/**
 * OfferApi - factory interface
 * @export
 */
var OfferApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OfferApiFp)(configuration);
    return {
        /**
         * Get offers
         * @summary Get offers
         * @param {OfferApiGetOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers: function (requestParameters, options) {
            return localVarFp.getOffers(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.loanOfferId, requestParameters.mortgageOfferId, requestParameters.savingsOfferId, requestParameters.specialOfferId, requestParameters.staticOfferId, requestParameters.productType, requestParameters.leadUuid, requestParameters.rateTableId, requestParameters.rateTableOfferId, requestParameters.sourceSubAccountId, requestParameters.includedForSupplySubAccountId, requestParameters._static, requestParameters.hasRule, requestParameters.includeDeactivated, requestParameters.minId, requestParameters.offset, requestParameters.order, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OfferApiFactory = OfferApiFactory;
/**
 * OfferApi - object-oriented interface
 * @export
 * @class OfferApi
 * @extends {BaseAPI}
 */
var OfferApi = /** @class */ (function (_super) {
    __extends(OfferApi, _super);
    function OfferApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get offers
     * @summary Get offers
     * @param {OfferApiGetOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferApi
     */
    OfferApi.prototype.getOffers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfferApiFp)(this.configuration).getOffers(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.loanOfferId, requestParameters.mortgageOfferId, requestParameters.savingsOfferId, requestParameters.specialOfferId, requestParameters.staticOfferId, requestParameters.productType, requestParameters.leadUuid, requestParameters.rateTableId, requestParameters.rateTableOfferId, requestParameters.sourceSubAccountId, requestParameters.includedForSupplySubAccountId, requestParameters._static, requestParameters.hasRule, requestParameters.includeDeactivated, requestParameters.minId, requestParameters.offset, requestParameters.order, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OfferApi;
}(base_1.BaseAPI));
exports.OfferApi = OfferApi;
/**
 * OfferRuleApi - axios parameter creator
 * @export
 */
var OfferRuleApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an offer rule
         * @summary Create an offer rule
         * @param {OfferRuleWriteData} offerRuleWriteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferRule: function (offerRuleWriteData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([offerRuleWriteData_1], args_1, true), void 0, function (offerRuleWriteData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'offerRuleWriteData' is not null or undefined
                            (0, common_1.assertParamExists)('createOfferRule', 'offerRuleWriteData', offerRuleWriteData);
                            localVarPath = "/admin/offerRules";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(offerRuleWriteData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an offer rule
         * @summary Delete an offer rule
         * @param {number} rootId The stable &#x60;rootId&#x60; of the offer rule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfferRule: function (rootId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rootId_1], args_1, true), void 0, function (rootId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rootId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOfferRule', 'rootId', rootId);
                            localVarPath = "/admin/offerRules/root/{rootId}"
                                .replace("{".concat("rootId", "}"), encodeURIComponent(String(rootId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get offer rules
         * @summary Get offer rules
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [rootId]
         * @param {Array<ProductType>} [productTypes]
         * @param {Array<number>} [demandSubAccountId]
         * @param {number} [loanAmountMin]
         * @param {number} [loanAmountMax]
         * @param {Array<LoanPurpose>} [loanPurposeKey]
         * @param {Array<ProvidedCreditRating>} [selfAssessedCreditScoreKey]
         * @param {number} [annualIncomeMin]
         * @param {number} [annualIncomeMax]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<string>} [stateAbbreviation]
         * @param {Array<string>} [militaryStatusKey]
         * @param {Array<CardPurpose>} [cardPurposes]
         * @param {Array<number>} [offerId]
         * @param {boolean} [excludeDeleted]
         * @param {boolean} [isDeactivated]
         * @param {Array<number>} [staticOfferId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferRules: function (id_1, rootId_1, productTypes_1, demandSubAccountId_1, loanAmountMin_1, loanAmountMax_1, loanPurposeKey_1, selfAssessedCreditScoreKey_1, annualIncomeMin_1, annualIncomeMax_1, supplySubAccountId_1, stateAbbreviation_1, militaryStatusKey_1, cardPurposes_1, offerId_1, excludeDeleted_1, isDeactivated_1, staticOfferId_1) {
            var args_1 = [];
            for (var _i = 18; _i < arguments.length; _i++) {
                args_1[_i - 18] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, rootId_1, productTypes_1, demandSubAccountId_1, loanAmountMin_1, loanAmountMax_1, loanPurposeKey_1, selfAssessedCreditScoreKey_1, annualIncomeMin_1, annualIncomeMax_1, supplySubAccountId_1, stateAbbreviation_1, militaryStatusKey_1, cardPurposes_1, offerId_1, excludeDeleted_1, isDeactivated_1, staticOfferId_1], args_1, true), void 0, function (id, rootId, productTypes, demandSubAccountId, loanAmountMin, loanAmountMax, loanPurposeKey, selfAssessedCreditScoreKey, annualIncomeMin, annualIncomeMax, supplySubAccountId, stateAbbreviation, militaryStatusKey, cardPurposes, offerId, excludeDeleted, isDeactivated, staticOfferId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/offerRules";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (rootId) {
                                localVarQueryParameter['rootId'] = rootId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (productTypes) {
                                localVarQueryParameter['productTypes'] = productTypes;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (loanAmountMin !== undefined) {
                                localVarQueryParameter['loanAmountMin'] = loanAmountMin;
                            }
                            if (loanAmountMax !== undefined) {
                                localVarQueryParameter['loanAmountMax'] = loanAmountMax;
                            }
                            if (loanPurposeKey) {
                                localVarQueryParameter['loanPurposeKey'] = loanPurposeKey.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (selfAssessedCreditScoreKey) {
                                localVarQueryParameter['selfAssessedCreditScoreKey'] = selfAssessedCreditScoreKey.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (annualIncomeMin !== undefined) {
                                localVarQueryParameter['annualIncomeMin'] = annualIncomeMin;
                            }
                            if (annualIncomeMax !== undefined) {
                                localVarQueryParameter['annualIncomeMax'] = annualIncomeMax;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (stateAbbreviation) {
                                localVarQueryParameter['stateAbbreviation'] = stateAbbreviation.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (militaryStatusKey) {
                                localVarQueryParameter['militaryStatusKey'] = militaryStatusKey.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (cardPurposes) {
                                localVarQueryParameter['cardPurposes'] = cardPurposes.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (offerId) {
                                localVarQueryParameter['offerId'] = offerId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            if (isDeactivated !== undefined) {
                                localVarQueryParameter['isDeactivated'] = isDeactivated;
                            }
                            if (staticOfferId) {
                                localVarQueryParameter['staticOfferId'] = staticOfferId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an offer rule
         * @summary Update an offer rule
         * @param {number} rootId The stable &#x60;rootId&#x60; of the offer rule.
         * @param {OfferRuleWriteData} offerRuleWriteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferRule: function (rootId_1, offerRuleWriteData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rootId_1, offerRuleWriteData_1], args_1, true), void 0, function (rootId, offerRuleWriteData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rootId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOfferRule', 'rootId', rootId);
                            // verify required parameter 'offerRuleWriteData' is not null or undefined
                            (0, common_1.assertParamExists)('updateOfferRule', 'offerRuleWriteData', offerRuleWriteData);
                            localVarPath = "/admin/offerRules/root/{rootId}"
                                .replace("{".concat("rootId", "}"), encodeURIComponent(String(rootId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(offerRuleWriteData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OfferRuleApiAxiosParamCreator = OfferRuleApiAxiosParamCreator;
/**
 * OfferRuleApi - functional programming interface
 * @export
 */
var OfferRuleApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OfferRuleApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create an offer rule
         * @summary Create an offer rule
         * @param {OfferRuleWriteData} offerRuleWriteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferRule: function (offerRuleWriteData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOfferRule(offerRuleWriteData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfferRuleApi.createOfferRule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete an offer rule
         * @summary Delete an offer rule
         * @param {number} rootId The stable &#x60;rootId&#x60; of the offer rule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfferRule: function (rootId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOfferRule(rootId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfferRuleApi.deleteOfferRule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get offer rules
         * @summary Get offer rules
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [rootId]
         * @param {Array<ProductType>} [productTypes]
         * @param {Array<number>} [demandSubAccountId]
         * @param {number} [loanAmountMin]
         * @param {number} [loanAmountMax]
         * @param {Array<LoanPurpose>} [loanPurposeKey]
         * @param {Array<ProvidedCreditRating>} [selfAssessedCreditScoreKey]
         * @param {number} [annualIncomeMin]
         * @param {number} [annualIncomeMax]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<string>} [stateAbbreviation]
         * @param {Array<string>} [militaryStatusKey]
         * @param {Array<CardPurpose>} [cardPurposes]
         * @param {Array<number>} [offerId]
         * @param {boolean} [excludeDeleted]
         * @param {boolean} [isDeactivated]
         * @param {Array<number>} [staticOfferId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferRules: function (id, rootId, productTypes, demandSubAccountId, loanAmountMin, loanAmountMax, loanPurposeKey, selfAssessedCreditScoreKey, annualIncomeMin, annualIncomeMax, supplySubAccountId, stateAbbreviation, militaryStatusKey, cardPurposes, offerId, excludeDeleted, isDeactivated, staticOfferId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOfferRules(id, rootId, productTypes, demandSubAccountId, loanAmountMin, loanAmountMax, loanPurposeKey, selfAssessedCreditScoreKey, annualIncomeMin, annualIncomeMax, supplySubAccountId, stateAbbreviation, militaryStatusKey, cardPurposes, offerId, excludeDeleted, isDeactivated, staticOfferId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfferRuleApi.getOfferRules']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update an offer rule
         * @summary Update an offer rule
         * @param {number} rootId The stable &#x60;rootId&#x60; of the offer rule.
         * @param {OfferRuleWriteData} offerRuleWriteData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferRule: function (rootId, offerRuleWriteData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOfferRule(rootId, offerRuleWriteData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfferRuleApi.updateOfferRule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OfferRuleApiFp = OfferRuleApiFp;
/**
 * OfferRuleApi - factory interface
 * @export
 */
var OfferRuleApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OfferRuleApiFp)(configuration);
    return {
        /**
         * Create an offer rule
         * @summary Create an offer rule
         * @param {OfferRuleApiCreateOfferRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferRule: function (requestParameters, options) {
            return localVarFp.createOfferRule(requestParameters.offerRuleWriteData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an offer rule
         * @summary Delete an offer rule
         * @param {OfferRuleApiDeleteOfferRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfferRule: function (requestParameters, options) {
            return localVarFp.deleteOfferRule(requestParameters.rootId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get offer rules
         * @summary Get offer rules
         * @param {OfferRuleApiGetOfferRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferRules: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getOfferRules(requestParameters.id, requestParameters.rootId, requestParameters.productTypes, requestParameters.demandSubAccountId, requestParameters.loanAmountMin, requestParameters.loanAmountMax, requestParameters.loanPurposeKey, requestParameters.selfAssessedCreditScoreKey, requestParameters.annualIncomeMin, requestParameters.annualIncomeMax, requestParameters.supplySubAccountId, requestParameters.stateAbbreviation, requestParameters.militaryStatusKey, requestParameters.cardPurposes, requestParameters.offerId, requestParameters.excludeDeleted, requestParameters.isDeactivated, requestParameters.staticOfferId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an offer rule
         * @summary Update an offer rule
         * @param {OfferRuleApiUpdateOfferRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferRule: function (requestParameters, options) {
            return localVarFp.updateOfferRule(requestParameters.rootId, requestParameters.offerRuleWriteData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OfferRuleApiFactory = OfferRuleApiFactory;
/**
 * OfferRuleApi - object-oriented interface
 * @export
 * @class OfferRuleApi
 * @extends {BaseAPI}
 */
var OfferRuleApi = /** @class */ (function (_super) {
    __extends(OfferRuleApi, _super);
    function OfferRuleApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an offer rule
     * @summary Create an offer rule
     * @param {OfferRuleApiCreateOfferRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferRuleApi
     */
    OfferRuleApi.prototype.createOfferRule = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfferRuleApiFp)(this.configuration).createOfferRule(requestParameters.offerRuleWriteData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an offer rule
     * @summary Delete an offer rule
     * @param {OfferRuleApiDeleteOfferRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferRuleApi
     */
    OfferRuleApi.prototype.deleteOfferRule = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfferRuleApiFp)(this.configuration).deleteOfferRule(requestParameters.rootId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get offer rules
     * @summary Get offer rules
     * @param {OfferRuleApiGetOfferRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferRuleApi
     */
    OfferRuleApi.prototype.getOfferRules = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OfferRuleApiFp)(this.configuration).getOfferRules(requestParameters.id, requestParameters.rootId, requestParameters.productTypes, requestParameters.demandSubAccountId, requestParameters.loanAmountMin, requestParameters.loanAmountMax, requestParameters.loanPurposeKey, requestParameters.selfAssessedCreditScoreKey, requestParameters.annualIncomeMin, requestParameters.annualIncomeMax, requestParameters.supplySubAccountId, requestParameters.stateAbbreviation, requestParameters.militaryStatusKey, requestParameters.cardPurposes, requestParameters.offerId, requestParameters.excludeDeleted, requestParameters.isDeactivated, requestParameters.staticOfferId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an offer rule
     * @summary Update an offer rule
     * @param {OfferRuleApiUpdateOfferRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferRuleApi
     */
    OfferRuleApi.prototype.updateOfferRule = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfferRuleApiFp)(this.configuration).updateOfferRule(requestParameters.rootId, requestParameters.offerRuleWriteData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OfferRuleApi;
}(base_1.BaseAPI));
exports.OfferRuleApi = OfferRuleApi;
/**
 * OfferRuleDeactivationApi - axios parameter creator
 * @export
 */
var OfferRuleDeactivationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get offer rule deactivations
         * @summary Get offer rule deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [offerRuleId]
         * @param {Array<number>} [offerDeactivationId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {Order} [order]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferRuleDeactivations: function (limit_1, id_1, offerRuleId_1, offerDeactivationId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, order_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, offerRuleId_1, offerDeactivationId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, order_1, sortBy_1], args_1, true), void 0, function (limit, id, offerRuleId, offerDeactivationId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, order, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getOfferRuleDeactivations', 'limit', limit);
                            localVarPath = "/admin/staticOfferRuleDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (offerRuleId) {
                                localVarQueryParameter['offerRuleId'] = offerRuleId;
                            }
                            if (offerDeactivationId) {
                                localVarQueryParameter['offerDeactivationId'] = offerDeactivationId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OfferRuleDeactivationApiAxiosParamCreator = OfferRuleDeactivationApiAxiosParamCreator;
/**
 * OfferRuleDeactivationApi - functional programming interface
 * @export
 */
var OfferRuleDeactivationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OfferRuleDeactivationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get offer rule deactivations
         * @summary Get offer rule deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [offerRuleId]
         * @param {Array<number>} [offerDeactivationId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {Order} [order]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferRuleDeactivations: function (limit, id, offerRuleId, offerDeactivationId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, order, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOfferRuleDeactivations(limit, id, offerRuleId, offerDeactivationId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, order, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfferRuleDeactivationApi.getOfferRuleDeactivations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OfferRuleDeactivationApiFp = OfferRuleDeactivationApiFp;
/**
 * OfferRuleDeactivationApi - factory interface
 * @export
 */
var OfferRuleDeactivationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OfferRuleDeactivationApiFp)(configuration);
    return {
        /**
         * Get offer rule deactivations
         * @summary Get offer rule deactivations
         * @param {OfferRuleDeactivationApiGetOfferRuleDeactivationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferRuleDeactivations: function (requestParameters, options) {
            return localVarFp.getOfferRuleDeactivations(requestParameters.limit, requestParameters.id, requestParameters.offerRuleId, requestParameters.offerDeactivationId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.order, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OfferRuleDeactivationApiFactory = OfferRuleDeactivationApiFactory;
/**
 * OfferRuleDeactivationApi - object-oriented interface
 * @export
 * @class OfferRuleDeactivationApi
 * @extends {BaseAPI}
 */
var OfferRuleDeactivationApi = /** @class */ (function (_super) {
    __extends(OfferRuleDeactivationApi, _super);
    function OfferRuleDeactivationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get offer rule deactivations
     * @summary Get offer rule deactivations
     * @param {OfferRuleDeactivationApiGetOfferRuleDeactivationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferRuleDeactivationApi
     */
    OfferRuleDeactivationApi.prototype.getOfferRuleDeactivations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfferRuleDeactivationApiFp)(this.configuration).getOfferRuleDeactivations(requestParameters.limit, requestParameters.id, requestParameters.offerRuleId, requestParameters.offerDeactivationId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.order, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OfferRuleDeactivationApi;
}(base_1.BaseAPI));
exports.OfferRuleDeactivationApi = OfferRuleDeactivationApi;
/**
 * PayoutCeilingApi - axios parameter creator
 * @export
 */
var PayoutCeilingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a payout ceiling
         * @summary Create a payout ceiling
         * @param {PayoutCeiling} [payoutCeiling]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayoutCeiling: function (payoutCeiling_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([payoutCeiling_1], args_1, true), void 0, function (payoutCeiling, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/payoutCeilings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payoutCeiling, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a payout ceiling
         * @summary Delete a payout ceiling
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePayoutCeiling: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deletePayoutCeiling', 'id', id);
                            localVarPath = "/admin/payoutCeilings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get payout ceilings
         * @summary Get payout ceilings
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutCeilings: function (limit_1, id_1, supplySubAccountId_1, demandSubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, supplySubAccountId_1, demandSubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, supplySubAccountId, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getPayoutCeilings', 'limit', limit);
                            localVarPath = "/admin/payoutCeilings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a payout ceiling
         * @summary Update a payout ceiling
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutCeiling: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updatePayoutCeiling', 'id', id);
                            localVarPath = "/admin/payoutCeilings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PayoutCeilingApiAxiosParamCreator = PayoutCeilingApiAxiosParamCreator;
/**
 * PayoutCeilingApi - functional programming interface
 * @export
 */
var PayoutCeilingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PayoutCeilingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a payout ceiling
         * @summary Create a payout ceiling
         * @param {PayoutCeiling} [payoutCeiling]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayoutCeiling: function (payoutCeiling, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPayoutCeiling(payoutCeiling, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayoutCeilingApi.createPayoutCeiling']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a payout ceiling
         * @summary Delete a payout ceiling
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePayoutCeiling: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePayoutCeiling(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayoutCeilingApi.deletePayoutCeiling']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get payout ceilings
         * @summary Get payout ceilings
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutCeilings: function (limit, id, supplySubAccountId, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPayoutCeilings(limit, id, supplySubAccountId, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayoutCeilingApi.getPayoutCeilings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a payout ceiling
         * @summary Update a payout ceiling
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutCeiling: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePayoutCeiling(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayoutCeilingApi.updatePayoutCeiling']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PayoutCeilingApiFp = PayoutCeilingApiFp;
/**
 * PayoutCeilingApi - factory interface
 * @export
 */
var PayoutCeilingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PayoutCeilingApiFp)(configuration);
    return {
        /**
         * Create a payout ceiling
         * @summary Create a payout ceiling
         * @param {PayoutCeilingApiCreatePayoutCeilingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayoutCeiling: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createPayoutCeiling(requestParameters.payoutCeiling, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a payout ceiling
         * @summary Delete a payout ceiling
         * @param {PayoutCeilingApiDeletePayoutCeilingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePayoutCeiling: function (requestParameters, options) {
            return localVarFp.deletePayoutCeiling(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get payout ceilings
         * @summary Get payout ceilings
         * @param {PayoutCeilingApiGetPayoutCeilingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutCeilings: function (requestParameters, options) {
            return localVarFp.getPayoutCeilings(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.demandSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a payout ceiling
         * @summary Update a payout ceiling
         * @param {PayoutCeilingApiUpdatePayoutCeilingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutCeiling: function (requestParameters, options) {
            return localVarFp.updatePayoutCeiling(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PayoutCeilingApiFactory = PayoutCeilingApiFactory;
/**
 * PayoutCeilingApi - object-oriented interface
 * @export
 * @class PayoutCeilingApi
 * @extends {BaseAPI}
 */
var PayoutCeilingApi = /** @class */ (function (_super) {
    __extends(PayoutCeilingApi, _super);
    function PayoutCeilingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a payout ceiling
     * @summary Create a payout ceiling
     * @param {PayoutCeilingApiCreatePayoutCeilingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutCeilingApi
     */
    PayoutCeilingApi.prototype.createPayoutCeiling = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PayoutCeilingApiFp)(this.configuration).createPayoutCeiling(requestParameters.payoutCeiling, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a payout ceiling
     * @summary Delete a payout ceiling
     * @param {PayoutCeilingApiDeletePayoutCeilingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutCeilingApi
     */
    PayoutCeilingApi.prototype.deletePayoutCeiling = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PayoutCeilingApiFp)(this.configuration).deletePayoutCeiling(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get payout ceilings
     * @summary Get payout ceilings
     * @param {PayoutCeilingApiGetPayoutCeilingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutCeilingApi
     */
    PayoutCeilingApi.prototype.getPayoutCeilings = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PayoutCeilingApiFp)(this.configuration).getPayoutCeilings(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.demandSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a payout ceiling
     * @summary Update a payout ceiling
     * @param {PayoutCeilingApiUpdatePayoutCeilingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutCeilingApi
     */
    PayoutCeilingApi.prototype.updatePayoutCeiling = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PayoutCeilingApiFp)(this.configuration).updatePayoutCeiling(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PayoutCeilingApi;
}(base_1.BaseAPI));
exports.PayoutCeilingApi = PayoutCeilingApi;
/**
 * PreSelectRuleApi - axios parameter creator
 * @export
 */
var PreSelectRuleApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a pre-select rule
         * @summary Create a pre-select rule
         * @param {PreSelectRule} preSelectRule A preselect rule object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreSelectRule: function (preSelectRule_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([preSelectRule_1], args_1, true), void 0, function (preSelectRule, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'preSelectRule' is not null or undefined
                            (0, common_1.assertParamExists)('createPreSelectRule', 'preSelectRule', preSelectRule);
                            localVarPath = "/admin/preSelectRules";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(preSelectRule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a pre-select rule
         * @summary Delete a pre-select rule
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreSelectRule: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deletePreSelectRule', 'id', id);
                            localVarPath = "/admin/preSelectRules/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get pre-select rules
         * @summary Get pre-select rules
         * @param {number} limit The maximum number of records to return
         * @param {Array<number>} [id] Preselect Rule record IDs
         * @param {number} [uuid] Preselect Rule Uuids
         * @param {Array<number>} [offerId] Offer ID
         * @param {Array<number>} [nonPreSelectOfferId] Non PreSelect Offer Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSelectRules: function (limit_1, id_1, uuid_1, offerId_1, nonPreSelectOfferId_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, offerId_1, nonPreSelectOfferId_1], args_1, true), void 0, function (limit, id, uuid, offerId, nonPreSelectOfferId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getPreSelectRules', 'limit', limit);
                            localVarPath = "/admin/preSelectRules";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (uuid !== undefined) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (offerId) {
                                localVarQueryParameter['offerId'] = offerId;
                            }
                            if (nonPreSelectOfferId) {
                                localVarQueryParameter['nonPreSelectOfferId'] = nonPreSelectOfferId;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of pre-select rule summaries that match the specified criteria.
         * @summary Get pre-select rule summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [offerId] Offer ID
         * @param {Array<number>} [nonPreSelectOfferId] Non PreSelect Offer Ids
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreselectRuleSummaries: function (limit_1, id_1, offerId_1, nonPreSelectOfferId_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, offerId_1, nonPreSelectOfferId_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, offerId, nonPreSelectOfferId, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getPreselectRuleSummaries', 'limit', limit);
                            localVarPath = "/admin/preSelectRuleSummaries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (offerId) {
                                localVarQueryParameter['offerId'] = offerId;
                            }
                            if (nonPreSelectOfferId) {
                                localVarQueryParameter['nonPreSelectOfferId'] = nonPreSelectOfferId;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a pre-select rule
         * @summary Update a pre-select rule
         * @param {number} id
         * @param {PreSelectRule} preSelectRule A preselect rule object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreSelectRule: function (id_1, preSelectRule_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, preSelectRule_1], args_1, true), void 0, function (id, preSelectRule, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updatePreSelectRule', 'id', id);
                            // verify required parameter 'preSelectRule' is not null or undefined
                            (0, common_1.assertParamExists)('updatePreSelectRule', 'preSelectRule', preSelectRule);
                            localVarPath = "/admin/preSelectRules/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(preSelectRule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PreSelectRuleApiAxiosParamCreator = PreSelectRuleApiAxiosParamCreator;
/**
 * PreSelectRuleApi - functional programming interface
 * @export
 */
var PreSelectRuleApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PreSelectRuleApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a pre-select rule
         * @summary Create a pre-select rule
         * @param {PreSelectRule} preSelectRule A preselect rule object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreSelectRule: function (preSelectRule, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPreSelectRule(preSelectRule, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreSelectRuleApi.createPreSelectRule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a pre-select rule
         * @summary Delete a pre-select rule
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreSelectRule: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePreSelectRule(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreSelectRuleApi.deletePreSelectRule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get pre-select rules
         * @summary Get pre-select rules
         * @param {number} limit The maximum number of records to return
         * @param {Array<number>} [id] Preselect Rule record IDs
         * @param {number} [uuid] Preselect Rule Uuids
         * @param {Array<number>} [offerId] Offer ID
         * @param {Array<number>} [nonPreSelectOfferId] Non PreSelect Offer Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSelectRules: function (limit, id, uuid, offerId, nonPreSelectOfferId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPreSelectRules(limit, id, uuid, offerId, nonPreSelectOfferId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreSelectRuleApi.getPreSelectRules']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of pre-select rule summaries that match the specified criteria.
         * @summary Get pre-select rule summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [offerId] Offer ID
         * @param {Array<number>} [nonPreSelectOfferId] Non PreSelect Offer Ids
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreselectRuleSummaries: function (limit, id, offerId, nonPreSelectOfferId, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPreselectRuleSummaries(limit, id, offerId, nonPreSelectOfferId, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreSelectRuleApi.getPreselectRuleSummaries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a pre-select rule
         * @summary Update a pre-select rule
         * @param {number} id
         * @param {PreSelectRule} preSelectRule A preselect rule object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreSelectRule: function (id, preSelectRule, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePreSelectRule(id, preSelectRule, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreSelectRuleApi.updatePreSelectRule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PreSelectRuleApiFp = PreSelectRuleApiFp;
/**
 * PreSelectRuleApi - factory interface
 * @export
 */
var PreSelectRuleApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PreSelectRuleApiFp)(configuration);
    return {
        /**
         * Create a pre-select rule
         * @summary Create a pre-select rule
         * @param {PreSelectRuleApiCreatePreSelectRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreSelectRule: function (requestParameters, options) {
            return localVarFp.createPreSelectRule(requestParameters.preSelectRule, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a pre-select rule
         * @summary Delete a pre-select rule
         * @param {PreSelectRuleApiDeletePreSelectRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreSelectRule: function (requestParameters, options) {
            return localVarFp.deletePreSelectRule(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get pre-select rules
         * @summary Get pre-select rules
         * @param {PreSelectRuleApiGetPreSelectRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSelectRules: function (requestParameters, options) {
            return localVarFp.getPreSelectRules(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.offerId, requestParameters.nonPreSelectOfferId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of pre-select rule summaries that match the specified criteria.
         * @summary Get pre-select rule summaries
         * @param {PreSelectRuleApiGetPreselectRuleSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreselectRuleSummaries: function (requestParameters, options) {
            return localVarFp.getPreselectRuleSummaries(requestParameters.limit, requestParameters.id, requestParameters.offerId, requestParameters.nonPreSelectOfferId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a pre-select rule
         * @summary Update a pre-select rule
         * @param {PreSelectRuleApiUpdatePreSelectRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreSelectRule: function (requestParameters, options) {
            return localVarFp.updatePreSelectRule(requestParameters.id, requestParameters.preSelectRule, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PreSelectRuleApiFactory = PreSelectRuleApiFactory;
/**
 * PreSelectRuleApi - object-oriented interface
 * @export
 * @class PreSelectRuleApi
 * @extends {BaseAPI}
 */
var PreSelectRuleApi = /** @class */ (function (_super) {
    __extends(PreSelectRuleApi, _super);
    function PreSelectRuleApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a pre-select rule
     * @summary Create a pre-select rule
     * @param {PreSelectRuleApiCreatePreSelectRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreSelectRuleApi
     */
    PreSelectRuleApi.prototype.createPreSelectRule = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PreSelectRuleApiFp)(this.configuration).createPreSelectRule(requestParameters.preSelectRule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a pre-select rule
     * @summary Delete a pre-select rule
     * @param {PreSelectRuleApiDeletePreSelectRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreSelectRuleApi
     */
    PreSelectRuleApi.prototype.deletePreSelectRule = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PreSelectRuleApiFp)(this.configuration).deletePreSelectRule(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get pre-select rules
     * @summary Get pre-select rules
     * @param {PreSelectRuleApiGetPreSelectRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreSelectRuleApi
     */
    PreSelectRuleApi.prototype.getPreSelectRules = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PreSelectRuleApiFp)(this.configuration).getPreSelectRules(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.offerId, requestParameters.nonPreSelectOfferId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of pre-select rule summaries that match the specified criteria.
     * @summary Get pre-select rule summaries
     * @param {PreSelectRuleApiGetPreselectRuleSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreSelectRuleApi
     */
    PreSelectRuleApi.prototype.getPreselectRuleSummaries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PreSelectRuleApiFp)(this.configuration).getPreselectRuleSummaries(requestParameters.limit, requestParameters.id, requestParameters.offerId, requestParameters.nonPreSelectOfferId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a pre-select rule
     * @summary Update a pre-select rule
     * @param {PreSelectRuleApiUpdatePreSelectRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreSelectRuleApi
     */
    PreSelectRuleApi.prototype.updatePreSelectRule = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PreSelectRuleApiFp)(this.configuration).updatePreSelectRule(requestParameters.id, requestParameters.preSelectRule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PreSelectRuleApi;
}(base_1.BaseAPI));
exports.PreSelectRuleApi = PreSelectRuleApi;
/**
 * PreSelectedOfferApi - axios parameter creator
 * @export
 */
var PreSelectedOfferApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get pre-selected offers for a lead
         * @summary Get pre-selected offers for a lead
         * @param {Array<string>} leadUuid
         * @param {number} limit
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSelectedOffers: function (leadUuid_1, limit_1, offset_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([leadUuid_1, limit_1, offset_1, sortBy_1], args_1, true), void 0, function (leadUuid, limit, offset, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'leadUuid' is not null or undefined
                            (0, common_1.assertParamExists)('getPreSelectedOffers', 'leadUuid', leadUuid);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getPreSelectedOffers', 'limit', limit);
                            localVarPath = "/admin/preSelectedOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PreSelectedOfferApiAxiosParamCreator = PreSelectedOfferApiAxiosParamCreator;
/**
 * PreSelectedOfferApi - functional programming interface
 * @export
 */
var PreSelectedOfferApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PreSelectedOfferApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get pre-selected offers for a lead
         * @summary Get pre-selected offers for a lead
         * @param {Array<string>} leadUuid
         * @param {number} limit
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSelectedOffers: function (leadUuid, limit, offset, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPreSelectedOffers(leadUuid, limit, offset, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreSelectedOfferApi.getPreSelectedOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PreSelectedOfferApiFp = PreSelectedOfferApiFp;
/**
 * PreSelectedOfferApi - factory interface
 * @export
 */
var PreSelectedOfferApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PreSelectedOfferApiFp)(configuration);
    return {
        /**
         * Get pre-selected offers for a lead
         * @summary Get pre-selected offers for a lead
         * @param {PreSelectedOfferApiGetPreSelectedOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSelectedOffers: function (requestParameters, options) {
            return localVarFp.getPreSelectedOffers(requestParameters.leadUuid, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PreSelectedOfferApiFactory = PreSelectedOfferApiFactory;
/**
 * PreSelectedOfferApi - object-oriented interface
 * @export
 * @class PreSelectedOfferApi
 * @extends {BaseAPI}
 */
var PreSelectedOfferApi = /** @class */ (function (_super) {
    __extends(PreSelectedOfferApi, _super);
    function PreSelectedOfferApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get pre-selected offers for a lead
     * @summary Get pre-selected offers for a lead
     * @param {PreSelectedOfferApiGetPreSelectedOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreSelectedOfferApi
     */
    PreSelectedOfferApi.prototype.getPreSelectedOffers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PreSelectedOfferApiFp)(this.configuration).getPreSelectedOffers(requestParameters.leadUuid, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PreSelectedOfferApi;
}(base_1.BaseAPI));
exports.PreSelectedOfferApi = PreSelectedOfferApi;
/**
 * PreviewOfferApi - axios parameter creator
 * @export
 */
var PreviewOfferApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get credit card preview offers
         * @summary Get credit card preview offers
         * @param {ProvidedCreditRating} [providedCreditRating]
         * @param {string} [zipCode]
         * @param {CardPurpose} [cardPurposes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewCreditCardOffers: function (providedCreditRating_1, zipCode_1, cardPurposes_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([providedCreditRating_1, zipCode_1, cardPurposes_1], args_1, true), void 0, function (providedCreditRating, zipCode, cardPurposes, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/preview/creditCardOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (providedCreditRating !== undefined) {
                                localVarQueryParameter['providedCreditRating'] = providedCreditRating;
                            }
                            if (zipCode !== undefined) {
                                localVarQueryParameter['zipCode'] = zipCode;
                            }
                            if (cardPurposes !== undefined) {
                                localVarQueryParameter['cardPurposes'] = cardPurposes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get loan preview offers
         * @summary Get loan preview offers
         * @param {number} [loanAmount]
         * @param {ProvidedCreditRating} [providedCreditRating]
         * @param {LoanPurpose} [loanPurpose]
         * @param {string} [zipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewLoanOffers: function (loanAmount_1, providedCreditRating_1, loanPurpose_1, zipCode_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([loanAmount_1, providedCreditRating_1, loanPurpose_1, zipCode_1], args_1, true), void 0, function (loanAmount, providedCreditRating, loanPurpose, zipCode, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/preview/loanOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (loanAmount !== undefined) {
                                localVarQueryParameter['loanAmount'] = loanAmount;
                            }
                            if (providedCreditRating !== undefined) {
                                localVarQueryParameter['providedCreditRating'] = providedCreditRating;
                            }
                            if (loanPurpose !== undefined) {
                                localVarQueryParameter['loanPurpose'] = loanPurpose;
                            }
                            if (zipCode !== undefined) {
                                localVarQueryParameter['zipCode'] = zipCode;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get savings preview offers
         * @summary Get savings preview offers
         * @param {number} [maxDepositAmount]
         * @param {number} [minDepositAmount]
         * @param {string} [zipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewSavingsOffers: function (maxDepositAmount_1, minDepositAmount_1, zipCode_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([maxDepositAmount_1, minDepositAmount_1, zipCode_1], args_1, true), void 0, function (maxDepositAmount, minDepositAmount, zipCode, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/preview/savingsOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (maxDepositAmount !== undefined) {
                                localVarQueryParameter['maxDepositAmount'] = maxDepositAmount;
                            }
                            if (minDepositAmount !== undefined) {
                                localVarQueryParameter['minDepositAmount'] = minDepositAmount;
                            }
                            if (zipCode !== undefined) {
                                localVarQueryParameter['zipCode'] = zipCode;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PreviewOfferApiAxiosParamCreator = PreviewOfferApiAxiosParamCreator;
/**
 * PreviewOfferApi - functional programming interface
 * @export
 */
var PreviewOfferApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PreviewOfferApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get credit card preview offers
         * @summary Get credit card preview offers
         * @param {ProvidedCreditRating} [providedCreditRating]
         * @param {string} [zipCode]
         * @param {CardPurpose} [cardPurposes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewCreditCardOffers: function (providedCreditRating, zipCode, cardPurposes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPreviewCreditCardOffers(providedCreditRating, zipCode, cardPurposes, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreviewOfferApi.getPreviewCreditCardOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get loan preview offers
         * @summary Get loan preview offers
         * @param {number} [loanAmount]
         * @param {ProvidedCreditRating} [providedCreditRating]
         * @param {LoanPurpose} [loanPurpose]
         * @param {string} [zipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewLoanOffers: function (loanAmount, providedCreditRating, loanPurpose, zipCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPreviewLoanOffers(loanAmount, providedCreditRating, loanPurpose, zipCode, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreviewOfferApi.getPreviewLoanOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get savings preview offers
         * @summary Get savings preview offers
         * @param {number} [maxDepositAmount]
         * @param {number} [minDepositAmount]
         * @param {string} [zipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewSavingsOffers: function (maxDepositAmount, minDepositAmount, zipCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPreviewSavingsOffers(maxDepositAmount, minDepositAmount, zipCode, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PreviewOfferApi.getPreviewSavingsOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PreviewOfferApiFp = PreviewOfferApiFp;
/**
 * PreviewOfferApi - factory interface
 * @export
 */
var PreviewOfferApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PreviewOfferApiFp)(configuration);
    return {
        /**
         * Get credit card preview offers
         * @summary Get credit card preview offers
         * @param {PreviewOfferApiGetPreviewCreditCardOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewCreditCardOffers: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getPreviewCreditCardOffers(requestParameters.providedCreditRating, requestParameters.zipCode, requestParameters.cardPurposes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get loan preview offers
         * @summary Get loan preview offers
         * @param {PreviewOfferApiGetPreviewLoanOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewLoanOffers: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getPreviewLoanOffers(requestParameters.loanAmount, requestParameters.providedCreditRating, requestParameters.loanPurpose, requestParameters.zipCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get savings preview offers
         * @summary Get savings preview offers
         * @param {PreviewOfferApiGetPreviewSavingsOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewSavingsOffers: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getPreviewSavingsOffers(requestParameters.maxDepositAmount, requestParameters.minDepositAmount, requestParameters.zipCode, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PreviewOfferApiFactory = PreviewOfferApiFactory;
/**
 * PreviewOfferApi - object-oriented interface
 * @export
 * @class PreviewOfferApi
 * @extends {BaseAPI}
 */
var PreviewOfferApi = /** @class */ (function (_super) {
    __extends(PreviewOfferApi, _super);
    function PreviewOfferApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get credit card preview offers
     * @summary Get credit card preview offers
     * @param {PreviewOfferApiGetPreviewCreditCardOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreviewOfferApi
     */
    PreviewOfferApi.prototype.getPreviewCreditCardOffers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PreviewOfferApiFp)(this.configuration).getPreviewCreditCardOffers(requestParameters.providedCreditRating, requestParameters.zipCode, requestParameters.cardPurposes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get loan preview offers
     * @summary Get loan preview offers
     * @param {PreviewOfferApiGetPreviewLoanOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreviewOfferApi
     */
    PreviewOfferApi.prototype.getPreviewLoanOffers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PreviewOfferApiFp)(this.configuration).getPreviewLoanOffers(requestParameters.loanAmount, requestParameters.providedCreditRating, requestParameters.loanPurpose, requestParameters.zipCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get savings preview offers
     * @summary Get savings preview offers
     * @param {PreviewOfferApiGetPreviewSavingsOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreviewOfferApi
     */
    PreviewOfferApi.prototype.getPreviewSavingsOffers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PreviewOfferApiFp)(this.configuration).getPreviewSavingsOffers(requestParameters.maxDepositAmount, requestParameters.minDepositAmount, requestParameters.zipCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PreviewOfferApi;
}(base_1.BaseAPI));
exports.PreviewOfferApi = PreviewOfferApi;
/**
 * PricingControlApi - axios parameter creator
 * @export
 */
var PricingControlApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a list of pricing control summaries summaries that match the specified criteria.
         * @summary Get pricing control summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<ProductType>} [productType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingControlSummaries: function (limit_1, id_1, demandSubAccountId_1, productType_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, demandSubAccountId_1, productType_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, demandSubAccountId, productType, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getPricingControlSummaries', 'limit', limit);
                            localVarPath = "/admin/pricingControlSummaries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PricingControlApiAxiosParamCreator = PricingControlApiAxiosParamCreator;
/**
 * PricingControlApi - functional programming interface
 * @export
 */
var PricingControlApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PricingControlApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a list of pricing control summaries summaries that match the specified criteria.
         * @summary Get pricing control summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<ProductType>} [productType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingControlSummaries: function (limit, id, demandSubAccountId, productType, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPricingControlSummaries(limit, id, demandSubAccountId, productType, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PricingControlApi.getPricingControlSummaries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PricingControlApiFp = PricingControlApiFp;
/**
 * PricingControlApi - factory interface
 * @export
 */
var PricingControlApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PricingControlApiFp)(configuration);
    return {
        /**
         * Returns a list of pricing control summaries summaries that match the specified criteria.
         * @summary Get pricing control summaries
         * @param {PricingControlApiGetPricingControlSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingControlSummaries: function (requestParameters, options) {
            return localVarFp.getPricingControlSummaries(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.productType, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PricingControlApiFactory = PricingControlApiFactory;
/**
 * PricingControlApi - object-oriented interface
 * @export
 * @class PricingControlApi
 * @extends {BaseAPI}
 */
var PricingControlApi = /** @class */ (function (_super) {
    __extends(PricingControlApi, _super);
    function PricingControlApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a list of pricing control summaries summaries that match the specified criteria.
     * @summary Get pricing control summaries
     * @param {PricingControlApiGetPricingControlSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingControlApi
     */
    PricingControlApi.prototype.getPricingControlSummaries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PricingControlApiFp)(this.configuration).getPricingControlSummaries(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.productType, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PricingControlApi;
}(base_1.BaseAPI));
exports.PricingControlApi = PricingControlApi;
/**
 * RateFeeDetailURLApi - axios parameter creator
 * @export
 */
var RateFeeDetailURLApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add a new rateFeeDetailUrl for a credit card, replacing any existing value for that `cardName`
         * @summary Add a new rateFeeDetailUrl for a credit card
         * @param {RateFeeDetailUrlCreateData} [rateFeeDetailUrlCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateFeeDetailUrls: function (rateFeeDetailUrlCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateFeeDetailUrlCreateData_1], args_1, true), void 0, function (rateFeeDetailUrlCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/commissionSoupRateFeeDetailUrls";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rateFeeDetailUrlCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a rate fee detail URL for a credit card
         * @summary Delete a rate fee detail URL for a credit card
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateFeeDetailUrl: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRateFeeDetailUrl', 'id', id);
                            localVarPath = "/admin/commissionSoupRateFeeDetailUrls/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the partner-provided URLs for viewing rate and fee information for credit cards
         * @summary Get rate fee detail URLs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFeeDetailUrls: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/commissionSoupRateFeeDetailUrls";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RateFeeDetailURLApiAxiosParamCreator = RateFeeDetailURLApiAxiosParamCreator;
/**
 * RateFeeDetailURLApi - functional programming interface
 * @export
 */
var RateFeeDetailURLApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RateFeeDetailURLApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add a new rateFeeDetailUrl for a credit card, replacing any existing value for that `cardName`
         * @summary Add a new rateFeeDetailUrl for a credit card
         * @param {RateFeeDetailUrlCreateData} [rateFeeDetailUrlCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateFeeDetailUrls: function (rateFeeDetailUrlCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRateFeeDetailUrls(rateFeeDetailUrlCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateFeeDetailURLApi.createRateFeeDetailUrls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a rate fee detail URL for a credit card
         * @summary Delete a rate fee detail URL for a credit card
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateFeeDetailUrl: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRateFeeDetailUrl(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateFeeDetailURLApi.deleteRateFeeDetailUrl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the partner-provided URLs for viewing rate and fee information for credit cards
         * @summary Get rate fee detail URLs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFeeDetailUrls: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateFeeDetailUrls(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateFeeDetailURLApi.getRateFeeDetailUrls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RateFeeDetailURLApiFp = RateFeeDetailURLApiFp;
/**
 * RateFeeDetailURLApi - factory interface
 * @export
 */
var RateFeeDetailURLApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RateFeeDetailURLApiFp)(configuration);
    return {
        /**
         * Add a new rateFeeDetailUrl for a credit card, replacing any existing value for that `cardName`
         * @summary Add a new rateFeeDetailUrl for a credit card
         * @param {RateFeeDetailURLApiCreateRateFeeDetailUrlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateFeeDetailUrls: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createRateFeeDetailUrls(requestParameters.rateFeeDetailUrlCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a rate fee detail URL for a credit card
         * @summary Delete a rate fee detail URL for a credit card
         * @param {RateFeeDetailURLApiDeleteRateFeeDetailUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateFeeDetailUrl: function (requestParameters, options) {
            return localVarFp.deleteRateFeeDetailUrl(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the partner-provided URLs for viewing rate and fee information for credit cards
         * @summary Get rate fee detail URLs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFeeDetailUrls: function (options) {
            return localVarFp.getRateFeeDetailUrls(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RateFeeDetailURLApiFactory = RateFeeDetailURLApiFactory;
/**
 * RateFeeDetailURLApi - object-oriented interface
 * @export
 * @class RateFeeDetailURLApi
 * @extends {BaseAPI}
 */
var RateFeeDetailURLApi = /** @class */ (function (_super) {
    __extends(RateFeeDetailURLApi, _super);
    function RateFeeDetailURLApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add a new rateFeeDetailUrl for a credit card, replacing any existing value for that `cardName`
     * @summary Add a new rateFeeDetailUrl for a credit card
     * @param {RateFeeDetailURLApiCreateRateFeeDetailUrlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateFeeDetailURLApi
     */
    RateFeeDetailURLApi.prototype.createRateFeeDetailUrls = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RateFeeDetailURLApiFp)(this.configuration).createRateFeeDetailUrls(requestParameters.rateFeeDetailUrlCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a rate fee detail URL for a credit card
     * @summary Delete a rate fee detail URL for a credit card
     * @param {RateFeeDetailURLApiDeleteRateFeeDetailUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateFeeDetailURLApi
     */
    RateFeeDetailURLApi.prototype.deleteRateFeeDetailUrl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateFeeDetailURLApiFp)(this.configuration).deleteRateFeeDetailUrl(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the partner-provided URLs for viewing rate and fee information for credit cards
     * @summary Get rate fee detail URLs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateFeeDetailURLApi
     */
    RateFeeDetailURLApi.prototype.getRateFeeDetailUrls = function (options) {
        var _this = this;
        return (0, exports.RateFeeDetailURLApiFp)(this.configuration).getRateFeeDetailUrls(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RateFeeDetailURLApi;
}(base_1.BaseAPI));
exports.RateFeeDetailURLApi = RateFeeDetailURLApi;
/**
 * RateTableApi - axios parameter creator
 * @export
 */
var RateTableApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a `RateTable` of offers sourced from the Offer Catalog
         * @summary Create a `RateTable` of offers sourced from the Offer Catalog
         * @param {LeadResponseJson} [leadResponseJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBasicRateTable: function (leadResponseJson_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([leadResponseJson_1], args_1, true), void 0, function (leadResponseJson, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/offerCatalogRateTables";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:create"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(leadResponseJson, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a rate Table
         * @summary Create a rate table
         * @param {LeadResponseJson} [leadResponseJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTable: function (leadResponseJson_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([leadResponseJson_1], args_1, true), void 0, function (leadResponseJson, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rateTables";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:create"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(leadResponseJson, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a rate table for the specified lead UUID, supply sub-account and offer IDs.
         * @summary Create a rate table with offers
         * @param {RateTableRecordCreateData} [rateTableRecordCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableWithOffers: function (rateTableRecordCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableRecordCreateData_1], args_1, true), void 0, function (rateTableRecordCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/rateTables";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rateTableRecordCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the lead uuids for leads that have a rate tables with at least one first look loan approval
         * @summary Get lead uuids for leads that have a rate tables with at least one first look loan approval
         * @param {Array<string>} leadUuids
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [offset]
         * @param {string} [sortBy]
         * @param {string} [order]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadUuidsWithFirstLookLoanApprovals: function (leadUuids_1, limit_1, id_1, offset_1, sortBy_1, order_1, createdAtMin_1, createdAtMax_1, createdBy_1) {
            var args_1 = [];
            for (var _i = 9; _i < arguments.length; _i++) {
                args_1[_i - 9] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([leadUuids_1, limit_1, id_1, offset_1, sortBy_1, order_1, createdAtMin_1, createdAtMax_1, createdBy_1], args_1, true), void 0, function (leadUuids, limit, id, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'leadUuids' is not null or undefined
                            (0, common_1.assertParamExists)('getLeadUuidsWithFirstLookLoanApprovals', 'leadUuids', leadUuids);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getLeadUuidsWithFirstLookLoanApprovals', 'limit', limit);
                            localVarPath = "/admin/rateTables/leadUuidsWithFirstLookLoanApprovals";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (leadUuids) {
                                localVarQueryParameter['leadUuids'] = leadUuids;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (offset) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a rate table by UUID
         * @summary Get a rate table
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTable: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTable', 'uuid', uuid);
                            localVarPath = "/rateTables/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:read", "originator:rate_table:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a rate tablesourced from the OfferCatalog by UUID
         * @summary Get a rate table sourced from the OfferCatalog
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableOfferCatalog: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTableOfferCatalog', 'uuid', uuid);
                            localVarPath = "/offerCatalogRateTables/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:read", "originator:rate_table:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a rate table timeline
         * @summary Get rate table timeline
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableTimeline: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTableTimeline', 'uuid', uuid);
                            localVarPath = "/admin/rateTableTimelines/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get rate tables
         * @summary Get rate tables
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [offerId]
         * @param {Array<number>} [id]
         * @param {Array<number>} [minId]
         * @param {Array<number>} [maxId]
         * @param {Array<number>} [offset]
         * @param {string} [sortBy]
         * @param {string} [order]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [snapshotAt]
         * @param {boolean} [pendingNonBlockingResponses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTables: function (limit_1, leadUuid_1, uuid_1, offerId_1, id_1, minId_1, maxId_1, offset_1, sortBy_1, order_1, createdAtMin_1, createdAtMax_1, createdBy_1, snapshotAt_1, pendingNonBlockingResponses_1) {
            var args_1 = [];
            for (var _i = 15; _i < arguments.length; _i++) {
                args_1[_i - 15] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, leadUuid_1, uuid_1, offerId_1, id_1, minId_1, maxId_1, offset_1, sortBy_1, order_1, createdAtMin_1, createdAtMax_1, createdBy_1, snapshotAt_1, pendingNonBlockingResponses_1], args_1, true), void 0, function (limit, leadUuid, uuid, offerId, id, minId, maxId, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, snapshotAt, pendingNonBlockingResponses, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTables', 'limit', limit);
                            localVarPath = "/admin/rateTables";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (offerId) {
                                localVarQueryParameter['offerId'] = offerId;
                            }
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (minId) {
                                localVarQueryParameter['minId'] = minId;
                            }
                            if (maxId) {
                                localVarQueryParameter['maxId'] = maxId;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (snapshotAt !== undefined) {
                                localVarQueryParameter['snapshotAt'] = (snapshotAt instanceof Date) ?
                                    snapshotAt.toISOString() :
                                    snapshotAt;
                            }
                            if (pendingNonBlockingResponses !== undefined) {
                                localVarQueryParameter['pendingNonBlockingResponses'] = pendingNonBlockingResponses;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get rate tables (deprecated)
         * @summary Get rate tables (deprecated)
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [offerId]
         * @param {Array<number>} [id]
         * @param {Array<number>} [minId]
         * @param {Array<number>} [maxId]
         * @param {Array<number>} [offset]
         * @param {string} [sortBy]
         * @param {string} [order]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [snapshotAt]
         * @param {boolean} [pendingNonBlockingResponses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTablesNew: function (limit_1, leadUuid_1, uuid_1, offerId_1, id_1, minId_1, maxId_1, offset_1, sortBy_1, order_1, createdAtMin_1, createdAtMax_1, createdBy_1, snapshotAt_1, pendingNonBlockingResponses_1) {
            var args_1 = [];
            for (var _i = 15; _i < arguments.length; _i++) {
                args_1[_i - 15] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, leadUuid_1, uuid_1, offerId_1, id_1, minId_1, maxId_1, offset_1, sortBy_1, order_1, createdAtMin_1, createdAtMax_1, createdBy_1, snapshotAt_1, pendingNonBlockingResponses_1], args_1, true), void 0, function (limit, leadUuid, uuid, offerId, id, minId, maxId, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, snapshotAt, pendingNonBlockingResponses, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTablesNew', 'limit', limit);
                            localVarPath = "/admin/rateTablesNew";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (offerId) {
                                localVarQueryParameter['offerId'] = offerId;
                            }
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (minId) {
                                localVarQueryParameter['minId'] = minId;
                            }
                            if (maxId) {
                                localVarQueryParameter['maxId'] = maxId;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (snapshotAt !== undefined) {
                                localVarQueryParameter['snapshotAt'] = (snapshotAt instanceof Date) ?
                                    snapshotAt.toISOString() :
                                    snapshotAt;
                            }
                            if (pendingNonBlockingResponses !== undefined) {
                                localVarQueryParameter['pendingNonBlockingResponses'] = pendingNonBlockingResponses;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RateTableApiAxiosParamCreator = RateTableApiAxiosParamCreator;
/**
 * RateTableApi - functional programming interface
 * @export
 */
var RateTableApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RateTableApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a `RateTable` of offers sourced from the Offer Catalog
         * @summary Create a `RateTable` of offers sourced from the Offer Catalog
         * @param {LeadResponseJson} [leadResponseJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBasicRateTable: function (leadResponseJson, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBasicRateTable(leadResponseJson, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.createBasicRateTable']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a rate Table
         * @summary Create a rate table
         * @param {LeadResponseJson} [leadResponseJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTable: function (leadResponseJson, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRateTable(leadResponseJson, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.createRateTable']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a rate table for the specified lead UUID, supply sub-account and offer IDs.
         * @summary Create a rate table with offers
         * @param {RateTableRecordCreateData} [rateTableRecordCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableWithOffers: function (rateTableRecordCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRateTableWithOffers(rateTableRecordCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.createRateTableWithOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns the lead uuids for leads that have a rate tables with at least one first look loan approval
         * @summary Get lead uuids for leads that have a rate tables with at least one first look loan approval
         * @param {Array<string>} leadUuids
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [offset]
         * @param {string} [sortBy]
         * @param {string} [order]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadUuidsWithFirstLookLoanApprovals: function (leadUuids, limit, id, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLeadUuidsWithFirstLookLoanApprovals(leadUuids, limit, id, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.getLeadUuidsWithFirstLookLoanApprovals']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a rate table by UUID
         * @summary Get a rate table
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTable: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTable(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.getRateTable']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a rate tablesourced from the OfferCatalog by UUID
         * @summary Get a rate table sourced from the OfferCatalog
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableOfferCatalog: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTableOfferCatalog(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.getRateTableOfferCatalog']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a rate table timeline
         * @summary Get rate table timeline
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableTimeline: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTableTimeline(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.getRateTableTimeline']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get rate tables
         * @summary Get rate tables
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [offerId]
         * @param {Array<number>} [id]
         * @param {Array<number>} [minId]
         * @param {Array<number>} [maxId]
         * @param {Array<number>} [offset]
         * @param {string} [sortBy]
         * @param {string} [order]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [snapshotAt]
         * @param {boolean} [pendingNonBlockingResponses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTables: function (limit, leadUuid, uuid, offerId, id, minId, maxId, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, snapshotAt, pendingNonBlockingResponses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTables(limit, leadUuid, uuid, offerId, id, minId, maxId, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, snapshotAt, pendingNonBlockingResponses, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.getRateTables']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get rate tables (deprecated)
         * @summary Get rate tables (deprecated)
         * @param {number} limit
         * @param {Array<string>} [leadUuid]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [offerId]
         * @param {Array<number>} [id]
         * @param {Array<number>} [minId]
         * @param {Array<number>} [maxId]
         * @param {Array<number>} [offset]
         * @param {string} [sortBy]
         * @param {string} [order]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [snapshotAt]
         * @param {boolean} [pendingNonBlockingResponses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTablesNew: function (limit, leadUuid, uuid, offerId, id, minId, maxId, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, snapshotAt, pendingNonBlockingResponses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTablesNew(limit, leadUuid, uuid, offerId, id, minId, maxId, offset, sortBy, order, createdAtMin, createdAtMax, createdBy, snapshotAt, pendingNonBlockingResponses, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableApi.getRateTablesNew']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RateTableApiFp = RateTableApiFp;
/**
 * RateTableApi - factory interface
 * @export
 */
var RateTableApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RateTableApiFp)(configuration);
    return {
        /**
         * Create a `RateTable` of offers sourced from the Offer Catalog
         * @summary Create a `RateTable` of offers sourced from the Offer Catalog
         * @param {RateTableApiCreateBasicRateTableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBasicRateTable: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createBasicRateTable(requestParameters.leadResponseJson, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a rate Table
         * @summary Create a rate table
         * @param {RateTableApiCreateRateTableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTable: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createRateTable(requestParameters.leadResponseJson, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a rate table for the specified lead UUID, supply sub-account and offer IDs.
         * @summary Create a rate table with offers
         * @param {RateTableApiCreateRateTableWithOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableWithOffers: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createRateTableWithOffers(requestParameters.rateTableRecordCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the lead uuids for leads that have a rate tables with at least one first look loan approval
         * @summary Get lead uuids for leads that have a rate tables with at least one first look loan approval
         * @param {RateTableApiGetLeadUuidsWithFirstLookLoanApprovalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadUuidsWithFirstLookLoanApprovals: function (requestParameters, options) {
            return localVarFp.getLeadUuidsWithFirstLookLoanApprovals(requestParameters.leadUuids, requestParameters.limit, requestParameters.id, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a rate table by UUID
         * @summary Get a rate table
         * @param {RateTableApiGetRateTableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTable: function (requestParameters, options) {
            return localVarFp.getRateTable(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a rate tablesourced from the OfferCatalog by UUID
         * @summary Get a rate table sourced from the OfferCatalog
         * @param {RateTableApiGetRateTableOfferCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableOfferCatalog: function (requestParameters, options) {
            return localVarFp.getRateTableOfferCatalog(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a rate table timeline
         * @summary Get rate table timeline
         * @param {RateTableApiGetRateTableTimelineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableTimeline: function (requestParameters, options) {
            return localVarFp.getRateTableTimeline(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get rate tables
         * @summary Get rate tables
         * @param {RateTableApiGetRateTablesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTables: function (requestParameters, options) {
            return localVarFp.getRateTables(requestParameters.limit, requestParameters.leadUuid, requestParameters.uuid, requestParameters.offerId, requestParameters.id, requestParameters.minId, requestParameters.maxId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.snapshotAt, requestParameters.pendingNonBlockingResponses, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get rate tables (deprecated)
         * @summary Get rate tables (deprecated)
         * @param {RateTableApiGetRateTablesNewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTablesNew: function (requestParameters, options) {
            return localVarFp.getRateTablesNew(requestParameters.limit, requestParameters.leadUuid, requestParameters.uuid, requestParameters.offerId, requestParameters.id, requestParameters.minId, requestParameters.maxId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.snapshotAt, requestParameters.pendingNonBlockingResponses, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RateTableApiFactory = RateTableApiFactory;
/**
 * RateTableApi - object-oriented interface
 * @export
 * @class RateTableApi
 * @extends {BaseAPI}
 */
var RateTableApi = /** @class */ (function (_super) {
    __extends(RateTableApi, _super);
    function RateTableApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a `RateTable` of offers sourced from the Offer Catalog
     * @summary Create a `RateTable` of offers sourced from the Offer Catalog
     * @param {RateTableApiCreateBasicRateTableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.createBasicRateTable = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RateTableApiFp)(this.configuration).createBasicRateTable(requestParameters.leadResponseJson, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a rate Table
     * @summary Create a rate table
     * @param {RateTableApiCreateRateTableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.createRateTable = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RateTableApiFp)(this.configuration).createRateTable(requestParameters.leadResponseJson, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a rate table for the specified lead UUID, supply sub-account and offer IDs.
     * @summary Create a rate table with offers
     * @param {RateTableApiCreateRateTableWithOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.createRateTableWithOffers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RateTableApiFp)(this.configuration).createRateTableWithOffers(requestParameters.rateTableRecordCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the lead uuids for leads that have a rate tables with at least one first look loan approval
     * @summary Get lead uuids for leads that have a rate tables with at least one first look loan approval
     * @param {RateTableApiGetLeadUuidsWithFirstLookLoanApprovalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.getLeadUuidsWithFirstLookLoanApprovals = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTableApiFp)(this.configuration).getLeadUuidsWithFirstLookLoanApprovals(requestParameters.leadUuids, requestParameters.limit, requestParameters.id, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a rate table by UUID
     * @summary Get a rate table
     * @param {RateTableApiGetRateTableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.getRateTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTableApiFp)(this.configuration).getRateTable(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a rate tablesourced from the OfferCatalog by UUID
     * @summary Get a rate table sourced from the OfferCatalog
     * @param {RateTableApiGetRateTableOfferCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.getRateTableOfferCatalog = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTableApiFp)(this.configuration).getRateTableOfferCatalog(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a rate table timeline
     * @summary Get rate table timeline
     * @param {RateTableApiGetRateTableTimelineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.getRateTableTimeline = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTableApiFp)(this.configuration).getRateTableTimeline(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get rate tables
     * @summary Get rate tables
     * @param {RateTableApiGetRateTablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.getRateTables = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTableApiFp)(this.configuration).getRateTables(requestParameters.limit, requestParameters.leadUuid, requestParameters.uuid, requestParameters.offerId, requestParameters.id, requestParameters.minId, requestParameters.maxId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.snapshotAt, requestParameters.pendingNonBlockingResponses, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get rate tables (deprecated)
     * @summary Get rate tables (deprecated)
     * @param {RateTableApiGetRateTablesNewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableApi
     */
    RateTableApi.prototype.getRateTablesNew = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTableApiFp)(this.configuration).getRateTablesNew(requestParameters.limit, requestParameters.leadUuid, requestParameters.uuid, requestParameters.offerId, requestParameters.id, requestParameters.minId, requestParameters.maxId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.snapshotAt, requestParameters.pendingNonBlockingResponses, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RateTableApi;
}(base_1.BaseAPI));
exports.RateTableApi = RateTableApi;
/**
 * RateTableAuditApi - axios parameter creator
 * @export
 */
var RateTableAuditApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get rate table audits
         * @summary Get rate table audits
         * @param {number} limit
         * @param {Array<string>} [rateTableUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableAudits: function (limit_1, rateTableUuid_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, rateTableUuid_1], args_1, true), void 0, function (limit, rateTableUuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTableAudits', 'limit', limit);
                            localVarPath = "/rateTableAudits";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (rateTableUuid) {
                                localVarQueryParameter['rateTableUuid'] = rateTableUuid;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RateTableAuditApiAxiosParamCreator = RateTableAuditApiAxiosParamCreator;
/**
 * RateTableAuditApi - functional programming interface
 * @export
 */
var RateTableAuditApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RateTableAuditApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get rate table audits
         * @summary Get rate table audits
         * @param {number} limit
         * @param {Array<string>} [rateTableUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableAudits: function (limit, rateTableUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTableAudits(limit, rateTableUuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableAuditApi.getRateTableAudits']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RateTableAuditApiFp = RateTableAuditApiFp;
/**
 * RateTableAuditApi - factory interface
 * @export
 */
var RateTableAuditApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RateTableAuditApiFp)(configuration);
    return {
        /**
         * Get rate table audits
         * @summary Get rate table audits
         * @param {RateTableAuditApiGetRateTableAuditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableAudits: function (requestParameters, options) {
            return localVarFp.getRateTableAudits(requestParameters.limit, requestParameters.rateTableUuid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RateTableAuditApiFactory = RateTableAuditApiFactory;
/**
 * RateTableAuditApi - object-oriented interface
 * @export
 * @class RateTableAuditApi
 * @extends {BaseAPI}
 */
var RateTableAuditApi = /** @class */ (function (_super) {
    __extends(RateTableAuditApi, _super);
    function RateTableAuditApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get rate table audits
     * @summary Get rate table audits
     * @param {RateTableAuditApiGetRateTableAuditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableAuditApi
     */
    RateTableAuditApi.prototype.getRateTableAudits = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTableAuditApiFp)(this.configuration).getRateTableAudits(requestParameters.limit, requestParameters.rateTableUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RateTableAuditApi;
}(base_1.BaseAPI));
exports.RateTableAuditApi = RateTableAuditApi;
/**
 * RateTableSnapshotApi - axios parameter creator
 * @export
 */
var RateTableSnapshotApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns the lead for a given Rate Table uuid
         * @summary Get Rate Table Lead snapshots
         * @param {Array<string>} [rateTableUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableLeadSnapshots: function (rateTableUuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableUuid_1], args_1, true), void 0, function (rateTableUuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/rateTableLeadSnapshots";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (rateTableUuid) {
                                localVarQueryParameter['rateTableUuid'] = rateTableUuid;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RateTableSnapshotApiAxiosParamCreator = RateTableSnapshotApiAxiosParamCreator;
/**
 * RateTableSnapshotApi - functional programming interface
 * @export
 */
var RateTableSnapshotApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RateTableSnapshotApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns the lead for a given Rate Table uuid
         * @summary Get Rate Table Lead snapshots
         * @param {Array<string>} [rateTableUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableLeadSnapshots: function (rateTableUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTableLeadSnapshots(rateTableUuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTableSnapshotApi.getRateTableLeadSnapshots']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RateTableSnapshotApiFp = RateTableSnapshotApiFp;
/**
 * RateTableSnapshotApi - factory interface
 * @export
 */
var RateTableSnapshotApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RateTableSnapshotApiFp)(configuration);
    return {
        /**
         * Returns the lead for a given Rate Table uuid
         * @summary Get Rate Table Lead snapshots
         * @param {RateTableSnapshotApiGetRateTableLeadSnapshotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableLeadSnapshots: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getRateTableLeadSnapshots(requestParameters.rateTableUuid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RateTableSnapshotApiFactory = RateTableSnapshotApiFactory;
/**
 * RateTableSnapshotApi - object-oriented interface
 * @export
 * @class RateTableSnapshotApi
 * @extends {BaseAPI}
 */
var RateTableSnapshotApi = /** @class */ (function (_super) {
    __extends(RateTableSnapshotApi, _super);
    function RateTableSnapshotApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the lead for a given Rate Table uuid
     * @summary Get Rate Table Lead snapshots
     * @param {RateTableSnapshotApiGetRateTableLeadSnapshotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTableSnapshotApi
     */
    RateTableSnapshotApi.prototype.getRateTableLeadSnapshots = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RateTableSnapshotApiFp)(this.configuration).getRateTableLeadSnapshots(requestParameters.rateTableUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RateTableSnapshotApi;
}(base_1.BaseAPI));
exports.RateTableSnapshotApi = RateTableSnapshotApi;
/**
 * RuleDemandAPIFilterApi - axios parameter creator
 * @export
 */
var RuleDemandAPIFilterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create rule demand API filters
         * @summary Create rule demand API filters
         * @param {RuleDemandApiFilterCreateData} ruleDemandApiFilterCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleDemandApiFilters: function (ruleDemandApiFilterCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ruleDemandApiFilterCreateData_1], args_1, true), void 0, function (ruleDemandApiFilterCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleDemandApiFilterCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createRuleDemandApiFilters', 'ruleDemandApiFilterCreateData', ruleDemandApiFilterCreateData);
                            localVarPath = "/admin/ruleDemandApiFilters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ruleDemandApiFilterCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a rule demand api filter
         * @summary Delete a rule demand api filter
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleDemandApiFilter: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRuleDemandApiFilter', 'id', id);
                            localVarPath = "/admin/ruleDemandApiFilters/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get rule demand API filters
         * @summary Get rule demand API filters
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma seperated list of Demand Sub Account ids
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {Array<number>} [supplySubAccountId] A comma seperated list of Supply Sub Account ids
         * @param {Array<State>} [state] A comma seperated list of States
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {string} [deletedBy]
         * @param {boolean} [isDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleDemandApiFilters: function (limit_1, id_1, demandSubAccountId_1, excludeDeleted_1, supplySubAccountId_1, state_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, deletedBy_1, isDeleted_1, offset_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, demandSubAccountId_1, excludeDeleted_1, supplySubAccountId_1, state_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, deletedBy_1, isDeleted_1, offset_1], args_1, true), void 0, function (limit, id, demandSubAccountId, excludeDeleted, supplySubAccountId, state, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, deletedBy, isDeleted, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getRuleDemandApiFilters', 'limit', limit);
                            localVarPath = "/admin/ruleDemandApiFilters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (state) {
                                localVarQueryParameter['state'] = state.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (deletedBy !== undefined) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RuleDemandAPIFilterApiAxiosParamCreator = RuleDemandAPIFilterApiAxiosParamCreator;
/**
 * RuleDemandAPIFilterApi - functional programming interface
 * @export
 */
var RuleDemandAPIFilterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RuleDemandAPIFilterApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create rule demand API filters
         * @summary Create rule demand API filters
         * @param {RuleDemandApiFilterCreateData} ruleDemandApiFilterCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleDemandApiFilters: function (ruleDemandApiFilterCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRuleDemandApiFilters(ruleDemandApiFilterCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RuleDemandAPIFilterApi.createRuleDemandApiFilters']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a rule demand api filter
         * @summary Delete a rule demand api filter
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleDemandApiFilter: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRuleDemandApiFilter(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RuleDemandAPIFilterApi.deleteRuleDemandApiFilter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get rule demand API filters
         * @summary Get rule demand API filters
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma seperated list of Demand Sub Account ids
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {Array<number>} [supplySubAccountId] A comma seperated list of Supply Sub Account ids
         * @param {Array<State>} [state] A comma seperated list of States
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {string} [deletedBy]
         * @param {boolean} [isDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleDemandApiFilters: function (limit, id, demandSubAccountId, excludeDeleted, supplySubAccountId, state, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, deletedBy, isDeleted, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRuleDemandApiFilters(limit, id, demandSubAccountId, excludeDeleted, supplySubAccountId, state, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, deletedBy, isDeleted, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RuleDemandAPIFilterApi.getRuleDemandApiFilters']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RuleDemandAPIFilterApiFp = RuleDemandAPIFilterApiFp;
/**
 * RuleDemandAPIFilterApi - factory interface
 * @export
 */
var RuleDemandAPIFilterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RuleDemandAPIFilterApiFp)(configuration);
    return {
        /**
         * Create rule demand API filters
         * @summary Create rule demand API filters
         * @param {RuleDemandAPIFilterApiCreateRuleDemandApiFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleDemandApiFilters: function (requestParameters, options) {
            return localVarFp.createRuleDemandApiFilters(requestParameters.ruleDemandApiFilterCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a rule demand api filter
         * @summary Delete a rule demand api filter
         * @param {RuleDemandAPIFilterApiDeleteRuleDemandApiFilterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleDemandApiFilter: function (requestParameters, options) {
            return localVarFp.deleteRuleDemandApiFilter(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get rule demand API filters
         * @summary Get rule demand API filters
         * @param {RuleDemandAPIFilterApiGetRuleDemandApiFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleDemandApiFilters: function (requestParameters, options) {
            return localVarFp.getRuleDemandApiFilters(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.excludeDeleted, requestParameters.supplySubAccountId, requestParameters.state, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.deletedBy, requestParameters.isDeleted, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RuleDemandAPIFilterApiFactory = RuleDemandAPIFilterApiFactory;
/**
 * RuleDemandAPIFilterApi - object-oriented interface
 * @export
 * @class RuleDemandAPIFilterApi
 * @extends {BaseAPI}
 */
var RuleDemandAPIFilterApi = /** @class */ (function (_super) {
    __extends(RuleDemandAPIFilterApi, _super);
    function RuleDemandAPIFilterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create rule demand API filters
     * @summary Create rule demand API filters
     * @param {RuleDemandAPIFilterApiCreateRuleDemandApiFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleDemandAPIFilterApi
     */
    RuleDemandAPIFilterApi.prototype.createRuleDemandApiFilters = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RuleDemandAPIFilterApiFp)(this.configuration).createRuleDemandApiFilters(requestParameters.ruleDemandApiFilterCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a rule demand api filter
     * @summary Delete a rule demand api filter
     * @param {RuleDemandAPIFilterApiDeleteRuleDemandApiFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleDemandAPIFilterApi
     */
    RuleDemandAPIFilterApi.prototype.deleteRuleDemandApiFilter = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RuleDemandAPIFilterApiFp)(this.configuration).deleteRuleDemandApiFilter(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get rule demand API filters
     * @summary Get rule demand API filters
     * @param {RuleDemandAPIFilterApiGetRuleDemandApiFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleDemandAPIFilterApi
     */
    RuleDemandAPIFilterApi.prototype.getRuleDemandApiFilters = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RuleDemandAPIFilterApiFp)(this.configuration).getRuleDemandApiFilters(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.excludeDeleted, requestParameters.supplySubAccountId, requestParameters.state, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.deletedBy, requestParameters.isDeleted, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RuleDemandAPIFilterApi;
}(base_1.BaseAPI));
exports.RuleDemandAPIFilterApi = RuleDemandAPIFilterApi;
/**
 * SecondLookConfigurationApi - axios parameter creator
 * @export
 */
var SecondLookConfigurationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a second look configuration
         * @summary Create a second look configuration
         * @param {SecondLookConfigurationCreateData} [secondLookConfigurationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondLookConfiguration: function (secondLookConfigurationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([secondLookConfigurationCreateData_1], args_1, true), void 0, function (secondLookConfigurationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/secondLookConfigurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(secondLookConfigurationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get second look configurations
         * @summary Get second look configurations
         * @param {number} limit
         * @param {Array<number>} [ids]
         * @param {Array<number>} [demandSubAccountId] A comma-separated list of one or more sub account IDs
         * @param {Array<number>} [supplySubAccountId] A comma-separated list of one or more sub account IDs
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondLookConfigurations: function (limit_1, ids_1, demandSubAccountId_1, supplySubAccountId_1, excludeDeleted_1, offset_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, ids_1, demandSubAccountId_1, supplySubAccountId_1, excludeDeleted_1, offset_1], args_1, true), void 0, function (limit, ids, demandSubAccountId, supplySubAccountId, excludeDeleted, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSecondLookConfigurations', 'limit', limit);
                            localVarPath = "/admin/secondLookConfigurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (ids) {
                                localVarQueryParameter['ids'] = ids;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SecondLookConfigurationApiAxiosParamCreator = SecondLookConfigurationApiAxiosParamCreator;
/**
 * SecondLookConfigurationApi - functional programming interface
 * @export
 */
var SecondLookConfigurationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SecondLookConfigurationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a second look configuration
         * @summary Create a second look configuration
         * @param {SecondLookConfigurationCreateData} [secondLookConfigurationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondLookConfiguration: function (secondLookConfigurationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSecondLookConfiguration(secondLookConfigurationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SecondLookConfigurationApi.createSecondLookConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get second look configurations
         * @summary Get second look configurations
         * @param {number} limit
         * @param {Array<number>} [ids]
         * @param {Array<number>} [demandSubAccountId] A comma-separated list of one or more sub account IDs
         * @param {Array<number>} [supplySubAccountId] A comma-separated list of one or more sub account IDs
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondLookConfigurations: function (limit, ids, demandSubAccountId, supplySubAccountId, excludeDeleted, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSecondLookConfigurations(limit, ids, demandSubAccountId, supplySubAccountId, excludeDeleted, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SecondLookConfigurationApi.getSecondLookConfigurations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SecondLookConfigurationApiFp = SecondLookConfigurationApiFp;
/**
 * SecondLookConfigurationApi - factory interface
 * @export
 */
var SecondLookConfigurationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SecondLookConfigurationApiFp)(configuration);
    return {
        /**
         * Create a second look configuration
         * @summary Create a second look configuration
         * @param {SecondLookConfigurationApiCreateSecondLookConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondLookConfiguration: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSecondLookConfiguration(requestParameters.secondLookConfigurationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get second look configurations
         * @summary Get second look configurations
         * @param {SecondLookConfigurationApiGetSecondLookConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondLookConfigurations: function (requestParameters, options) {
            return localVarFp.getSecondLookConfigurations(requestParameters.limit, requestParameters.ids, requestParameters.demandSubAccountId, requestParameters.supplySubAccountId, requestParameters.excludeDeleted, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SecondLookConfigurationApiFactory = SecondLookConfigurationApiFactory;
/**
 * SecondLookConfigurationApi - object-oriented interface
 * @export
 * @class SecondLookConfigurationApi
 * @extends {BaseAPI}
 */
var SecondLookConfigurationApi = /** @class */ (function (_super) {
    __extends(SecondLookConfigurationApi, _super);
    function SecondLookConfigurationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a second look configuration
     * @summary Create a second look configuration
     * @param {SecondLookConfigurationApiCreateSecondLookConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondLookConfigurationApi
     */
    SecondLookConfigurationApi.prototype.createSecondLookConfiguration = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SecondLookConfigurationApiFp)(this.configuration).createSecondLookConfiguration(requestParameters.secondLookConfigurationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get second look configurations
     * @summary Get second look configurations
     * @param {SecondLookConfigurationApiGetSecondLookConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondLookConfigurationApi
     */
    SecondLookConfigurationApi.prototype.getSecondLookConfigurations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SecondLookConfigurationApiFp)(this.configuration).getSecondLookConfigurations(requestParameters.limit, requestParameters.ids, requestParameters.demandSubAccountId, requestParameters.supplySubAccountId, requestParameters.excludeDeleted, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SecondLookConfigurationApi;
}(base_1.BaseAPI));
exports.SecondLookConfigurationApi = SecondLookConfigurationApi;
/**
 * SecondLookOffersConfigurationsApi - axios parameter creator
 * @export
 */
var SecondLookOffersConfigurationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create second look offers configuration
         * @summary Create second look offers configuration
         * @param {SecondLookOfferConfigurationCreateData} [secondLookOfferConfigurationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondLookOfferConfiguration: function (secondLookOfferConfigurationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([secondLookOfferConfigurationCreateData_1], args_1, true), void 0, function (secondLookOfferConfigurationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/secondLookOfferConfigurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(secondLookOfferConfigurationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get second look offers configurations by supply sub account id
         * @summary Get second look offers configurations
         * @param {number} supplySubAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondLookOfferConfigurations: function (supplySubAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplySubAccountId_1], args_1, true), void 0, function (supplySubAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplySubAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('getSecondLookOfferConfigurations', 'supplySubAccountId', supplySubAccountId);
                            localVarPath = "/admin/secondLookOfferConfigurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (supplySubAccountId !== undefined) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SecondLookOffersConfigurationsApiAxiosParamCreator = SecondLookOffersConfigurationsApiAxiosParamCreator;
/**
 * SecondLookOffersConfigurationsApi - functional programming interface
 * @export
 */
var SecondLookOffersConfigurationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SecondLookOffersConfigurationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create second look offers configuration
         * @summary Create second look offers configuration
         * @param {SecondLookOfferConfigurationCreateData} [secondLookOfferConfigurationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondLookOfferConfiguration: function (secondLookOfferConfigurationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSecondLookOfferConfiguration(secondLookOfferConfigurationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SecondLookOffersConfigurationsApi.createSecondLookOfferConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get second look offers configurations by supply sub account id
         * @summary Get second look offers configurations
         * @param {number} supplySubAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondLookOfferConfigurations: function (supplySubAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSecondLookOfferConfigurations(supplySubAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SecondLookOffersConfigurationsApi.getSecondLookOfferConfigurations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SecondLookOffersConfigurationsApiFp = SecondLookOffersConfigurationsApiFp;
/**
 * SecondLookOffersConfigurationsApi - factory interface
 * @export
 */
var SecondLookOffersConfigurationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SecondLookOffersConfigurationsApiFp)(configuration);
    return {
        /**
         * Create second look offers configuration
         * @summary Create second look offers configuration
         * @param {SecondLookOffersConfigurationsApiCreateSecondLookOfferConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondLookOfferConfiguration: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSecondLookOfferConfiguration(requestParameters.secondLookOfferConfigurationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get second look offers configurations by supply sub account id
         * @summary Get second look offers configurations
         * @param {SecondLookOffersConfigurationsApiGetSecondLookOfferConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondLookOfferConfigurations: function (requestParameters, options) {
            return localVarFp.getSecondLookOfferConfigurations(requestParameters.supplySubAccountId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SecondLookOffersConfigurationsApiFactory = SecondLookOffersConfigurationsApiFactory;
/**
 * SecondLookOffersConfigurationsApi - object-oriented interface
 * @export
 * @class SecondLookOffersConfigurationsApi
 * @extends {BaseAPI}
 */
var SecondLookOffersConfigurationsApi = /** @class */ (function (_super) {
    __extends(SecondLookOffersConfigurationsApi, _super);
    function SecondLookOffersConfigurationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create second look offers configuration
     * @summary Create second look offers configuration
     * @param {SecondLookOffersConfigurationsApiCreateSecondLookOfferConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondLookOffersConfigurationsApi
     */
    SecondLookOffersConfigurationsApi.prototype.createSecondLookOfferConfiguration = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SecondLookOffersConfigurationsApiFp)(this.configuration).createSecondLookOfferConfiguration(requestParameters.secondLookOfferConfigurationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get second look offers configurations by supply sub account id
     * @summary Get second look offers configurations
     * @param {SecondLookOffersConfigurationsApiGetSecondLookOfferConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondLookOffersConfigurationsApi
     */
    SecondLookOffersConfigurationsApi.prototype.getSecondLookOfferConfigurations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SecondLookOffersConfigurationsApiFp)(this.configuration).getSecondLookOfferConfigurations(requestParameters.supplySubAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SecondLookOffersConfigurationsApi;
}(base_1.BaseAPI));
exports.SecondLookOffersConfigurationsApi = SecondLookOffersConfigurationsApi;
/**
 * StaticOfferApi - axios parameter creator
 * @export
 */
var StaticOfferApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a static offer payout floor
         * @summary Create a static offer payout floor
         * @param {StaticOfferPayoutFloorCreateData} staticOfferPayoutFloorCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferPayoutFloor: function (staticOfferPayoutFloorCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([staticOfferPayoutFloorCreateData_1], args_1, true), void 0, function (staticOfferPayoutFloorCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'staticOfferPayoutFloorCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createStaticOfferPayoutFloor', 'staticOfferPayoutFloorCreateData', staticOfferPayoutFloorCreateData);
                            localVarPath = "/admin/staticOfferPayoutFloors";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(staticOfferPayoutFloorCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a static offer payout floor
         * @summary Delete a static offer payout floor
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferPayoutFloor: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteStaticOfferPayoutFloor', 'id', id);
                            localVarPath = "/admin/staticOfferPayoutFloors/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a static offer payout floor by offer id
         * @summary Get a static offer payout floor by offer id
         * @param {number} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferPayoutFloorByOfferId: function (offerId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([offerId_1], args_1, true), void 0, function (offerId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'offerId' is not null or undefined
                            (0, common_1.assertParamExists)('getStaticOfferPayoutFloorByOfferId', 'offerId', offerId);
                            localVarPath = "/admin/staticOffers/{offerId}/payoutFloors"
                                .replace("{".concat("offerId", "}"), encodeURIComponent(String(offerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get static offers
         * @summary Get static offers
         * @param {Array<number>} [id]
         * @param {Array<string>} [offerUuid]
         * @param {string} [name]
         * @param {Array<number>} [offerId]
         * @param {Array<number>} [offerRuleId]
         * @param {string} [productType]
         * @param {Array<number>} [subAccountId]
         * @param {string} [rateTableUuid]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOffers: function (id_1, offerUuid_1, name_1, offerId_1, offerRuleId_1, productType_1, subAccountId_1, rateTableUuid_1, offset_1, limit_1) {
            var args_1 = [];
            for (var _i = 10; _i < arguments.length; _i++) {
                args_1[_i - 10] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, offerUuid_1, name_1, offerId_1, offerRuleId_1, productType_1, subAccountId_1, rateTableUuid_1, offset_1, limit_1], args_1, true), void 0, function (id, offerUuid, name, offerId, offerRuleId, productType, subAccountId, rateTableUuid, offset, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/staticOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (offerUuid) {
                                localVarQueryParameter['offerUuid'] = offerUuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (offerId) {
                                localVarQueryParameter['offerId'] = offerId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (offerRuleId) {
                                localVarQueryParameter['offerRuleId'] = offerRuleId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (productType !== undefined) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (rateTableUuid !== undefined) {
                                localVarQueryParameter['rateTableUuid'] = rateTableUuid;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a static offer payout floor by offer id
         * @summary Update a static offer payout floor by offer id
         * @param {number} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticOfferPayoutFloorByOfferId: function (offerId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([offerId_1], args_1, true), void 0, function (offerId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'offerId' is not null or undefined
                            (0, common_1.assertParamExists)('updateStaticOfferPayoutFloorByOfferId', 'offerId', offerId);
                            localVarPath = "/admin/staticOffers/{offerId}/payoutFloors"
                                .replace("{".concat("offerId", "}"), encodeURIComponent(String(offerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.StaticOfferApiAxiosParamCreator = StaticOfferApiAxiosParamCreator;
/**
 * StaticOfferApi - functional programming interface
 * @export
 */
var StaticOfferApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StaticOfferApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a static offer payout floor
         * @summary Create a static offer payout floor
         * @param {StaticOfferPayoutFloorCreateData} staticOfferPayoutFloorCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferPayoutFloor: function (staticOfferPayoutFloorCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createStaticOfferPayoutFloor(staticOfferPayoutFloorCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferApi.createStaticOfferPayoutFloor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a static offer payout floor
         * @summary Delete a static offer payout floor
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferPayoutFloor: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteStaticOfferPayoutFloor(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferApi.deleteStaticOfferPayoutFloor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a static offer payout floor by offer id
         * @summary Get a static offer payout floor by offer id
         * @param {number} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferPayoutFloorByOfferId: function (offerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOfferPayoutFloorByOfferId(offerId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferApi.getStaticOfferPayoutFloorByOfferId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get static offers
         * @summary Get static offers
         * @param {Array<number>} [id]
         * @param {Array<string>} [offerUuid]
         * @param {string} [name]
         * @param {Array<number>} [offerId]
         * @param {Array<number>} [offerRuleId]
         * @param {string} [productType]
         * @param {Array<number>} [subAccountId]
         * @param {string} [rateTableUuid]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOffers: function (id, offerUuid, name, offerId, offerRuleId, productType, subAccountId, rateTableUuid, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOffers(id, offerUuid, name, offerId, offerRuleId, productType, subAccountId, rateTableUuid, offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferApi.getStaticOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a static offer payout floor by offer id
         * @summary Update a static offer payout floor by offer id
         * @param {number} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticOfferPayoutFloorByOfferId: function (offerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateStaticOfferPayoutFloorByOfferId(offerId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferApi.updateStaticOfferPayoutFloorByOfferId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.StaticOfferApiFp = StaticOfferApiFp;
/**
 * StaticOfferApi - factory interface
 * @export
 */
var StaticOfferApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StaticOfferApiFp)(configuration);
    return {
        /**
         * Create a static offer payout floor
         * @summary Create a static offer payout floor
         * @param {StaticOfferApiCreateStaticOfferPayoutFloorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferPayoutFloor: function (requestParameters, options) {
            return localVarFp.createStaticOfferPayoutFloor(requestParameters.staticOfferPayoutFloorCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a static offer payout floor
         * @summary Delete a static offer payout floor
         * @param {StaticOfferApiDeleteStaticOfferPayoutFloorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferPayoutFloor: function (requestParameters, options) {
            return localVarFp.deleteStaticOfferPayoutFloor(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a static offer payout floor by offer id
         * @summary Get a static offer payout floor by offer id
         * @param {StaticOfferApiGetStaticOfferPayoutFloorByOfferIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferPayoutFloorByOfferId: function (requestParameters, options) {
            return localVarFp.getStaticOfferPayoutFloorByOfferId(requestParameters.offerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get static offers
         * @summary Get static offers
         * @param {StaticOfferApiGetStaticOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOffers: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getStaticOffers(requestParameters.id, requestParameters.offerUuid, requestParameters.name, requestParameters.offerId, requestParameters.offerRuleId, requestParameters.productType, requestParameters.subAccountId, requestParameters.rateTableUuid, requestParameters.offset, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a static offer payout floor by offer id
         * @summary Update a static offer payout floor by offer id
         * @param {StaticOfferApiUpdateStaticOfferPayoutFloorByOfferIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticOfferPayoutFloorByOfferId: function (requestParameters, options) {
            return localVarFp.updateStaticOfferPayoutFloorByOfferId(requestParameters.offerId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StaticOfferApiFactory = StaticOfferApiFactory;
/**
 * StaticOfferApi - object-oriented interface
 * @export
 * @class StaticOfferApi
 * @extends {BaseAPI}
 */
var StaticOfferApi = /** @class */ (function (_super) {
    __extends(StaticOfferApi, _super);
    function StaticOfferApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a static offer payout floor
     * @summary Create a static offer payout floor
     * @param {StaticOfferApiCreateStaticOfferPayoutFloorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferApi
     */
    StaticOfferApi.prototype.createStaticOfferPayoutFloor = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferApiFp)(this.configuration).createStaticOfferPayoutFloor(requestParameters.staticOfferPayoutFloorCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a static offer payout floor
     * @summary Delete a static offer payout floor
     * @param {StaticOfferApiDeleteStaticOfferPayoutFloorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferApi
     */
    StaticOfferApi.prototype.deleteStaticOfferPayoutFloor = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferApiFp)(this.configuration).deleteStaticOfferPayoutFloor(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a static offer payout floor by offer id
     * @summary Get a static offer payout floor by offer id
     * @param {StaticOfferApiGetStaticOfferPayoutFloorByOfferIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferApi
     */
    StaticOfferApi.prototype.getStaticOfferPayoutFloorByOfferId = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferApiFp)(this.configuration).getStaticOfferPayoutFloorByOfferId(requestParameters.offerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get static offers
     * @summary Get static offers
     * @param {StaticOfferApiGetStaticOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferApi
     */
    StaticOfferApi.prototype.getStaticOffers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StaticOfferApiFp)(this.configuration).getStaticOffers(requestParameters.id, requestParameters.offerUuid, requestParameters.name, requestParameters.offerId, requestParameters.offerRuleId, requestParameters.productType, requestParameters.subAccountId, requestParameters.rateTableUuid, requestParameters.offset, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a static offer payout floor by offer id
     * @summary Update a static offer payout floor by offer id
     * @param {StaticOfferApiUpdateStaticOfferPayoutFloorByOfferIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferApi
     */
    StaticOfferApi.prototype.updateStaticOfferPayoutFloorByOfferId = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferApiFp)(this.configuration).updateStaticOfferPayoutFloorByOfferId(requestParameters.offerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StaticOfferApi;
}(base_1.BaseAPI));
exports.StaticOfferApi = StaticOfferApi;
/**
 * StaticOfferDeactivationApi - axios parameter creator
 * @export
 */
var StaticOfferDeactivationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create static offer deactivations
         * @summary Create static offer deactivations
         * @param {StaticOfferDeactivationCreateData} [staticOfferDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferDeactivation: function (staticOfferDeactivationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([staticOfferDeactivationCreateData_1], args_1, true), void 0, function (staticOfferDeactivationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/staticOfferDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(staticOfferDeactivationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a static offer deactivation
         * @summary Delete a static offer deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferDeactivation: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteStaticOfferDeactivation', 'id', id);
                            localVarPath = "/admin/staticOfferDeactivations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return static offer deactivations based upon request parameters
         * @summary Get static offer deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [offerId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferDeactivations: function (limit_1, id_1, offerId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 13; _i < arguments.length; _i++) {
                args_1[_i - 13] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, offerId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, offerId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getStaticOfferDeactivations', 'limit', limit);
                            localVarPath = "/admin/staticOfferDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (offerId) {
                                localVarQueryParameter['offerId'] = offerId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.StaticOfferDeactivationApiAxiosParamCreator = StaticOfferDeactivationApiAxiosParamCreator;
/**
 * StaticOfferDeactivationApi - functional programming interface
 * @export
 */
var StaticOfferDeactivationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StaticOfferDeactivationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create static offer deactivations
         * @summary Create static offer deactivations
         * @param {StaticOfferDeactivationCreateData} [staticOfferDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferDeactivation: function (staticOfferDeactivationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createStaticOfferDeactivation(staticOfferDeactivationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferDeactivationApi.createStaticOfferDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a static offer deactivation
         * @summary Delete a static offer deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferDeactivation: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteStaticOfferDeactivation(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferDeactivationApi.deleteStaticOfferDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return static offer deactivations based upon request parameters
         * @summary Get static offer deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [offerId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferDeactivations: function (limit, id, offerId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOfferDeactivations(limit, id, offerId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferDeactivationApi.getStaticOfferDeactivations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.StaticOfferDeactivationApiFp = StaticOfferDeactivationApiFp;
/**
 * StaticOfferDeactivationApi - factory interface
 * @export
 */
var StaticOfferDeactivationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StaticOfferDeactivationApiFp)(configuration);
    return {
        /**
         * Create static offer deactivations
         * @summary Create static offer deactivations
         * @param {StaticOfferDeactivationApiCreateStaticOfferDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferDeactivation: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createStaticOfferDeactivation(requestParameters.staticOfferDeactivationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a static offer deactivation
         * @summary Delete a static offer deactivation
         * @param {StaticOfferDeactivationApiDeleteStaticOfferDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferDeactivation: function (requestParameters, options) {
            return localVarFp.deleteStaticOfferDeactivation(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return static offer deactivations based upon request parameters
         * @summary Get static offer deactivations
         * @param {StaticOfferDeactivationApiGetStaticOfferDeactivationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferDeactivations: function (requestParameters, options) {
            return localVarFp.getStaticOfferDeactivations(requestParameters.limit, requestParameters.id, requestParameters.offerId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StaticOfferDeactivationApiFactory = StaticOfferDeactivationApiFactory;
/**
 * StaticOfferDeactivationApi - object-oriented interface
 * @export
 * @class StaticOfferDeactivationApi
 * @extends {BaseAPI}
 */
var StaticOfferDeactivationApi = /** @class */ (function (_super) {
    __extends(StaticOfferDeactivationApi, _super);
    function StaticOfferDeactivationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create static offer deactivations
     * @summary Create static offer deactivations
     * @param {StaticOfferDeactivationApiCreateStaticOfferDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferDeactivationApi
     */
    StaticOfferDeactivationApi.prototype.createStaticOfferDeactivation = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StaticOfferDeactivationApiFp)(this.configuration).createStaticOfferDeactivation(requestParameters.staticOfferDeactivationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a static offer deactivation
     * @summary Delete a static offer deactivation
     * @param {StaticOfferDeactivationApiDeleteStaticOfferDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferDeactivationApi
     */
    StaticOfferDeactivationApi.prototype.deleteStaticOfferDeactivation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferDeactivationApiFp)(this.configuration).deleteStaticOfferDeactivation(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return static offer deactivations based upon request parameters
     * @summary Get static offer deactivations
     * @param {StaticOfferDeactivationApiGetStaticOfferDeactivationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferDeactivationApi
     */
    StaticOfferDeactivationApi.prototype.getStaticOfferDeactivations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferDeactivationApiFp)(this.configuration).getStaticOfferDeactivations(requestParameters.limit, requestParameters.id, requestParameters.offerId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StaticOfferDeactivationApi;
}(base_1.BaseAPI));
exports.StaticOfferDeactivationApi = StaticOfferDeactivationApi;
/**
 * SupplyDemandSubAccountRequestsApi - axios parameter creator
 * @export
 */
var SupplyDemandSubAccountRequestsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get count of requests for a supply demand sub-account pair by day
         * @summary Get count of requests for a supply demand sub-account pair by day
         * @param {SubAccountAttributionSummaryCalculationRequest} [subAccountAttributionSummaryCalculationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSupplyDemandSubAccountRequestCounts: function (subAccountAttributionSummaryCalculationRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([subAccountAttributionSummaryCalculationRequest_1], args_1, true), void 0, function (subAccountAttributionSummaryCalculationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/summaries/supplyDemandSubAccountRequests";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:rateTables:read", "originator:rate_table:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subAccountAttributionSummaryCalculationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplyDemandSubAccountRequestsApiAxiosParamCreator = SupplyDemandSubAccountRequestsApiAxiosParamCreator;
/**
 * SupplyDemandSubAccountRequestsApi - functional programming interface
 * @export
 */
var SupplyDemandSubAccountRequestsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplyDemandSubAccountRequestsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get count of requests for a supply demand sub-account pair by day
         * @summary Get count of requests for a supply demand sub-account pair by day
         * @param {SubAccountAttributionSummaryCalculationRequest} [subAccountAttributionSummaryCalculationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSupplyDemandSubAccountRequestCounts: function (subAccountAttributionSummaryCalculationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestSupplyDemandSubAccountRequestCounts(subAccountAttributionSummaryCalculationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountRequestsApi.requestSupplyDemandSubAccountRequestCounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplyDemandSubAccountRequestsApiFp = SupplyDemandSubAccountRequestsApiFp;
/**
 * SupplyDemandSubAccountRequestsApi - factory interface
 * @export
 */
var SupplyDemandSubAccountRequestsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplyDemandSubAccountRequestsApiFp)(configuration);
    return {
        /**
         * Get count of requests for a supply demand sub-account pair by day
         * @summary Get count of requests for a supply demand sub-account pair by day
         * @param {SupplyDemandSubAccountRequestsApiRequestSupplyDemandSubAccountRequestCountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSupplyDemandSubAccountRequestCounts: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.requestSupplyDemandSubAccountRequestCounts(requestParameters.subAccountAttributionSummaryCalculationRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplyDemandSubAccountRequestsApiFactory = SupplyDemandSubAccountRequestsApiFactory;
/**
 * SupplyDemandSubAccountRequestsApi - object-oriented interface
 * @export
 * @class SupplyDemandSubAccountRequestsApi
 * @extends {BaseAPI}
 */
var SupplyDemandSubAccountRequestsApi = /** @class */ (function (_super) {
    __extends(SupplyDemandSubAccountRequestsApi, _super);
    function SupplyDemandSubAccountRequestsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get count of requests for a supply demand sub-account pair by day
     * @summary Get count of requests for a supply demand sub-account pair by day
     * @param {SupplyDemandSubAccountRequestsApiRequestSupplyDemandSubAccountRequestCountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountRequestsApi
     */
    SupplyDemandSubAccountRequestsApi.prototype.requestSupplyDemandSubAccountRequestCounts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyDemandSubAccountRequestsApiFp)(this.configuration).requestSupplyDemandSubAccountRequestCounts(requestParameters.subAccountAttributionSummaryCalculationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplyDemandSubAccountRequestsApi;
}(base_1.BaseAPI));
exports.SupplyDemandSubAccountRequestsApi = SupplyDemandSubAccountRequestsApi;
/**
 * SupplyTemplateApi - axios parameter creator
 * @export
 */
var SupplyTemplateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create supply template
         * @summary Create supply template
         * @param {SupplyTemplateCreateData} [supplyTemplateCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplate: function (supplyTemplateCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyTemplateCreateData_1], args_1, true), void 0, function (supplyTemplateCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyTemplates";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyTemplateCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create supply template application
         * @summary Create supply template application
         * @param {SupplyTemplateApplicationCreateData} [supplyTemplateApplicationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateApplication: function (supplyTemplateApplicationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyTemplateApplicationCreateData_1], args_1, true), void 0, function (supplyTemplateApplicationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyTemplateApplications";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyTemplateApplicationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add demand sub-account to supply template
         * @summary Add demand sub-account to supply template
         * @param {SupplyTemplateDemandSubAccountCreateData} [supplyTemplateDemandSubAccountCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateDemandSubAccount: function (supplyTemplateDemandSubAccountCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyTemplateDemandSubAccountCreateData_1], args_1, true), void 0, function (supplyTemplateDemandSubAccountCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyTemplateDemandSubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyTemplateDemandSubAccountCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add offer to supply template
         * @summary Add offer to supply template
         * @param {SupplyTemplateOfferCreateData} [supplyTemplateOfferCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateOffer: function (supplyTemplateOfferCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyTemplateOfferCreateData_1], args_1, true), void 0, function (supplyTemplateOfferCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyTemplateOffers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyTemplateOfferCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deactivates a supply template
         * @summary Deactivates a supply template
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateSupplyTemplate: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deactivateSupplyTemplate', 'id', id);
                            localVarPath = "/supplyTemplates/deactivate/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Remove demand sub-account from supply template
         * @summary Remove demand sub-account from supply template
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyTemplateDemandSubAccount: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyTemplateDemandSubAccount', 'id', id);
                            localVarPath = "/supplyTemplateDemandSubAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Remove offer from supply template
         * @summary Remove offer from supply template
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyTemplateOffer: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyTemplateOffer', 'id', id);
                            localVarPath = "/supplyTemplateOffers/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get supply template applications
         * @summary Get supply template applications
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [supplyTemplateId]
         * @param {Array<number>} [supplySubAccountId]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyTemplateApplications: function (limit_1, id_1, supplyTemplateId_1, supplySubAccountId_1, offset_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, supplyTemplateId_1, supplySubAccountId_1, offset_1], args_1, true), void 0, function (limit, id, supplyTemplateId, supplySubAccountId, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyTemplateApplications', 'limit', limit);
                            localVarPath = "/supplyTemplateApplications";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (supplyTemplateId) {
                                localVarQueryParameter['supplyTemplateId'] = supplyTemplateId;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get supply templates
         * @summary Get supply templates
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<AccountTierType>} [tier]
         * @param {Array<SupplyTemplateProductType>} [productType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyTemplates: function (limit_1, id_1, uuid_1, tier_1, productType_1, offset_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, tier_1, productType_1, offset_1], args_1, true), void 0, function (limit, id, uuid, tier, productType, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyTemplates', 'limit', limit);
                            localVarPath = "/supplyTemplates";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (tier) {
                                localVarQueryParameter['tier'] = tier;
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update supply template
         * @summary Update supply template
         * @param {SupplyTemplateUpdateData} [supplyTemplateUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplyTemplate: function (supplyTemplateUpdateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyTemplateUpdateData_1], args_1, true), void 0, function (supplyTemplateUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyTemplates";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["originator:admin:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyTemplateUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplyTemplateApiAxiosParamCreator = SupplyTemplateApiAxiosParamCreator;
/**
 * SupplyTemplateApi - functional programming interface
 * @export
 */
var SupplyTemplateApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplyTemplateApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create supply template
         * @summary Create supply template
         * @param {SupplyTemplateCreateData} [supplyTemplateCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplate: function (supplyTemplateCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyTemplate(supplyTemplateCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.createSupplyTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create supply template application
         * @summary Create supply template application
         * @param {SupplyTemplateApplicationCreateData} [supplyTemplateApplicationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateApplication: function (supplyTemplateApplicationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyTemplateApplication(supplyTemplateApplicationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.createSupplyTemplateApplication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add demand sub-account to supply template
         * @summary Add demand sub-account to supply template
         * @param {SupplyTemplateDemandSubAccountCreateData} [supplyTemplateDemandSubAccountCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateDemandSubAccount: function (supplyTemplateDemandSubAccountCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyTemplateDemandSubAccount(supplyTemplateDemandSubAccountCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.createSupplyTemplateDemandSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add offer to supply template
         * @summary Add offer to supply template
         * @param {SupplyTemplateOfferCreateData} [supplyTemplateOfferCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateOffer: function (supplyTemplateOfferCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyTemplateOffer(supplyTemplateOfferCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.createSupplyTemplateOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Deactivates a supply template
         * @summary Deactivates a supply template
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateSupplyTemplate: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deactivateSupplyTemplate(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.deactivateSupplyTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Remove demand sub-account from supply template
         * @summary Remove demand sub-account from supply template
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyTemplateDemandSubAccount: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyTemplateDemandSubAccount(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.deleteSupplyTemplateDemandSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Remove offer from supply template
         * @summary Remove offer from supply template
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyTemplateOffer: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyTemplateOffer(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.deleteSupplyTemplateOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get supply template applications
         * @summary Get supply template applications
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [supplyTemplateId]
         * @param {Array<number>} [supplySubAccountId]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyTemplateApplications: function (limit, id, supplyTemplateId, supplySubAccountId, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyTemplateApplications(limit, id, supplyTemplateId, supplySubAccountId, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.getSupplyTemplateApplications']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get supply templates
         * @summary Get supply templates
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<AccountTierType>} [tier]
         * @param {Array<SupplyTemplateProductType>} [productType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyTemplates: function (limit, id, uuid, tier, productType, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyTemplates(limit, id, uuid, tier, productType, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.getSupplyTemplates']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update supply template
         * @summary Update supply template
         * @param {SupplyTemplateUpdateData} [supplyTemplateUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplyTemplate: function (supplyTemplateUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSupplyTemplate(supplyTemplateUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyTemplateApi.updateSupplyTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplyTemplateApiFp = SupplyTemplateApiFp;
/**
 * SupplyTemplateApi - factory interface
 * @export
 */
var SupplyTemplateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplyTemplateApiFp)(configuration);
    return {
        /**
         * Create supply template
         * @summary Create supply template
         * @param {SupplyTemplateApiCreateSupplyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplate: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplyTemplate(requestParameters.supplyTemplateCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create supply template application
         * @summary Create supply template application
         * @param {SupplyTemplateApiCreateSupplyTemplateApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateApplication: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplyTemplateApplication(requestParameters.supplyTemplateApplicationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add demand sub-account to supply template
         * @summary Add demand sub-account to supply template
         * @param {SupplyTemplateApiCreateSupplyTemplateDemandSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateDemandSubAccount: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplyTemplateDemandSubAccount(requestParameters.supplyTemplateDemandSubAccountCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add offer to supply template
         * @summary Add offer to supply template
         * @param {SupplyTemplateApiCreateSupplyTemplateOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyTemplateOffer: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplyTemplateOffer(requestParameters.supplyTemplateOfferCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deactivates a supply template
         * @summary Deactivates a supply template
         * @param {SupplyTemplateApiDeactivateSupplyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateSupplyTemplate: function (requestParameters, options) {
            return localVarFp.deactivateSupplyTemplate(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Remove demand sub-account from supply template
         * @summary Remove demand sub-account from supply template
         * @param {SupplyTemplateApiDeleteSupplyTemplateDemandSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyTemplateDemandSubAccount: function (requestParameters, options) {
            return localVarFp.deleteSupplyTemplateDemandSubAccount(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Remove offer from supply template
         * @summary Remove offer from supply template
         * @param {SupplyTemplateApiDeleteSupplyTemplateOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyTemplateOffer: function (requestParameters, options) {
            return localVarFp.deleteSupplyTemplateOffer(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get supply template applications
         * @summary Get supply template applications
         * @param {SupplyTemplateApiGetSupplyTemplateApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyTemplateApplications: function (requestParameters, options) {
            return localVarFp.getSupplyTemplateApplications(requestParameters.limit, requestParameters.id, requestParameters.supplyTemplateId, requestParameters.supplySubAccountId, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get supply templates
         * @summary Get supply templates
         * @param {SupplyTemplateApiGetSupplyTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyTemplates: function (requestParameters, options) {
            return localVarFp.getSupplyTemplates(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.tier, requestParameters.productType, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update supply template
         * @summary Update supply template
         * @param {SupplyTemplateApiUpdateSupplyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplyTemplate: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.updateSupplyTemplate(requestParameters.supplyTemplateUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplyTemplateApiFactory = SupplyTemplateApiFactory;
/**
 * SupplyTemplateApi - object-oriented interface
 * @export
 * @class SupplyTemplateApi
 * @extends {BaseAPI}
 */
var SupplyTemplateApi = /** @class */ (function (_super) {
    __extends(SupplyTemplateApi, _super);
    function SupplyTemplateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create supply template
     * @summary Create supply template
     * @param {SupplyTemplateApiCreateSupplyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.createSupplyTemplate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyTemplateApiFp)(this.configuration).createSupplyTemplate(requestParameters.supplyTemplateCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create supply template application
     * @summary Create supply template application
     * @param {SupplyTemplateApiCreateSupplyTemplateApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.createSupplyTemplateApplication = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyTemplateApiFp)(this.configuration).createSupplyTemplateApplication(requestParameters.supplyTemplateApplicationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add demand sub-account to supply template
     * @summary Add demand sub-account to supply template
     * @param {SupplyTemplateApiCreateSupplyTemplateDemandSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.createSupplyTemplateDemandSubAccount = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyTemplateApiFp)(this.configuration).createSupplyTemplateDemandSubAccount(requestParameters.supplyTemplateDemandSubAccountCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add offer to supply template
     * @summary Add offer to supply template
     * @param {SupplyTemplateApiCreateSupplyTemplateOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.createSupplyTemplateOffer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyTemplateApiFp)(this.configuration).createSupplyTemplateOffer(requestParameters.supplyTemplateOfferCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deactivates a supply template
     * @summary Deactivates a supply template
     * @param {SupplyTemplateApiDeactivateSupplyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.deactivateSupplyTemplate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyTemplateApiFp)(this.configuration).deactivateSupplyTemplate(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Remove demand sub-account from supply template
     * @summary Remove demand sub-account from supply template
     * @param {SupplyTemplateApiDeleteSupplyTemplateDemandSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.deleteSupplyTemplateDemandSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyTemplateApiFp)(this.configuration).deleteSupplyTemplateDemandSubAccount(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Remove offer from supply template
     * @summary Remove offer from supply template
     * @param {SupplyTemplateApiDeleteSupplyTemplateOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.deleteSupplyTemplateOffer = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyTemplateApiFp)(this.configuration).deleteSupplyTemplateOffer(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get supply template applications
     * @summary Get supply template applications
     * @param {SupplyTemplateApiGetSupplyTemplateApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.getSupplyTemplateApplications = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyTemplateApiFp)(this.configuration).getSupplyTemplateApplications(requestParameters.limit, requestParameters.id, requestParameters.supplyTemplateId, requestParameters.supplySubAccountId, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get supply templates
     * @summary Get supply templates
     * @param {SupplyTemplateApiGetSupplyTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.getSupplyTemplates = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyTemplateApiFp)(this.configuration).getSupplyTemplates(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.tier, requestParameters.productType, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update supply template
     * @summary Update supply template
     * @param {SupplyTemplateApiUpdateSupplyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyTemplateApi
     */
    SupplyTemplateApi.prototype.updateSupplyTemplate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyTemplateApiFp)(this.configuration).updateSupplyTemplate(requestParameters.supplyTemplateUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplyTemplateApi;
}(base_1.BaseAPI));
exports.SupplyTemplateApi = SupplyTemplateApi;
